// The white and black (the black is really a dark grey) ['#FFFFFF,'#333333'] //
// The colors from color brewer: //
['#ffffd9','#edf8b1','#c7e9b4','#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']
// https://colorbrewer2.org/#type=sequential&scheme=YlGnBu&n=9

<template>
  <div id="haikubox" v-if="this.user != ''">
    <!-- notices -->
    <v-alert type="info" v-for="notice in userNotices" :key="notice.id">
      <v-row align="center">
        <v-col class="grow">
          {{ notice.noticeTitle }}
          {{ notice.noticeDescription }}
        </v-col>
        <v-col class="shrink">
          <v-btn @click="acknowledgeNotice(notice.id)">OK</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Nudge old wrapped-app users to the new native apps -->
    <v-alert
      type="info"
      dismissible
      :value="showNewAppNotice"
      @input="onNewAppNoticeInput"
    >
      <v-row align="center">
        <v-col cols="12" :sm="goNativeActive ? 7 : 12" class="py-1">
          <div class="font-weight-medium">
            {{ t("NewAppNoticeTitle", "The new Haikubox app is here") }}
          </div>
          <div class="caption">
            {{
              t(
                "NewAppNoticeText",
                "Get the redesigned app for iOS or Android — a faster experience with the latest features."
              )
            }}
          </div>
        </v-col>
        <!-- Store buttons only in the app; the website just spreads the word -->
        <v-col
          v-if="goNativeActive"
          cols="12"
          sm="5"
          class="py-1 d-flex align-center justify-sm-end flex-wrap"
        >
          <!-- Known platform inside the app: one button to the right store -->
          <v-btn
            v-if="showNewAppStoreButton"
            small
            outlined
            color="white"
            class="ma-1"
            @click="openNewAppStore()"
          >
            {{ t("NewAppNoticeButton", "Get It") }}
          </v-btn>
          <!-- Otherwise offer both, so they can pick their own platform -->
          <template v-else>
            <v-btn
              v-if="newAppStoreUrls.ios"
              small
              outlined
              color="white"
              class="ma-1"
              @click="openNewAppStore(newAppStoreUrls.ios)"
            >
              <v-icon left small>mdi-apple</v-icon>
              {{ t("NewAppNoticeIos", "App Store") }}
            </v-btn>
            <v-btn
              v-if="newAppStoreUrls.android"
              small
              outlined
              color="white"
              class="ma-1"
              @click="openNewAppStore(newAppStoreUrls.android)"
            >
              <v-icon left small>mdi-google-play</v-icon>
              {{ t("NewAppNoticeAndroid", "Google Play") }}
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert type="info" dismissible v-if="showRenewAlert">
      <v-row align="center">
        <v-col class="grow">
          <div>{{ t("Subscription Expired") }}</div>
          <v-btn
            text
            small
            color="white"
            href="https://listen.haikubox.com/#/settings"
            target="_blank"
            class="pa-0 mt-1"
          >
            Go to Account Webpage →
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Map -->
    <v-card
      class="mx-auto"
      max-width="100%"
      max-height="400"
      outlined
      v-if="showMap"
    >
      <div>
        <v-img height="100%" width="100%">
          <l-map
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            :bounds="bounds"
            style="height: 400px; width: 100%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            :maxZoom="maxZoomSummary"
          >
            <l-tile-layer :url="urlStates" :attribution="urlOceanAttribution" />
            <l-circle
              :key="haikuboxMarkerID"
              :lat-lng="[lat, lon]"
              :radius="currentHaikuboxRadius"
            >
            </l-circle>
            <v-marker-cluster :options="{ chunkedLoading: true }">
              <l-marker
                @click="
                  clickDevice(item, 1, false, item.shareLat, item.shareLon)
                "
                v-for="item in connectedDevices"
                :key="item.id"
                :lat-lng="[item.shareLat, item.shareLon]"
                :radius="2000"
                color="#0277BD"
              >
                <l-tooltip :options="{ permanent: true }">{{
                  item.name
                }}</l-tooltip>
              </l-marker>
            </v-marker-cluster>
          </l-map></v-img
        >
      </div>
    </v-card>

    <!-- Map Animation -->
    <!-- <v-card dark v-if="animationRunning">
      <div>
        <l-map
          style="height: 350px"
          :zoom="zoomSummary"
          :center="centerSummary"
          :maxZoom="maxZoomSummary"
        >
          <l-tile-layer :url="urlSummary" :attribution="attributionSummary" />
          <l-circle
            v-for="item in filterHourlySummary(summaryHour)"
            :key="item.id"
            :lat-lng="[item.lat, item.lon]"
            :radius="item.radius"
            :color="item.color"
          >
            <l-tooltip
              :options="{ sticky: true }"
              :content="item.name + ': ' + item.count"
            />
          </l-circle>
        </l-map>
      </div>
      <v-row>
        <v-col>
          <v-btn icon @click="startAnimation()"
            ><v-icon left>mdi-play-circle</v-icon></v-btn
          >
          <v-btn icon @click="stopAnimation()">
            <v-icon left>mdi-stop-circle</v-icon></v-btn
          >
          <v-card-text>{{ summaryHourLabel }} </v-card-text>
          <v-slider v-model="summaryHour" step="1" min="0" max="23"></v-slider> 
          <v-slider
            v-if="animationRunning == false"
            v-model="summaryHourIndex"
            step="1"
            min="0"
            max="23"
            @change="sliderSummaryHourIndex()"
          ></v-slider>
        </v-col>
        <v-col>
          <v-btn @click="toggleBasemap()">Basemap</v-btn>
          <v-btn @click="toggleColormap()"
            >Colormap {{ summaryColorMapIndex }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card> -->

    <!-- Haikubox Stats -->

    <v-card
      outlined
      height="200px"
      width="100%"
      v-if="
        (showMap == false) &
        (yesterdayCallsAndSongs == 0) &
        (showBadge == false)
      "
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground3.jpeg"
        height="100%"
        width="100%"
      >
        <v-row no-gutter>
          <v-col cols="9" class="py-1">
            <v-card-title style="word-break: break-word">
              {{ t("Welcome") }}
            </v-card-title></v-col
          >
          <v-col cols="3" class="d-flex align-center py-1">
            <v-icon dark>mdi-web</v-icon>
            <v-select
              :items="languages"
              v-model="selectedLanguage"
              @change="setLanguage(selectedLanguage)"
              dark
            ></v-select>
          </v-col>
        </v-row>
        <!-- <v-row class="mx-1"><v-col xs="4" sm="3"> </v-col></v-row> -->
      </v-img>
    </v-card>

    <v-card
      flat
      height="280px"
      width="100%"
      class="transparent px-0 mx-0 my-0 py-0"
      v-if="
        (showMap == false) & (yesterdayCallsAndSongs > 0) & (showBadge == false)
      "
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground3.jpeg"
        height="280px"
      >
        <v-row no-gutter>
          <v-col cols="9" class="py-1"
            ><v-card-title>{{ t("Yesterday") }}</v-card-title></v-col
          >
          <v-col cols="3" class="d-flex align-center py-1">
            <v-icon dark>mdi-web</v-icon>
            <v-select
              :items="languages"
              v-model="selectedLanguage"
              @change="setLanguage(selectedLanguage)"
              dark
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="mx-1"
          ><v-col xs="4" sm="4" md="3" class="py-1">
            <v-card dark color="grey" tile>
              <v-card-title class="justify-center"
                >{{ yesterdayNumSpecies }}
              </v-card-title>
              <v-card-subtitle class="text-center">{{
                t("Species")
              }}</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col xs="4" sm="4" md="3" class="py-1">
            <v-card dark color="grey" tile>
              <v-card-title class="justify-center"
                >{{ yesterdayCallsAndSongs }} </v-card-title
              ><v-card-subtitle class="text-center">
                {{ t("Calls and Songs") }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mx-1 my-2 py-4" align="center"
          ><v-col xs="8" sm="8" md="6" class="py-2">
            <v-card dark color="grey" tile>
              <v-row
                ><v-col cols="4" class="my-0">
                  <img
                    v-if="!hidePics && yesterdaySpCode"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${yesterdaySpCode}.jpeg`"
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  />
                </v-col>
                <v-col cols="7" class="py-2">
                  <v-card-title style="word-break: break-word">
                    {{
                      t(yesterdaySpCode, yesterdayMostFrequent)
                    }}</v-card-title
                  >
                  <v-card-subtitle
                    >{{ t("Most Frequent Visitor") }}
                    <!-- <v-btn
                      text
                      color="yellow"
                      @click="dailySummary()"
                      >More</v-btn
                    > -->
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-img>
    </v-card>

    <!-- Badges -->
    <v-card
      v-if="(showMap == false) & (showBadge == true)"
      height="280"
      light
      tile
      class="transparent mx-auto"
      width="100%"
      flat
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground1.jpeg"
        height="280px"
      >
        <v-card-title style="word-break: break-word">{{
          t("Progress and Badges")
        }}</v-card-title>
        <v-row style="height: 10px"></v-row>
        <v-row style="height: 20px"
          ><v-col cols="7"></v-col
          ><v-col cols="2"
            ><v-btn
              text
              class="white--text"
              height="40"
              width="40"
              v-if="totalLabeled > 0"
              >Level</v-btn
            ></v-col
          ></v-row
        >

        <v-card-text
          class="white--text text-xs-h6 text-sm-h5"
          v-if="totalLabeled == 0"
          >{{ t("Label bird detections to earn badges") }}</v-card-text
        >
        <div v-if="totalLabeled > 0">
          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabeled"
                color="amber"
                height="40"
                class="mx-2 white--text"
                >{{ t("Labeled") }}: {{ totalLabeled }} / {{ targetLabel }}
              </v-progress-linear>
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelLevel }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabelSpecies"
                color="orange"
                height="40"
                class="mx-2 my-1 white--text"
                >{{ t("Species") }}: {{ totalSpeciesLabeled }} /
                {{ targetLabelSpecies }}</v-progress-linear
              >
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelSpeciesLevel }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabelStreak"
                height="40"
                class="mx-2 white--text"
                >{{ t("Streak") }}: {{ labelStreak }} / {{ targetLabelStreak }}
                {{ t("days") }}</v-progress-linear
              >
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelStreakLevel }}
              </v-btn>
            </v-col></v-row
          >
        </div>
      </v-img>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="100%"
      outlined
      color="blue-grey darken-4"
    >
      <!-- More Active Species  -->
      <!-- <v-card
        tile
        flat
        height="338"
        width="80%"
        class="transparent mx-auto"
      >
        <v-card-title class="my-6" style="word-break: break-word"
          >Singing levels are similar as previous day</v-card-title
        >
      </v-card> -->

      <!-- <v-card
        tile
        height="338"
        class="transparent"
      >
        <v-card-title>Increasing Activity</v-card-title>
        <v-container fluid>
          <v-row dense>
            <v-col
              cols="12"
              v-for="(item, index) in moreActiveSpeciesList"
              :key="item.id"
            >
              <v-card
                outlined
                color="light-grey darken-4"
                class="mx-auto"
                dark
                height="60"
                width="80%"
                max-width="500"
              >
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar
                      class="mx-2 my-1"
                      :href="
                        isBat(item)
                          ? 'https://www.batcon.org/about-bats/bats-101/'
                          : item.lon > -30
                          ? 'https://ebird.org/species/' + item.spCode
                          : 'https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn)
                      "
                      target="_blank"
                    >
                      <img
                    v-if="!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                    @error="
                      if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                    "
                  /></v-avatar>
                  </v-col>
                  <v-col cols="6"> {{ item.cn }} </v-col>
                  <v-col cols="3">
                    <v-btn
                      icon
                      @click="
                        getWavFileName(
                          index,
                          item.spCode,
                          item.cn,
                          'Increasing',
                          'play',
                          ''
                        )
                      "
                    >
                      <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card> -->

      <!-- Header Info Section -->
      <v-row v-if="currentWiFi === 0 && isOwner">
        <v-col cols="12">
          <v-card dark class="px-2">
            <v-card-title style="word-break: break-word">
              {{ t("No WiFi") }}
            </v-card-title>
            <v-card-text class="my-0 py=0">{{ t("WiFi Step 1") }}</v-card-text>
            <v-card-text class="my-0 py=0">{{ t("WiFi Step 2") }}</v-card-text>
            <v-btn class="mx-2 my-2" @click="checkConnection(currentSerial)"
              >Check Connection</v-btn
            >
            <v-card-subtitle v-if="checkConnectionFailed"
              >{{ t("WiFi Check") }}
              {{ currentSerial }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" class="my-1 py-0">
          <v-card-title
            class="white--text text-no-wrap"
            style="word-break: break-word"
            v-if="haikuboxLoaded == 1"
          >
            <v-btn
              v-if="isOwner == true"
              color="white"
              icon
              aria-hidden="true"
              tabindex="-1"
            >
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn
              v-if="
                (currentHaikuboxBookmark == false) &
                (isOwner == false) &
                (currentSiteName != '')
              "
              icon
              color="pink"
              @click="toggleHaikuboxBookmark()"
              v-tooltip.bottom-start="'Bookmark this Haikubox'"
            >
              <v-icon alt="bookmark">mdi-bookmark-multiple-outline</v-icon>
            </v-btn>
            <v-btn
              v-if="(currentHaikuboxBookmark == true) & (isOwner == false)"
              icon
              color="pink"
              @click="toggleHaikuboxBookmark()"
              v-tooltip.bottom-start="'Un-Bookmark this Haikubox'"
            >
              <v-icon alt="bookmark">mdi-bookmark-multiple</v-icon>
            </v-btn>
            {{ currentSiteName }}
          </v-card-title>
        </v-col>

        <v-col cols="2" class="my-1 d-flex justify-end" v-if="isOwner">
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -60 && currentWiFi != 0"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-3</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -74 && currentWiFi < -60"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-2</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -78 && currentWiFi < -74"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-1</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi < -78"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-outline</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-row class="py-0 my-0">
        <v-col cols="12" class="py-0 my-0 px-10 d-flex justify-end">
          <!-- New Bird Alert -->
          <v-switch
            v-if="
              isOwner &
              goNativeActive &
              (currentView == 'Recent') &
              subscriptionActive
            "
            v-model="newBirdAlert"
            :label="t('New Bird Alerts')"
            @change="toggleNewBirdAlert(newBirdAlert)"
            dark
            color="info"
          ></v-switch> </v-col
      ></v-row>

      <!-- User window with App Bar -->
      <v-app-bar
        color="blue-grey darken-4"
        dark
        dense
        flat
        height="80px"
        v-if="
          ((devicesByOwner.length > 1) |
            ((devicesByOwner.length >= 0) & (bookmarkedDevices.length > 0))) &
          !showMap
        "
      >
        <v-select
          v-if="
            (devicesByOwner.length > 1) |
              ((devicesByOwner.length >= 0) & (bookmarkedDevices.length > 0))
          "
          v-model="haikuboxSelect"
          :items="devicesByOwner"
          item-text="name"
          item-value="serial"
          return-object
          @input="ownerSelectDevice()"
          dark
          class="mx-4"
          :label="t('Your Haikuboxes')"
        ></v-select>
        <v-select
          v-if="bookmarkedDevices.length > 0"
          v-model="bookmarkSelect"
          :items="bookmarkedDevices"
          item-text="name"
          item-value="id"
          return-object
          @input="bookmarkSelectDevice()"
          dark
          class="mx-4"
          :label="t('Bookmarks')"
        ></v-select>
      </v-app-bar>

      <!-- New Badges Alert -->
      <!-- <v-snackbar v-model="newLabelBadge" centered>
        You reached a labeling milestone! Thank you for helping make Haikubox
        better.
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <!-- <v-snackbar v-model="newLabelSpeciesBadge" centered>
        Species labeling milestone reached!
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelSpeciesBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <!-- <v-snackbar v-model="newLabelStreakBadge" centered>
        Fantastic! New labeling streak!
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelStreakBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <v-snackbar v-model="notifyBirdInfo" centered :timeout="60000">
        <v-icon>mdi-account</v-icon>
        {{ t("Notify Auth") }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="notifyBirdInfo = false"
          >
            No
          </v-btn>
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="grantOneSignalPrivacyConsent()"
          >
            Yes
          </v-btn>
        </template>
      </v-snackbar>

      <v-row
        ><v-col cols="6" class="white--text my-0 py-0 mx-4">
          <!-- Header for page viewing (Recent, All) -->
          <!-- Main Navigation Dropdown -->
          <v-select
            v-model="navSelection"
            :items="navList"
            item-text="text"
            item-value="id"
            return-object
            @input="changeView()"
            dark
            class="mx-4"
            :label="t('View')"
            ><template v-slot:item="{ item }">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template></v-select
          > </v-col
        ><v-col cols="5">
          <v-btn color="yellow" plain v-if="hitsLoading > 0">
            {{ t("Loading") }} {{ hitsLoading }}</v-btn
          >

          <!-- Calendar Picker -->
          <v-btn
            fab
            small
            v-if="
              (currentView === 'Recent') &
              (hitsLoading == 0) &
              isOwner &
              subscriptionActive &
              !hidePics
            "
            class="pa-1 ma-1"
            :color="recentHours == 0 ? 'blue lighten-2' : 'grey'"
            @click="hitSelectDate()"
            ><v-icon alt="calendar">mdi-calendar</v-icon>
          </v-btn>

          <!-- Volume Control -->
          <!-- <v-slider
            dark
            v-if="(hitsLoading == 0) & (!hidePics)"
            color="grey"
            class="px-2"
            v-model="playbackGain"
            prepend-icon="mdi-volume-high"
            prepend-icon-color="grey"
            min="50"
            max="200"
          ></v-slider>  -->
        </v-col></v-row
      >

      <template v-if="hitCalendarDatePicked == false">
        <v-row justify="center">
          <v-date-picker
            v-model="hitDatePicker"
            :min="minDate"
            :max="maxDate"
            @change="hitDateClick()"
          ></v-date-picker>
        </v-row>
      </template>

      <v-card-title
        v-if="currentView == 'Daily Summary'"
        class="grey--text my-0 py-0 subtitle-1"
        >{{ dailySummaryDate }}</v-card-title
      >
      <v-card-title
        v-if="(currentView == 'Recent') | (currentView == 'Live')"
        class="grey--text my-0 py-0 subtitle-1"
      >
        <div v-if="recentHours != 0">{{ lastUpdated }}</div>
        <div v-if="recentHours == 0">{{ hitDatePicker }}</div>

        <!-- Refresh Button -->
        <v-btn
          v-if="(currentView === 'Recent') & (hitsLoading == 0) & isOwner"
          icon
          color="grey"
          @click="clickRefresh(currentSerial)"
          aria-label="Refresh"
        >
          <v-icon alt="refresh">mdi-refresh</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <!-- Buttons to control viewSettings confidence level for Recent -->
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'Low' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('Low')"
          >{{ t("Low") }}
        </v-btn>
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'Medium' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('Medium')"
          >{{ t("Med") }}
        </v-btn>
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'High' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('High')"
          >{{ t("High") }}
        </v-btn>
        <v-dialog
          width="300"
          v-if="(currentView === 'Recent') | (currentView === 'Live')"
        >
          <template v-slot:activator="{ on, attrs }" v-if="!hidePics">
            <v-btn
              icon
              color="yellow"
              v-bind="attrs"
              v-on="on"
              class="my-6 mx-3"
            >
              <v-icon alt="info">mdi-information</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ t("View Settings") }}
            </v-card-title>
            <v-card-text>
              <v-list-item
                ><v-list-item-content>
                  {{ t("View Info") }}
                </v-list-item-content></v-list-item
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-title>

      <!-- Recent -->
      <!-- Share dialog outside of for loop -->
      <v-dialog v-model="shareDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h5 blue lighten-1 white--text">
            {{ t("Share") }}
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile class="white--text" text @click="shareDialog = false">
                {{ t("Close") }}
              </v-btn>
            </v-card-actions>
          </v-card-title>

          <!-- <v-btn
            v-if="goNativeActive == false"
            class="mx-2 my-4"
            color="primary"
            fab
            medium
            dark
            v-tooltip.bottom-start="'Download File'"
            :href="downloadLink"
            ><v-icon alt="download">mdi-download</v-icon>
          </v-btn> -->

          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="9">
              <v-text-field
                class="mx-2 my-6"
                :value="audioLink"
                readonly
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn @click="copyLink()" class="my-8">Copy</v-btn>
              <v-snackbar
                absolute
                shaped
                color="success"
                v-model="copyLinkSnackbar"
                :timeout="1000"
                icon="check_circle"
              >
                <v-icon>mdi-check</v-icon>
                {{ t("Copied") }}
              </v-snackbar>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Recent card loop -->
      <v-container v-if="currentView == 'Recent'">
        <v-row dense>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            v-for="(item, index) in hits"
            :key="item.id"
          >
            <v-card
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              style="word-break: break-word"
              dark
            >
              <div
                v-if="hidePics"
                tabindex="0"
                :aria-label="t(item.spCode, item.cn)"
              >
                {{ t(item.spCode, item.cn) }}
              </div>

              <v-card-title v-if="!hidePics">{{
                t(item.spCode, item.cn)
              }}</v-card-title>
              <v-card-subtitle class="font-italic" v-if="!hidePics">{{
                item.sn
              }}</v-card-subtitle>

              <v-row justify="end" class="px-8 my-0">
                <v-switch
                  v-if="isOwner & goNativeActive & subscriptionActive"
                  dense
                  class="mr-5 py-0"
                  v-model="item.notifyBird"
                  v-tooltip.bottom-start="
                    'Send notification when this species is detected'
                  "
                  label="Notify"
                  @change="
                    toggleNotifyBird(item.cn, item.spCode, item.notifyBird)
                  "
                  color="info"
                ></v-switch>

                <v-switch
                  dense
                  class="py-0"
                  v-if="isOwner"
                  v-model="item.showBird"
                  v-tooltip.bottom-start="
                    'Turning Show OFF will hide this species on M and H setting'
                  "
                  :label="t('Show')"
                  @change="toggleShowBird(item.cn, item.spCode, item.showBird)"
                  color="info"
                ></v-switch>
              </v-row>

              <!-- Recent Image -->
              <v-card-subtitle class="py-0">
                <img
                  width="100%"
                  v-if="(item.window == 'image') & !hidePics"
                  :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                  @error="
                    if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                  "
                />

                <!-- Recent 24 Hour Donut Chart -->
                <div v-if="item.window == 'daily'">
                  <fusioncharts
                    type="doughnut2d"
                    width="100%"
                    height="240"
                    dataFormat="json"
                    :dataSource="item.hourlyCountPlotData"
                  >
                  </fusioncharts>
                </div>
                <!-- Recent 14 day heat map -->
                <div v-if="item.window == 'heatmap'">
                  <Plotly
                    :data="item.heatmap"
                    :display-mode-bar="false"
                    :layout="plotlyLayoutHeatmap"
                  ></Plotly>
                </div>

                <!-- Recent Daily Time Series -->
                <div v-if="item.window == 'monthly'">
                  <v-card-text class="ma-3"
                    ><v-icon>mdi-music-note</v-icon>
                    Past 3 Months

                    <!-- <span
                      class="font-weight-white"
                      v-text="getDailySpeciesCount(item.cn)"
                    ></span> -->
                  </v-card-text>
                  <column-chart
                    :colors="['#90A4AE']"
                    :height="300"
                    :library="{
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                      },
                    }"
                    :data="item.dailyCountPlotData"
                  ></column-chart>
                </div>

                <!-- Recent Spectrogram -->
                <div
                  v-if="item.window == 'spectrogram'"
                  class="spectrogram-container"
                >
                  <div v-if="item.spectrogram" style="position: relative">
                    <!-- Frequency label above spectrogram -->
                    <div
                      v-if="item.maxFreqKHz"
                      style="position: absolute; left: 2px; top: -18px; z-index: 10;"
                      class="text-caption grey--text"
                    >
                      {{ item.maxFreqKHz }} kHz
                    </div>
                    <Plotly
                      :data="item.spectrogram"
                      :layout="plotlyLayout"
                      :display-mode-bar="false"
                    ></Plotly>
                    <!-- Loading overlay -->
                    <div
                      v-if="item.loadingSpectrogram"
                      class="spectrogram-loading-overlay"
                    >
                      <v-progress-circular
                        indeterminate
                        color="yellow"
                      ></v-progress-circular>
                      <div class="mt-2 white--text">Updating...</div>
                    </div>
                    <!-- Progress bar here, above the time labels -->
                    <div
                      v-if="item.isPlaying && item.playbackProgress >= 0"
                      class="spectrogram-progress-bar"
                      :style="{ width: item.playbackProgress + '%' }"
                    ></div>
                    <v-row no-gutters>
                      <v-col cols="2" class="text-caption">{{
                        item.windowStart
                          ? item.windowStart.toFixed(1) + "s"
                          : "0s"
                      }}</v-col>
                      <v-col cols="8" class="text-center">
                        <span
                          v-if="item.isPlaying"
                          class="yellow--text text-caption playing-indicator"
                          >▶ Playing...</span
                        >
                      </v-col>
                      <v-col cols="2" class="d-flex justify-end text-caption">{{
                        item.windowEnd
                          ? item.windowEnd.toFixed(1) + "s"
                          : clipSeconds + "s"
                      }}</v-col>
                    </v-row>
                  </div>
                  <div
                    v-else-if="item.loadingSpectrogram"
                    class="text-center pa-4"
                    style="height: 300px"
                  >
                    <v-progress-circular
                      indeterminate
                      color="blue"
                    ></v-progress-circular>
                    <div class="mt-2 white--text">
                      Generating spectrogram...
                    </div>
                  </div>
                  <div v-else class="text-center pa-4">
                    <v-icon size="64" color="grey">mdi-chart-bubble</v-icon>
                    <div class="mt-2 grey--text">No spectrogram available</div>
                  </div>
                </div>

                <!-- Recent Map -->
                <div v-if="item.window == 'map'">
                  <l-map
                    :center="center"
                    :options="hitMapOptions"
                    :bounds="bounds"
                    style="height: 240px; width: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    :zoomControl="false"
                    :zoom="zoom"
                    :maxZoom="maxZoomHitMap"
                  >
                    <l-tile-layer
                      :url="urlStates"
                      :attribution="attributionSummary"
                    />
                    <l-circle
                      v-for="countPerHaikubox in item.map"
                      :key="countPerHaikubox.id"
                      :lat-lng="[countPerHaikubox.lat, countPerHaikubox.lon]"
                      :radius="countPerHaikubox.radius"
                      color="#0277BD"
                      fillColor="#039BE5"
                    />
                  </l-map>
                </div>
              </v-card-subtitle>

              <v-row class="my-0 py-0">
                <v-card-text class="my-0 py-0">
                  <v-btn
                    text
                    v-if="isBat(item)"
                    @click="
                      navigateTo('https://www.batcon.org/about-bats/bats-101/')
                    "
                    color="light-blue"
                    >BCI</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item) && item.lon < -30"
                    @click="
                      navigateTo(
                        'https://www.allaboutbirds.org/guide/' +
                          replaceSpaces(item.cn)
                      )
                    "
                    color="light-blue"
                    >{{ t("About") }}</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item)"
                    @click="
                      navigateTo('https://ebird.org/species/' + item.spCode)
                    "
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>

                <v-spacer></v-spacer>
              </v-row>

              <!-- Recent Navigation -->
              <!-- Icons take their own width, so a longer translated Share label
                   still fits beside them; it only wraps on a narrow card. -->
              <v-row class="mb-1" no-gutters align="center" v-if="!hidePics">
                <v-col cols="auto">
                  <v-avatar
                    class="ml-4"
                    size="24"
                    v-tooltip.bottom-start="t('Image')"
                    @click="
                      setWindowRecent(index, 'image', item.spCode, item.cn)
                    "
                  >
                    <img
                      :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                      :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                      @error="
                        if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                      "
                    />
                  </v-avatar>

                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Hourly Chart')"
                    @click="
                      setWindowRecent(index, 'daily', item.spCode, item.cn)
                    "
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="hourly chart">mdi-chart-donut</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Daily Chart')"
                    @click="
                      setWindowRecent(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-bar</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Heat Map')"
                    @click="
                      setWindowRecent(index, 'heatmap', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="heat map">mdi-checkerboard</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Map')"
                    @click="setWindowRecent(index, 'map', item.spCode, item.cn)"
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="map">mdi-earth</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Spectrogram')"
                    @click="
                      spectrogram(index, item.currentWav['filename'], 'Recent')
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn>
                </v-col>

                <v-spacer></v-spacer>

                <v-btn
                  v-tooltip.bottom-start="t('Share sound')"
                  @click="
                    shareLink(item.spCode, item.cn, item.currentWav['filename'])
                  "
                  color="light-blue darken-1"
                  @click.stop="shareDialog = true"
                  v-if="
                    isOwner || user === '9042f396-b3f9-49ec-b398-6c35bb29886a'
                  "
                  class="ml-0 mr-2"
                  >{{ t("Share") }}
                </v-btn>
              </v-row>

              <!-- Recent Play -->
              <div>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="mx-1 my-1"
                        @click="
                          item.isPlaying && !item.isPlayingEnhance ? stopPlayback() : playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            false
                          )
                        "
                        :color="
                          item.isPlaying && !item.isPlayingEnhance ? 'orange' : 'light-blue darken-1'
                        "
                        :disabled="item.isPlayingEnhance"
                      >
                        <v-icon left>{{
                          item.isPlaying && !item.isPlayingEnhance ? "mdi-stop" : "mdi-play-circle"
                        }}</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Play") }}
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        @click="
                          item.isPlayingEnhance ? stopPlayback() : playFileEnhance(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item.id,
                            item
                          )
                        "
                        :color="item.isPlayingEnhance ? 'orange' : 'light-blue darken-1'"
                        :disabled="item.isPlaying && !item.isPlayingEnhance"
                      >
                        <v-icon left>{{ item.isPlayingEnhance ? 'mdi-stop' : 'mdi-play-circle' }}</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ item.cn === 'Bat' ? 'Pitch Shift' : t("Enhance") }}
                      </v-btn>

                      <!-- Clip length controls (not for bat files - they play full duration) -->
                      <v-chip
                        v-if="subscriptionActive && maxClipSeconds > 3 && isLongClipFile(item)"
                        class="mx-2"
                        small
                        color="light-blue darken-1"
                      >
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(-3)"
                          :disabled="clipSeconds <= 3"
                          class="mr-1"
                        >
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        {{ clipSeconds }}s
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(3)"
                          :disabled="clipSeconds >= maxClipSeconds"
                          class="ml-1"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </v-chip>
                    </v-col>

                    <v-col cols="12">
                      <v-select
                        class="mx-2 my-0 py-0"
                        :items="item.wavList"
                        v-model="item.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          if (item.cn === 'Bat' && item.window === 'spectrogram') {
                            spectrogram(index, item.currentWav['filename'], 'Recent');
                          } else {
                            playFile(
                              item.currentWav['filename'],
                              item.spCode,
                              item.cn,
                              item,
                              index,
                              true
                            );
                          }
                        "
                        return-object
                        single-line
                      >
                        <template v-slot:selection="{ item: wav }">
                          {{ wav.listname }}
                        </template>
                        <template v-slot:item="{ item: wav }">
                          {{ wav.listname }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-card-actions>

                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row align="center" justify="center" no-gutter>
                    <v-col cols="12">
                      <v-btn
                        v-if="isOwner & subscriptionActive"
                        class="mx-1 my-0"
                        @click="favoriteHit(item)"
                        color="light-blue darken-1"
                      >
                        <v-icon left>{{
                          item.favoriteHit ? "mdi-star" : "mdi-star-outline"
                        }}</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Favorite") }}
                      </v-btn>
                      <v-btn
                        v-if="
                          (goNativeActive == false) &
                          isOwner &
                          subscriptionActive
                        "
                        class="mx-2 my-0"
                        color="light-blue darken-1"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(item)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>

                <!-- Recent Label -->
                <v-row no-gutters v-if="isOwner & !hidePics"
                  ><v-col cols="10">
                    <v-overflow-btn
                      class="mx-3 my-2"
                      v-if="item.wav"
                      @change="labelHit(index, item)"
                      :items="dropdown_class"
                      :background-color="
                        item.classLabel != null
                          ? 'light-blue darken-4'
                          : 'light-blue darken-1'
                      "
                      :label="labelText(item.spCode, item.cn)"
                      :aria-label="labelText(item.spCode, item.cn)"
                      target="#label_sound"
                      v-model="item.classLabel"
                    ></v-overflow-btn>

                    <v-text-field
                      v-if="item.showEntryBox == true"
                      counter="50"
                      maxlength="50"
                      v-model="item.tellUsMore"
                      :placeholder="t('What is this sound?')"
                      :label="t('This sound is a:')"
                      outlined
                      :hint="item.submitted == true ? t('Submitted') : ''"
                      persistent-hint
                    >
                    </v-text-field>

                    <v-btn
                      v-if="item.showSubmitBox == true"
                      @click="labelHitCustom(index, item)"
                      class="ma-2"
                      color="light-blue darken-1"
                      >{{ t("Submit") }}</v-btn
                    >
                  </v-col>
                  <v-col cols="2">
                    <v-dialog width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="my-6 mx-3"
                          v-if="!hidePics"
                        >
                          <v-icon alt=" labeling information"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          {{ t("About Labeling") }}
                        </v-card-title>

                        <v-card-text>
                          {{ t("Label Info") }}
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Live Detections -->
      <v-container fluid v-if="currentView == 'Live'">
        <v-row dense>
          <v-col cols="12" v-for="item in liveHits" :key="item.id">
            <v-card outlined tile color="black" dark>
              <v-row align="center">
                <v-col cols="3" align="center">
                  <img
                    v-if="!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                    @error="
                      if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                    "
                  />
                </v-col>

                <v-col cols="3">
                  {{ t(item.spCode, item.cn) }}
                  <v-card-text class="my-0 py-0">
                    <v-btn
                      v-if="isBat(item) && !goNativeActive"
                      text
                      @click="
                        navigateTo('https://www.batcon.org/about-bats/bats-101/')
                      "
                      color="light-blue"
                      >BCI</v-btn
                    >
                    <v-btn
                      v-if="!isBat(item) && !goNativeActive"
                      text
                      @click="
                        navigateTo('https://ebird.org/species/' + item.spCode)
                      "
                      color="light-blue"
                      >eBird</v-btn
                    >
                  </v-card-text>
                </v-col>

                <v-col cols="3" align="right"> {{ getEventText(item) }} </v-col>
                <v-col cols="3" align="center">
                  <v-btn
                    icon
                    v-tooltip.bottom-start="t('Play')"
                    @click="
                      playFile(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item,
                        null,
                        false
                      )
                    "
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-1"
                    v-tooltip.bottom-start="item.cn === 'Bat' ? 'Pitch Shift' : t('Enhance')"
                    @click="
                      playFileEnhance(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item.id,
                        item
                      )
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!-- <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div> -->
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-card-title class="white--text">Past Hour</v-card-title>
          <v-col
            cols="12"
            v-for="(item, index2) in allHits.slice(0, 100)"
            :key="item.id"
          >
            <v-card dark tile color="#385F73">
              <v-row dense align="center">
                <v-col cols="3" align="center">
                  <img
                    v-if="!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                    @error="
                      if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                    "
                  />
                </v-col>
                <v-col cols="3" align="left">
                  {{ index2 + 1 }}. {{ t(item.spCode, item.cn) }}
                  <v-card-text class="my-0 py-0">
                    <v-btn
                      v-if="isBat(item) && !goNativeActive"
                      text
                      @click="
                        navigateTo('https://www.batcon.org/about-bats/bats-101/')
                      "
                      color="light-blue"
                      >BCI</v-btn
                    >
                    <v-btn
                      v-if="!isBat(item) && (item.lon < -30) & !goNativeActive"
                      text
                      @click="
                        navigateTo('https://ebird.org/species/' + item.spCode)
                      "
                      color="light-blue"
                      >eBird</v-btn
                    >
                  </v-card-text>
                </v-col>
                <v-col cols="3" align="right">
                  {{ getEventText(item) }}
                </v-col>
                <v-col cols="3" align="center">
                  <v-btn
                    icon
                    v-tooltip.bottom-start="t('Play')"
                    v-if="item.wav"
                    @click="
                      playFile(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item,
                        null,
                        false
                      )
                    "
                    ><v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    v-tooltip.bottom-start="item.cn === 'Bat' ? 'Pitch Shift' : t('Enhance')"
                    class="mx-1"
                    @click="
                      playFileEnhance(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item.id,
                        item
                      )
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- All -->
      <v-container v-if="currentView == 'All'" fluid>
        <template>
          <v-row>
            <v-col class="text-left mx-5">
              <v-autocomplete
                dark
                :items="allSpeciesList"
                :label="t('Select Species')"
                v-model="speciesSelected"
                @change="selectSpecies(speciesSelected)"
                auto-select-first
              ></v-autocomplete>
            </v-col>
            <v-dialog v-model="csvDialog" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-col class="text-right">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    {{ t("Download CSV") }}
                  </v-btn>
                </v-col>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Download CSV</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          dense
                          v-model="downloadSummary"
                          :label="t('Download Summary')"
                        ></v-checkbox>
                        <v-checkbox
                          dense
                          v-model="downloadDailyCounts"
                          label="Download Daily Counts"
                        ></v-checkbox>
                        <v-checkbox
                          dense
                          v-model="downloadRaw"
                          :label="t('DownloadInfo')"
                        ></v-checkbox>
                      </v-col>

                      <v-col cols="12" v-if="downloadRaw == true">
                        <v-date-picker
                          v-model="csvDates"
                          range
                          no-title
                          :min="csvMinDate"
                          :max="today"
                        ></v-date-picker>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="csvDialog = false">
                    {{ t("Close") }}
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="downloadCSV()">
                    {{ t("Download CSV") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Photo Upload Dialog -->
            <v-dialog v-model="photoUploadDialog" max-width="90%" persistent>
              <v-card>
                <v-card-title class="headline"  style="word-break: break-word;">
                  Custom Photo for {{ uploadingSpecies.cn }}
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closePhotoUploadDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-file-input
                    v-model="selectedPhotoFile"
                    accept="image/*"
                    label="Select photo"
                    prepend-icon="mdi-camera"
                    @change="handlePhotoSelect"
                    :loading="processingPhoto"
                  ></v-file-input>

                  <!-- Preview -->
                  <div v-if="photoPreviewUrl" class="text-center mt-4">
                    <v-img
                      :src="photoPreviewUrl"
                      max-width="320"
                      max-height="240"
                      class="mx-auto"
                    ></v-img>
                    <p class="mt-2 text-caption">Preview (320x240)</p>
                  </div>

                  <!-- Current Custom Photo -->
                  <div v-if="!photoPreviewUrl" class="text-center mt-4">
                    <v-img
                      :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${
                        uploadingSpecies.spCode
                      }.jpeg?t=${Date.now()}`"
                      max-width="320"
                      max-height="240"
                      class="mx-auto"
                    ></v-img>
                    <p class="mt-2 text-caption">Current Photo</p>
                  </div>

                  <v-alert v-if="photoUploadError" type="error" class="mt-4">
                    {{ photoUploadError }}
                  </v-alert>

                  <v-alert
                    v-if="photoUploadSuccess"
                    type="success"
                    class="mt-4"
                  >
                    Success!
                  </v-alert>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    color="error"
                    text
                    @click="deleteCustomPhoto"
                    :loading="deletingPhoto"
                  >
                    Delete
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closePhotoUploadDialog">Cancel</v-btn>
                  
                  <v-btn
                    color="primary"
                    @click="uploadPhoto"
                    :disabled="!selectedPhotoFile || processingPhoto"
                    :loading="uploadingPhoto"
                  >
                    Upload
                  </v-btn>
                </v-card-actions>
                <div class="text-right pr-4 pb-3">
                  <small>
                    <a href="#/terms" target="_blank" @click.stop style="text-decoration: none;">Terms</a>
                  </small>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <!-- ALL Loop through all species -->
        <v-row dense>
          <v-col
            cols="12"
            v-for="(item, index) in seriesDaily"
            :key="item.id"
            :id="t(item.spCode, item.cn)"
          >
            <v-card
              tile
              outlined
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              dark
              scroll-margin-top="50px"
            >
              <v-row no-gutters>
                <v-col cols="2">
                  <img
                    v-if="!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                    @error="
                      if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                    "
                  />
                </v-col>

                <v-col cols="5">
                  {{ index + 1 }}. {{ t(item.spCode, item.cn) }}
                  {{ item.countsTotal }}
                </v-col>

                <v-col cols="5">
                  <v-btn
                    v-if="!hidePics"
                    icon
                    v-tooltip.bottom-start="t('Daily Chart')"
                    @click="
                      setWindowAll(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-multiple</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!hidePics && isOwner"
                    icon
                    v-tooltip.bottom-start="'Upload Custom Photo'"
                    @click="openPhotoUploadDialog(item)"
                    color="light-blue darken-1"
                  >
                    <v-icon alt="upload photo">mdi-camera-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <v-btn
                      text
                      style="
                        height: 12px;
                        margin: 0;
                        padding: 0;
                        margin-left: 2px;
                        margin-right: 1px;
                      "
                      v-if="isBat(item)"
                      @click="
                        navigateTo('https://www.batcon.org/about-bats/bats-101/')
                      "
                      color="light-blue"
                      >BCI
                    </v-btn>
                    <v-btn
                      text
                      style="
                        height: 12px;
                        margin: 0;
                        padding: 0;
                        margin-left: 2px;
                        margin-right: 1px;
                      "
                      v-if="!isBat(item) && item.lon < -30"
                      @click="
                        navigateTo(
                          'https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn)
                        )
                      "
                      color="light-blue"
                      >{{ t("About") }}
                    </v-btn>
                    <v-btn
                      text
                      style="
                        height: 12px;
                        margin: 0;
                        padding: 0;
                        margin-left: 0px;
                        margin-right: 10px;
                      "
                      v-if="!isBat(item)"
                      @click="
                        navigateTo('https://ebird.org/species/' + item.spCode)
                      "
                      color="light-blue"
                      >eBird</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-switch
                      v-if="isOwner"
                      v-model="item.showBird"
                      v-tooltip.bottom-start="
                        'Turning Show OFF will hide this species on M and H setting'
                      "
                      :label="t('Show')"
                      @change="
                        toggleShowBird(item.cn, item.spCode, item.showBird)
                      "
                      color="info"
                      style="
                        margin: 0;
                        padding: 0;
                        margin-left: 8px;
                        margin-right: 8px;
                      "
                    ></v-switch>

                    <v-switch
                      v-if="isOwner & goNativeActive & subscriptionActive"
                      v-model="item.notifyBird"
                      v-tooltip.bottom-start="
                        'Send notification when this species is detected'
                      "
                      :label="t('Notify')"
                      @change="
                        toggleNotifyBird(item.cn, item.spCode, item.notifyBird)
                      "
                      color="info"
                      style="margin: 0; padding: 0; margin-right: 16px"
                    ></v-switch>
                  </div>
                </v-col>
              </v-row>

              <!-- All Daily Time Series -->
              <div v-if="item.window == 'monthly'">
                <!-- <v-card-text class="ma-3">
                  <v-icon>mdi-music-note</v-icon
                  >{{ item.countsTotal }}</v-card-text
                > -->
                <fusioncharts
                  width="100%"
                  height="300"
                  type="timeseries"
                  dataFormat="json"
                  :dataSource="item.dataSource"
                >
                </fusioncharts>
              </div>

              <!-- All Spectrogram -->
              <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div>

              <!-- <div v-if="item.wav">
                  <v-card-actions>
                    <v-btn @click="playFile(item.wav, item.spCode, item.cn)" color="light-blue darken-1">
                      <v-icon class="mx-1" small align="center">mdi-play-circle</v-icon>
                      {{t("Play")}}
                    </v-btn>
                    <v-slider class="px-3" v-model="playbackGain" prepend-icon="mdi-volume-high" min="20" max="60"></v-slider>
                  </v-card-actions>
                </div> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Yesterday Daily Summary -->
      <v-container v-if="currentView == 'Yesterday'" fluid>
        <v-row dense>
          <v-col
            cols="12"
            v-for="(item, index) in dailySummaryList"
            :key="item.id"
          >
            <v-card
              tile
              outlined
              color="light-blue darken-4"
              class="mx-auto my-auto"
              dark
            >
              <v-row no-gutters align="center">
                <v-col cols="3">
                  <img
                    v-if="!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    style="max-width: 120px"
                    :src="`https://haikubox-images.s3.amazonaws.com/${currentSerial}/${item.spCode}.jpeg?v=${imageVersion}`"
                    @error="
                      if (!$event.target.dataset.fallback) { $event.target.dataset.fallback = '1'; $event.target.src = `https://haikubox-images.s3.amazonaws.com/${item.spCode}.jpeg`; } else if ($event.target.dataset.fallback === '1' && item.group === 'bat' && item.spCode !== 'batbatbat') { $event.target.dataset.fallback = '2'; $event.target.src = 'https://haikubox-images.s3.amazonaws.com/batbatbat.jpeg'; } else { $event.target.src = 'https://haikubox-images.s3.amazonaws.com/placeholder.jpeg'; $event.target.onerror = null; }
                    "
                  />
                </v-col>

                <v-col cols="4">
                  {{ index + 1 }}. {{ t(item.spCode, item.cn) }}
                  {{ item.countsPerDay }}
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-btn
                    class="mx-1 my-1"
                    @click="
                      playFile(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item,
                        index,
                        false
                      )
                    "
                    color="light-blue darken-1"
                    ><v-icon left>mdi-play-circle</v-icon>
                    <v-divider class="mx-1" vertical></v-divider>
                    {{ t("Play") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mx-1 my-2"
                    @click="
                      playFileEnhance(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item.id,
                        item
                      )
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                    <v-divider class="mx-1" vertical></v-divider>
                    {{ item.cn === 'Bat' ? 'Pitch Shift' : t("Enhance") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters align="center"
                ><v-col cols="8">
                  <v-btn
                    text
                    v-if="isBat(item)"
                    @click="
                      navigateTo('https://www.batcon.org/about-bats/bats-101/')
                    "
                    color="light-blue"
                    >BCI</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item) && item.lon < -30"
                    @click="
                      navigateTo(
                        'https://www.allaboutbirds.org/guide/' +
                          replaceSpaces(item.cn)
                      )
                    "
                    color="light-blue"
                    >{{ t("About") }}</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item)"
                    @click="
                      navigateTo('https://ebird.org/species/' + item.spCode)
                    "
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-col>
              </v-row>

              <!-- All Daily Time Series -->
              <div v-if="item.window == 'monthly'">
                <v-card-text class="ma-3">
                  <v-icon>mdi-music-note</v-icon
                  >{{ item.countsTotal }}</v-card-text
                >
                <fusioncharts
                  width="100%"
                  height="300"
                  type="timeseries"
                  dataFormat="json"
                  :dataSource="item.dataSource"
                >
                </fusioncharts>
              </div>

              <!-- All Spectrogram -->
              <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div>

              <!-- <div v-if="item.wav">
                  <v-card-actions>
                    <v-btn @click="playFile(item.wav, item.spCode, item.cn)" color="light-blue darken-1">
                      <v-icon class="mx-1" small align="center">mdi-play-circle</v-icon>
                      Play
                    </v-btn>
                    <v-slider class="px-3" v-model="playbackGain" prepend-icon="mdi-volume-high" min="20" max="60"></v-slider>
                  </v-card-actions>
                </div> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- Haiku Poem -->
    <v-card light tile flat color="rgb(255, 255, 255, 0.6)">
      <v-img :src="haiku.src">
        <v-row style="height: 10px"></v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-2" cols="12">
            <v-card-text
              role="none"
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5 font-weight-bold"
              style="color: white; text-align: left; text-indent: 20%; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -1px -1px 2px rgba(0, 0, 0, 0.9);"
              :aria-label="haiku.poem1"
              tabindex="0"
            >
              {{ haiku.poem1 }}</v-card-text
            >
          </v-col>
        </v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-1" cols="12">
            <v-card-text
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5 font-weight-bold"
              style="color: white; text-align: left; text-indent: 20%; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -1px -1px 2px rgba(0, 0, 0, 0.9);"
              :aria-label="haiku.poem2"
              tabindex="0"
              >{{ haiku.poem2 }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-1" cols="12">
            <v-card-text
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5 font-weight-bold"
              style="color: white; text-align: left; text-indent: 20%; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -1px -1px 2px rgba(0, 0, 0, 0.9);"
              :aria-label="haiku.poem3"
              tabindex="0"
            >
              {{ haiku.poem3 }}</v-card-text
            >
          </v-col>
        </v-row>

        <v-row style="height: 2px"></v-row>

        <v-row style="height: 50px"
          ><v-col xs="2" sm="4"> </v-col
          ><v-col xs="10" sm="8">
            <v-card-text
              class="text-xs-h6 text-sm-h5 font-weight-bold"
              style="color: white; text-align: left; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -1px -1px 2px rgba(0, 0, 0, 0.9);"
              :aria-label="haiku.poemAuthor"
              tabindex="0"
            >
              {{ haiku.poemAuthor }}
            </v-card-text>
          </v-col></v-row
        >
        <v-row style="height: 60px"
          ><v-col xs="2" sm="4"> </v-col><v-col xs="10" sm="8"> </v-col
        ></v-row>
      </v-img>
    </v-card>

    <!-- Snackbar No Audio -->
    <v-snackbar v-model="snackbar">
      Audio unavailable
      <template v-slot:action="{ attrs }">
        <v-btn color="yellow" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Bottom Navigation -->
    <v-bottom-navigation hide-on-scroll fixed horizontal dark height="60">
      <v-btn v-if="showBirdCastButton()" @click="navigateTo(birdCastUrl)">
        <span>Birdcast</span>
        <v-icon alt="Birdcast link">mdi-earth</v-icon>
      </v-btn>
      <v-btn
        @click="
          $vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic',
          })
        "
      >
        <span>To Top</span>
        <v-icon alt="Go to top of page">mdi-pan-up</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script
  async
  defer
  crossorigin="anonymous"
></script>

<script>
import { API, Storage } from "aws-amplify";
import {
  hitBySerialByDate,
  statusByDate,
  getDeviceState,
  dailyCountSummaryBySerialBySpecies,
  dailyCountSummaryBySerialByDate,
  yearlyCountSummaryBySerialByYear,
  getUserInteraction,
  dailyCountSummaryByDateBySpecies,
  getDailyCountSummary,
  listShareMaps,
  haikuboxByOwner,
  hideBirdBySerial,
  notifyBirdBySerial,
  getOneSignalConsent,
  bookmarkHaikuboxByOwner,
  getShareMap,
  getBookmarkHaikubox,
  getDevice,
  hitsBySpeciesByDate,
  userNoticeByOwnerByViewed,
  getNoticeDescription,
  getSubscription,
  getFavoriteHit,
  getUserSettings,
  getAudioUrl,
  uploadBirdPhoto,
  deleteBirdPhoto,
  labelBySerialByCn,
} from "./graphql/queries";
import {
  createLabeledData,
  createUserInteraction,
  updateUserInteraction,
  createClickTable,
  deleteHideBird,
  createHideBird,
  deleteNotifyBird,
  createNotifyBird,
  createOneSignal,
  createOneSignalConsent,
  updateDevice,
  deleteBookmarkHaikubox,
  createBookmarkHaikubox,
  updateUserNotice,
  createFavoriteHit,
  deleteFavoriteHit,
} from "./graphql/mutations";
import { latLngBounds, latLng, icon } from "leaflet";
import { LCircle, LTooltip } from "vue2-leaflet";
// import terminator from '@joergdietrich/leaflet.terminator';

import FusionCharts from "fusioncharts";

import { Plotly } from "vue-plotly";
import { getMicSensitivityDb } from "./data/memsMicResponse";
var moment = require("moment-timezone");
var tzlookup = require("tz-lookup");

var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;

// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
//const AudioContext = window.AudioContext || window.webkitAudioContext;

import { FFT } from "dsp.js";
import { unmute } from "./unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

// subscription for new hits
import { onCreateHit } from "./graphql/subscriptions";
let subscription;

import { extractFileInfo } from "@/utils";

window.gonative_app_resumed = function () {
  console.log("gonative_app_resumed");
  // window.location.reload();
};

export default {
  name: "App",
  props: ["user", "email", "goHomeClicked", "toggleMapClicked", "toggleBadgeClicked"],
  watch: {
    goHomeClicked: function () {
      // watch it
      // console.log("Haikbuox.vue goHomeClicked:", this.haikuboxLoaded);
      // mounted gets run again when home clicked
      if (this.haikuboxLoaded == 1) this.getDevicesByOwner();
      this.showBadge = false;
      this.showMap = false;
    },
    toggleMapClicked: function () {
      this.showMap = !this.showMap;
      if (this.showMap === true) {
        this.showBadge = false;
        if (this.mapInitialized == false) {
          this.getDevices();
          this.mapInitialized = true;
        }
        // this.updateCurrentHaikuboxRadius(); // kick off animation
      }
      // console.log('showMap',this.showMap);
    },
    toggleBadgeClicked: function () {
      this.showBadge = !this.showBadge;
      if (this.showBadge) this.showMap = false;
      // console.log("showBadge", this.showBadge);
    },
    watch: {
      clipSeconds(newVal) {
        localStorage.setItem("haikuboxClipSeconds", newVal.toString());
      },
    },
  },
  mounted() {
    this.haikuboxLoaded = 0;
    // console.log("haikubox.vue mounted:", this.user);
    // delay is to handle page reload, waiting for user auth update
    const haikuboxLanguage = localStorage.getItem("haikuboxLanguage");
    if (haikuboxLanguage != null) {
      this.setLanguage(haikuboxLanguage);
    } else {
      let browserLanguage = navigator.language || navigator.languages[0];
      this.browserLang = browserLanguage.split("-")[0];
      // console.log("language", this.browserLang);
      this.setLanguage(this.browserLang);
    }
    // Load clipSeconds from localStorage
    const savedClipSeconds = localStorage.getItem("haikuboxClipSeconds");
    if (savedClipSeconds) {
      this.clipSeconds = parseInt(savedClipSeconds);
      // Ensure it's a valid value
      if (
        this.clipSeconds < 3 ||
        this.clipSeconds > 12 ||
        this.clipSeconds % 3 !== 0
      ) {
        this.clipSeconds = 3; // Default to 3 if invalid
      }
    }
    // get view from local storage
    const haikuboxView = localStorage.getItem("haikuboxView");
    const haikuboxViewText = this.t(haikuboxView);
    // console.log('Mounted Haikubox View', haikuboxView, haikuboxViewText);
    if (haikuboxView != null) {
      const haikuboxViewIcon = localStorage.getItem("haikuboxViewIcon");
      this.navSelection = {
        id: haikuboxView,
        text: haikuboxViewText,
        icon: haikuboxViewIcon,
      };
    }

    // get confidence from local storage
    const haikuboxConfidence = localStorage.getItem("haikuboxConfidence");

    // console.log('Mounted Haikubox Confidence', haikuboxConfidence);
    if (haikuboxConfidence != null) {
      this.viewSettings = haikuboxConfidence;
      this.setViewConfidence(this.viewSettings); // set threshold values
    }

    if (this.user != "") this.getDevicesByOwner();
    else {
      setTimeout(this.getDevicesByOwner, 1000); // load owners boxes first
      // console.log('delay load');
    }
    // if (this.devicesByOwner[0] != null) {
    //   // this.clickDevice(this.devicesByOwner[0], 0, true, this.devicesByOwner[0].lat, this.devicesByOwner[0].lon);
    // }
    // else {
    // // this
    //   // console.log("mounted getDevices");
    //   // setTimeout(this.getDevices, 1000); // only load if no owner devices, or if click on map
    // }

    // check for oneSignalConsent if on smartphone app
    if (navigator.userAgent.indexOf("gonative") > -1) {
      this.goNativeActive = true;
      setTimeout(this.checkOneSignalConsent, 2000);
    }
    // Notice shows on web and in the app, so remember dismissal in both
    this.newAppNoticeDismissed =
      localStorage.getItem("haikuboxNewAppNoticeDismissed") === "true";
    this.haikuboxLoaded = 1;

    // iOS audio unlock - initialize AudioContext on first user interaction
    const unlockAudio = () => {
      this.initAudioContext();
      if (globalAudioContext && globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }
      // Remove listeners after first interaction
      document.removeEventListener("touchstart", unlockAudio);
      document.removeEventListener("touchend", unlockAudio);
      document.removeEventListener("click", unlockAudio);
    };
    document.addEventListener("touchstart", unlockAudio, { once: true });
    document.addEventListener("touchend", unlockAudio, { once: true });
    document.addEventListener("click", unlockAudio, { once: true });

    // setTimeout(this.getDevicesByOwner, 500);
    // this.startAnimation();
  },
  components: {
    Plotly,
    LCircle,
    LTooltip,
  },
  data() {
    return {
      browserLang: "",
      currentTranslations: {},
      languages: [
        "da",
        "de",
        "en",
        "es",
        "fr",
        "fi",
        "it",
        "nl",
        "no",
        "pt",
        "sv",
      ],
      selectedLanguage: "en",
      haikuboxLoaded: 0,
      yesterdayNumSpecies: 0,
      yesterdayCallsAndSongs: 0,
      yesterdayMostFrequent: "",
      yesterdaySpCode: 0,
      navSelection: {
        id: "Last 2 Hours",
        text: "Last 2 Hours",
        icon: "mdi-clock-outline",
      },
      // haiku: {
      //   autumn src: "https://haikubox-images.s3.amazonaws.com/carousel/haikuPoemBackground1.jpeg",
      //   type: "haiku",
      //   heading: "",
      //   poem1: "On a withered branch",
      //   poem2: "a crow is perched",
      //   poem3: "an autumn evening",
      //   poemAuthor: "Basho",
      //   poemLink:
      //     "https://www.basho4humanity.com/topic-description.php?ID=1525957618",
      //   poemLinkName: "Learn More",
      // },
      haiku: {
        // Spring src: "https://haikubox-images.s3.amazonaws.com/carousel/Background_Spring_480.jpeg",
        src: "https://haikubox-images.s3.amazonaws.com/carousel/Background_Summer_480.jpeg",
        type: "haiku",
        heading: "",
        poem1: "As the cuckoo flies,",
        poem2: "its singing stretches out:",
        poem3: "Upon the water lies.",
        poemAuthor: "-Matsuo Basho",
        poemLink: "https://www.basho4humanity.com/topic-description.php?ID=1525957618",
        // poemAuthor: "-Shiki Masaoka",
        // poemLink: "https://en.wikipedia.org/wiki/Masaoka_Shiki",
        poemLinkName: "Learn More",
      },
      moreActiveSpeciesList: [],
      csvDialog: false,
      csvDates: ["", ""],
      csvMaxMonths: 14, // How far back the raw detection CSV can reach
      downloadSummary: true,
      downloadRaw: false,
      downloadDailyCounts: false,
      showMap: false,
      showBadge: false,
      playGettingStartedVideo: false,
      currentView: "Recent",
      lastUpdated: "",
      lastStatusUpdate: "",
      confidenceThreshold: 0.4,
      specSumThreshold: 2,
      viewSettings: "Medium",
      recentHours: 2,
      hitsLoading: 0,
      csvLoading: 0,
      haikuboxSelect: {},
      bookmarkSelect: {},
      devicesByOwner: [],
      hidePics: false,
      isOwner: false,
      showRenewAlert: false,
      subscriptionActive: true,
      newBirdAlert: false,
      authState: undefined,
      goNativeActive: false,
      // Nudge users of the old wrapped app toward the new native apps.
      // Dismissal is remembered so it only nags once.
      newAppNoticeDismissed: false,
      newAppStoreUrls: {
        ios: "https://apps.apple.com/us/app/haikubox/id6790497087",
        android:
          "https://play.google.com/store/apps/details?id=com.haikubox.android",
      },
      osConsentGranted: false,
      birdCastUrl: "https://dashboard.birdcast.info/",
      clipSeconds: 3,
      maxClipSeconds: 3,
      playbackGain: 100,
      fftLength: 512,
      halfLength: 256,
      audioCache: new Map(),
      audioContexts: new Map(),
      // Audio playback tracking
      currentAudioSource: null,
      currentPlayingItem: null,
      playbackInterval: null,
      lastEnhancedFile: "",
      lastEnhancedAudio: [],
      lastEnhancedContext: null,
      micCorrectionEnabled: true,
      isVisibilityListenerAdded: false,
      lat: 0.0,
      lon: 0.0,
      snackbar: false,
      hitCalendarDatePicked: true,
      hitDatePicker: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10),
      minDate: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .substr(0, 10),
      fusionSchema: [
        {
          name: "Time",
          type: "date",
          format: "%Y-%m-%d %H:%M",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      fusionSchemaDaily: [
        {
          name: "Date",
          type: "date",
          format: "%Y-%m-%d",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      dataSource: {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        caption: {
          text: "Detections",
        },
        subcaption: {
          text: "All Species",
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Avg/15 minutes",
          },
        ],
      },
      plotlyLayoutHeatmap: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        title: "Calls Per Hour",
        margin: {
          l: 60,
          r: 40,
          b: 60,
          t: 40,
          pad: 4,
        },
        height: 300,
        hovermode: false,
      },
      plotlyLayout: {
        xaxis: {
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
      dropdownVersionList: [
        "1.38",
        "1.41",
        "2.03",
        "2.06",
        "2.07",
        "2.08",
        "2.09",
      ],
      dropdownVersion: "2.09",
      hiddenList: [
        "Gun",
        "Power tools",
        "",
        "Engine",
        "Siren",
        "Fireworks",
        "Environmental",
        "Human vocal",
        "Human whistle",
        "Human non-vocal",
        "Dog",
        "nocode",
        "soundscape",
        "Rock Pigeon",
        "Black Vulture",
        "Cattle Egret",
        "Black-crowned Night-Heron",
        "Noise",
        "Northern Cricket Frog",
        "Southern Cricket Frog",
        "Allard's Ground Cricket",
        "Tinkling Ground Cricket",
        "Walker's Ground Cricket",
        "Confused Ground Cricket",
        "Carolina Ground Cricket",
        "Clicker Round-winged Katydid",
        "Common Virtuoso Katydid",
        "Oblong-winged Katydid",
        "Rattler Round-winged Katydid",
        "Say's Trig",
        "American Toad",
        "Yosemite Toad",
        "Great Plains Toad",
        "Fowler's Toad",
        "Houston Toad",
        "Arizona Toad",
        "Oak Toad",
        "Texas Toad",
        "Southern Toad",
        "Woodhouse's Toad",
        "Honey Bee",
        "Protean Shieldback",
        "Coyote",
        "Gray Wolf",
        "Short-winged Meadow Katydid",
        "Slender Meadow Katydid",
        "Pine Barrens Treefrog",
        "Canyon Treefrog",
        "Bird-voiced Treefrog",
        "Cope's Gray Treefrog",
        "Green Treefrog",
        "Pine Woods Treefrog",
        "Barking Treefrog",
        "Squirrel Treefrog",
        "Gray Treefrog",
        "Greenhouse Frog",
        "Eastern Narrow-mouthed Toad",
        "Great Plains Narrow-mouthed Toad",
        "Gryllus assimilis",
        "Southern Wood Cricket",
        "Fall Field Cricket",
        "Southeastern Field Cricket",
        "Columbian Trig",
        "Gulf Coast Toad",
        "American Bullfrog",
        "Green Frog",
        "Pickerel Frog",
        "Wood Frog",
        "Greater Angle-wing",
        "Miogryllus saussurei",
        "False Robust Conehead",
        "Sword-bearing Conehead",
        "Round-tipped Conehead",
        "Robust Conehead",
        "Cuban Ground Cricket",
        "White-tailed Deer",
        "Fast-calling Tree Cricket",
        "Davis's Tree Cricket",
        "Snowy Tree Cricket",
        "Blackhorned Tree Cricket",
        "Narrow-winged Tree Cricket",
        "Pine Tree Cricket",
        "Four-spotted Tree Cricket",
        "Agile Meadow Katydid",
        "Stripe-faced Meadow Katydid",
        "Handsome Meadow Katydid",
        "Jumping Bush Cricket",
        "Brimley's Chorus Frog",
        "Spotted Chorus Frog",
        "Spring Peeper",
        "Upland Chorus Frog",
        "Southern Chorus Frog",
        "Little Grass Frog",
        "Ornate Chorus Frog",
        "Strecker's Chorus Frog",
        "Striped Chorus Frog",
        "Common True Katydid",
        "Couch's Spadefoot",
        "Eastern Gray Squirrel",
        "Red Squirrel",
        "Eastern Chipmunk",
        "Curve-tailed Bush Katydid",
        "Fork-tailed Bush Katydid",
        "Texas Bush Katydid",
        "Pacific Chorus Frog",
        "Handsome Trig",
        "Red-legged Partridge",
      ],
      backgroundLabelColor: "blue",
      // isFetchingBoxes: true,
      connectedDevices: [],
      disconnectedDevices: [],
      bookmarkedDevices: [],
      mapInitialized: false,
      haikuboxStatus: [],
      userNotices: [],
      liveHits: [],
      hits: [],
      allHits: [],
      dailyCounts: [],
      photoUploadDialog: false,
      uploadingSpecies: { cn: "", spCode: "" },
      selectedPhotoFile: null,
      photoPreviewUrl: null,
      processingPhoto: false,
      uploadingPhoto: false,
      deletingPhoto: false,
      photoUploadError: null,
      photoUploadSuccess: false,
      imageVersion: 0,
      liveIntervalId: null,
      currentSiteName: "",
      currentHaikuboxBookmark: false,
      currentSerial: "",
      currentTimezone: "America/New_York",
      seriesHourly: [],
      seriesDaily: [],
      allSpeciesList: [],
      speciesSelected: "",
      scrolledToBottom: false,
      dailyDetectionsTotal: [],
      dailySpeciesTotal: [],
      newSpeciesList: [],
      missingSpeciesList: [],
      dailySummaryList: [],
      dailySummaryDate: "",
      species1HourCounts: null,
      specTickLabels: ["0", "1", "2", "3"],
      currentWiFi: -60,
      checkConnectionFailed: false,
      wifiUpdatedAt: "",
      audioLink: "",
      downloadLink: "",
      shareDialog: false,
      shareCommonName: "",
      shareAudioFile: "",
      copyLinkSnackbar: false,
      totalLabeled: 0,
      speciesLabeled: [],
      totalSpeciesLabeled: 0,
      labelStreak: 0,
      labelStreakRecord: 0,
      targetLabel: 10,
      targetLabelSpecies: 2,
      targetLabelStreak: 2,
      percentTargetLabeled: 0,
      percentTargetLabelSpecies: 0,
      percentTargetLabelStreak: 0,
      badgeLabelRewards: [
        10, 25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000,
        3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 30000, 40000,
        50000, 100000, 200000, 1000000, 10000000,
      ],
      badgeLabelSpeciesRewards: [
        2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85,
        90, 95, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 250, 300,
        350, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000, 4000, 5000, 10000,
      ],
      badgleLabelStreakRewards: [
        2, 3, 5, 7, 10, 12, 14, 16, 21, 28, 60, 90, 120, 150, 180, 210, 240,
        270, 300, 330, 360, 1000, 10000,
      ],
      badgeLabelLevel: 0,
      badgeLabelSpeciesLevel: 0,
      badgeLabelStreakLevel: 0,
      newLabelBadge: false,
      newLabelSpeciesBadge: false,
      newLabelStreakBadge: false,
      notifyBirdInfo: false,
      notifyBirdInfoSnackShown: false,
      gn_OneSignalUserId: null,
      gn_OneSignalPlatform: null,
      gn_OneSignalInfo: "",
      animationInterval: "",
      animationRunning: false,
      summaryColorMapIndex: 0,
      summaryHourIndex: 0,
      summaryHour: 0,
      summaryHourLabel: "",
      zoomSummary: 3,
      centerSummary: latLng(39, -94),
      urlSummary:
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}",
      // "https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}",
      maxZoomSummary: 15,
      maxZoomHitMap: 7,
      attributionSummary:
        "Tiles &copy; Esri &mdash; Source: US National Park Service",
      zoom: 3,
      center: latLng(39, -94),
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      urlStates:
        "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      urlStatesSummary:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
      attribution:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
      urlOcean:
        "https://server.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/{z}/{y}/{x}",
      urlOceanAttribution:
        "Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri",
      currentZoom: 3,
      currentCenter: latLng(39, -94),
      mapOptions: {
        zoomSnap: 0.5,
      },
      hitMapOptions: {
        zoomControl: false,
      },
      bounds: latLngBounds([
        [20, -120],
        [55, -70],
      ]),
      iconConnected: icon({
        iconUrl: "./apple-icon-57.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconDisconnected: icon({
        iconUrl: "./signal_wifi_off-24px.svg",
        iconSize: [24, 24],
        iconAnchor: [16, 37],
      }),
      currentHaikuboxRadius: 50,
      haikuboxMarkerID: 0,
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address",
          required: true,
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password (>7 characters)",
          required: true,
        },
      ],
    };
  },
  computed: {
    csvMinDate() {
      return moment()
        .subtract(this.csvMaxMonths, "months")
        .format("YYYY-MM-DD");
    },
    newAppStoreUrl() {
      // GoNative's user agent keeps the underlying platform in it. On the
      // website we can't know the platform, so there's no single right store.
      const ua = navigator.userAgent;
      if (/iPhone|iPad|iPod/i.test(ua)) return this.newAppStoreUrls.ios;
      if (/Android/i.test(ua)) return this.newAppStoreUrls.android;
      return "";
    },
    showNewAppNotice() {
      // Shown everywhere — web visitors should hear about the app too
      return !this.newAppNoticeDismissed;
    },
    showNewAppStoreButton() {
      // Only deep-link to a store from the app, where we know the platform
      // (and only once that platform's URL is filled in)
      return this.goNativeActive && this.newAppStoreUrl !== "";
    },
    today() {
      return moment().format("YYYY-MM-DD");
    },
    dropdown_class() {
      const text = this.t("dropdown");
      // console.log(text);
      return text;
    },
    beforeDestroy() {
      this.stopCurrentAudio();

      // Clean up any subscriptions
      if (subscription) {
        subscription.unsubscribe();
      }

      // Clear any other intervals
      clearInterval(this.liveIntervalId);

      // Clean up cached AudioContexts
      if (this.audioContexts) {
        this.audioContexts.forEach((ctx) => {
          if (ctx.state !== "closed") {
            ctx.close();
          }
        });
        this.audioContexts.clear();
      }

      // Clean up global AudioContext
      if (globalAudioContext && globalAudioContext.state !== "closed") {
        globalAudioContext.close();
        globalAudioContext = null;
      }
    },
    navList() {
      if (this.subscriptionActive == false) {
        return [
          {
            id: "Last 2 Hours",
            text: this.t("Last 2 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: this.t("Last 12 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: this.t("Last 24 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Resubscribe",
            text: this.t("ResubscribeInfo"),
            icon: "mdi-meteor",
          },
        ];
      } else {
        return [
          {
            id: "Last 2 Hours",
            text: this.t("Last 2 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: this.t("Last 12 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: this.t("Last 24 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Yesterday",
            text: this.t("Yesterday"),
            icon: "mdi-calendar-clock",
          },
          { id: "Live", text: this.t("Live"), icon: "mdi-meteor" },
          { id: "All", text: this.t("All"), icon: "mdi-ballot-outline" },
        ];
      }
    },
  },
  methods: {
    setLanguage(lang) {
      // console.log(lang);
      if (
        (lang != "da") &
        (lang != "de") &
        (lang != "en") &
        (lang != "es") &
        (lang != "fi") &
        (lang != "fr") &
        (lang != "it") &
        (lang != "nl") &
        (lang != "no") &
        (lang != "pt") &
        (lang != "sv")
      ) {
        lang = "en";
      }
      this.loadTranslations(lang).then((translations) => {
        this.currentTranslations = translations;
      });
      localStorage.setItem("haikuboxLanguage", lang);
      this.selectedLanguage = lang;
      if (this.currentSerial != "") this.clickRefresh(this.currentSerial); // reload page
    },
    loadTranslations(lang) {
      return fetch(`/I18N/${lang}.json`)
        .then((response) => response.json())
        .then((translations) => {
          return translations;
        });
    },
    t(key, cn) {
      return this.currentTranslations[key] || cn;
    },
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    navigateTo(url) {
      if (this.goNativeActive) {
        window.location.href =
          "gonative://window/open?url=" + url + "&mode=appbrowser";
      } else {
        window.open(url, "_blank");
      }
    },
    openNewAppStore(url) {
      // No url = use the store matching this device's platform
      const target = url || this.newAppStoreUrl;
      if (!target) return;
      this.logClick("newAppNoticeDownload", "", "");
      if (this.goNativeActive) {
        // mode=external hands off to the OS so the App Store / Play Store app
        // opens natively — an in-app browser can't install anything
        window.location.href =
          "gonative://window/open?url=" +
          encodeURIComponent(target) +
          "&mode=external";
      } else {
        window.open(target, "_blank");
      }
    },
    onNewAppNoticeInput(open) {
      // v-alert's built-in close button emits false
      if (!open) this.dismissNewAppNotice();
    },
    dismissNewAppNotice() {
      this.logClick("newAppNoticeDismiss", "", "");
      this.newAppNoticeDismissed = true;
      localStorage.setItem("haikuboxNewAppNoticeDismissed", "true");
    },
    changeView() {
      // console.log("changeView", this.navSelection);
      this.logClick(this.navSelection.id, "", "");
      clearInterval(this.liveIntervalId);

      // if subscription not active only show last 2 hours
      if (this.subscriptionActive == false) {
        if (this.navSelection.id == "Resubscribe") {
          this.navSelection.id = "Last 2 Hours";
          this.navSelection.text = this.t(this.navSelection.id);
          this.navSelection.icon = "mdi-clock-outline";
          this.$router.push("/settings");
        }
      }

      localStorage.setItem("haikuboxView", this.navSelection.id);
      localStorage.setItem("haikuboxViewIcon", this.navSelection.icon);
      if (this.navSelection.id == "Last 2 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(2);
      }
      if (this.navSelection.id == "Last 12 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(12);
      }
      if (this.navSelection.id == "Last 24 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(24);
      }
      if (this.navSelection.id == "All") {
        this.getAll(this.currentSerial);
        this.currentView = "All";
        this.logClick("All", "", "");
      }
      // // if switching from calendar date to live, load last 2 hours
      // if ((this.navSelection.id == "Live") & (this.recentHours == 0)) {
      //   this.changeRecentHours(2);
      // }
      if (this.navSelection.id == "Live") {
        this.changeRecentHours(1); // only load past hour
        this.liveHits = []; // clear liveHits so don't see old ones
        this.subscribe(this.currentSerial);
        // this.clickRefresh(this.currentSerial);
        this.currentView = "Live";
        this.liveIntervalId = setInterval(() => {
          this.getHits(this.currentSerial);
        }, 30000);
        this.logClick("Live", "", "");
      }
      if (this.navSelection.id == "Yesterday") {
        this.currentView = "Yesterday";
        this.logClick("Yesterday", "", "");
      }
    },
    changeRecentHours(numHours) {
      this.hitCalendarDatePicked = true; // hide calendar
      this.logClick("changeRecentHours_" + numHours, "", "");
      this.recentHours = numHours;
      this.hits = [];
      this.hitsLoading = 0;
      this.getHits(this.currentSerial);
    },
    async checkUserInteractionTableExists() {
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;
      // console.log("check for user", userData);
      if (userData == null) {
        const id = this.user;
        const totalLabeled = 0;
        const speciesLabeled = [];
        const speciesLabeledCode = [];
        const totalSpeciesLabeled = 0;
        const labelStreak = 0;
        const labelStreakRecord = 0;
        // createdAt
        const labelCounterData = {
          id,
          totalLabeled,
          speciesLabeled,
          speciesLabeledCode,
          totalSpeciesLabeled,
          labelStreak,
          labelStreakRecord,
        };

        await API.graphql({
          query: createUserInteraction,
          variables: { input: labelCounterData },
        });
        // console.log("checkUserInteractionTableExists: Create user.");
      }
    },
    async loadUserInteractionData() {
      // getUserInteraction
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;

      // check if more than 1 day since last labeled (note we are not resetting this in the database, just in the display)
      const nowDate = moment().format("YYYY-MM-DD");
      let oldDate = moment(userData.dateLastLabeled);
      let newDate = moment(nowDate);
      let diffDays = newDate.diff(oldDate, "days");
      if (diffDays > 1) this.labelStreak = 0;
      else {
        this.labelStreak = userData.labelStreak;
      }

      this.totalLabeled = userData.totalLabeled;
      this.speciesLabeled = userData.speciesLabeled;
      this.totalSpeciesLabeled = userData.totalSpeciesLabeled;
      this.labelStreakRecord = userData.labelStreakRecord;
      this.updateLabelBadgeTargetLevels();
    },
    updateLabelBadgeTargetLevels() {
      // get target level for number of labels
      var nextLevelIndex = 0;
      for (let i = this.badgeLabelRewards.length - 1; i >= 0; i--) {
        if (this.totalLabeled >= this.badgeLabelRewards[i]) {
          nextLevelIndex = i + 1;
          break;
        }
      }
      if (nextLevelIndex > this.badgeLabelRewards.length - 1)
        nextLevelIndex = this.badgeLabelRewards.length - 1;
      this.targetLabel = this.badgeLabelRewards[nextLevelIndex];
      this.badgeLabelLevel = nextLevelIndex;

      // get target level for number of species
      var nextLevelIndexSpecies = 0;
      for (let i = this.badgeLabelSpeciesRewards.length - 1; i >= 0; i--) {
        if (this.totalSpeciesLabeled >= this.badgeLabelSpeciesRewards[i]) {
          nextLevelIndexSpecies = i + 1;
          break;
        }
      }
      if (nextLevelIndexSpecies > this.badgeLabelSpeciesRewards.length - 1)
        nextLevelIndexSpecies = this.badgeLabelSpeciesRewards.length - 1;
      this.targetLabelSpecies =
        this.badgeLabelSpeciesRewards[nextLevelIndexSpecies];
      this.badgeLabelSpeciesLevel = nextLevelIndexSpecies;

      // get target level for label streak
      var nextLevelIndexStreak = 0;
      for (let i = this.badgleLabelStreakRewards.length - 1; i >= 0; i--) {
        if (this.labelStreakRecord >= this.badgleLabelStreakRewards[i]) {
          nextLevelIndexStreak = i + 1;
          break;
        }
      }
      if (nextLevelIndexStreak > this.badgleLabelStreakRewards.length - 1)
        nextLevelIndexStreak = this.badgleLabelStreakRewards.length - 1;
      this.targetLabelStreak =
        this.badgleLabelStreakRewards[nextLevelIndexStreak];
      this.badgeLabelStreakLevel = nextLevelIndexStreak;

      this.percentTargetLabeled = (this.totalLabeled / this.targetLabel) * 100;
      this.percentTargetLabelSpecies =
        (this.totalSpeciesLabeled / this.targetLabelSpecies) * 100;
      this.percentTargetLabelStreak =
        (this.labelStreakRecord / this.targetLabelStreak) * 100;

      // console.log("badgeLabelStreakLevel", this.badgeLabelStreakLevel);
      // console.log("totalLabeled", this.totalLabeled);
      // console.log("totalSpeciesLabeled", this.totalSpeciesLabeled);
      // console.log("labelStreakRecord", this.labelStreakRecord);
      // console.log("targetLabel", this.targetLabel);
      // console.log("targetLabelSpecies", this.targetLabelSpecies);
      // console.log("targetLabelStreak", this.targetLabelStreak);
      // console.log("badgeLabelSpeciesLevel", this.badgeLabelSpeciesLevel);
      // console.log("percentTargetLabelSpecies", this.percentTargetLabelSpecies);
    },
    async labelHit(index, item) {
      // console.log("labelHit", index, item);
      if (!item.classLabel) return;
      this.logClick("label", item.spCode, item.cn);

      // copy file to label bucket
      if (item.wav.startsWith("bb/")) {
        // Get the audio URL
        const audioUrl = await this.getAudioUrl(item.wav);

        // Download the file
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();

        // Convert ArrayBuffer to Blob
        const blob = new Blob([arrayBuffer], { type: "audio/flac" });

        // Upload to S3 private storage
        await Storage.put("label/" + item.wav, blob, {
          level: "private",
          contentType: "audio/flac",
        });
      } else {
        // For S3 files, use the existing copy method
        await Storage.copy(
          { key: item.wav, level: "public" },
          { key: "label/" + item.wav, level: "private" }
        );
      }

      if (item.classLabel == this.t("No, it's a ...")) {
        this.hits[index].showEntryBox = true;
        this.hits[index].showSubmitBox = true;
        this.hits[index].id += 1; // increment ID so that component updates
        // console.log();
        return;
      }

      const serial = item.serial;
      const dt = item.currentWav["dt"];
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.currentWav["filename"];
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.currentWav["score"];
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      // Update the listname in wavList to show the new label
      const currentWavIndex = this.hits[index].wavList.findIndex(
        (w) => w.filename === wav
      );
      if (currentWavIndex !== -1) {
        // Remove old label suffix if present and add new one
        let listname = this.hits[index].wavList[currentWavIndex].listname;
        const labelSuffixIndex = listname.indexOf(" - ");
        if (labelSuffixIndex !== -1) {
          listname = listname.substring(0, labelSuffixIndex);
        }
        listname = listname + " - " + label;
        this.hits[index].wavList[currentWavIndex].listname = listname;
        this.hits[index].currentWav.listname = listname;
      }

      // console.log(labeledData);

      if (
        (item.classLabel == this.t("No")) |
        (item.classLabel == this.t("Yes"))
      ) {
        this.hits[index].showEntryBox = false;
        this.hits[index].id += 1; // increment ID so that component updates
      }

      // getUserInteraction
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;
      // console.log("userInteractionData", userData);

      const id = this.user;
      const totalLabeled = userData.totalLabeled + 1;

      // Check if species is a new one for this user
      if (!userData.speciesLabeledCode.includes(item.spCode)) {
        userData.speciesLabeled.push(item.cn);
        userData.speciesLabeledCode.push(item.spCode);
        userData.totalSpeciesLabeled += 1;
      }

      const speciesLabeled = userData.speciesLabeled;
      const speciesLabeledCode = userData.speciesLabeledCode;
      const totalSpeciesLabeled = userData.totalSpeciesLabeled;

      // Update Label Streak (# days in a row)
      const nowDate = moment().format("YYYY-MM-DD");
      if (userData.dateLastLabeled == null) {
        userData.dateLastLabeled = nowDate;
        userData.labelStreak = 1;
      }
      // new day?
      let oldDate = moment(userData.dateLastLabeled);
      let newDate = moment(nowDate);
      let diffDays = newDate.diff(oldDate, "days");

      if (diffDays == 1) {
        userData.labelStreak += 1; // increment if it has been at least one day but not more than 2
      } else if (diffDays > 1) {
        userData.labelStreak = 1; // reset if it has been
      }
      const labelStreak = userData.labelStreak;

      // update labelStreakRecord
      if (userData.labelStreak > userData.labelStreakRecord) {
        userData.labelStreakRecord = userData.labelStreak;
      }
      const labelStreakRecord = userData.labelStreakRecord;
      const dateLastLabeled = nowDate;

      const labelCounterData = {
        id,
        totalLabeled,
        speciesLabeled,
        speciesLabeledCode,
        totalSpeciesLabeled,
        labelStreak,
        labelStreakRecord,
        dateLastLabeled,
      };

      API.graphql({
        query: updateUserInteraction,
        variables: { input: labelCounterData },
      });
      // console.log("updateUserInteraction", labelCounterData);

      this.totalLabeled = totalLabeled;
      this.speciesLabeled = speciesLabeled;
      this.totalSpeciesLabeled = totalSpeciesLabeled;
      this.labelStreak = labelStreak;
      this.labelStreakRecord = labelStreakRecord;

      // check if hit any badge levels
      if (this.totalLabeled == this.targetLabel) {
        // new label badge!
        this.newLabelBadge = true;
        // ("new label badge");
      }
      if (this.totalSpeciesLabeled == this.targetLabelSpecies) {
        // new species badge!
        this.newLabelSpeciesBadge = true;
        // console.log("new species label badge");
      }
      if (this.labelStreakRecord == this.targetLabelStreak) {
        // new streak badge!
        this.newLabelStreakBadge = true;
        // console.log("new label streak badge");
      }

      this.updateLabelBadgeTargetLevels();
    },
    labelHitCustom(index, item) {
      // console.log("labelHitCustom");
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.tellUsMore;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      // Update the listname in wavList to show the new label
      const currentWavFilename = item.currentWav ? item.currentWav["filename"] : wav;
      const currentWavIndex = this.hits[index].wavList.findIndex(
        (w) => w.filename === currentWavFilename
      );
      if (currentWavIndex !== -1) {
        // Remove old label suffix if present and add new one
        let listname = this.hits[index].wavList[currentWavIndex].listname;
        const labelSuffixIndex = listname.indexOf(" - ");
        if (labelSuffixIndex !== -1) {
          listname = listname.substring(0, labelSuffixIndex);
        }
        listname = listname + " - " + label;
        this.hits[index].wavList[currentWavIndex].listname = listname;
        if (this.hits[index].currentWav) {
          this.hits[index].currentWav.listname = listname;
        }
      }

      this.hits[index].submitted = true;
      this.hits[index].showSubmitBox = false;
      this.hits[index].id += 1; // increment ID so that component updates
    },
    async download(item) {
      // console.log(item);
      let audioFile = item.currentWav["filename"];
      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if ((audioFile[5] == "P") | (audioFile[0] == "p")) {
        globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }

      // Get audio URL based on file prefix - FIXED THIS PART
      var audioUrl;
      if (audioFile[0] == "b") {
        audioUrl = await this.getAudioUrl(audioFile);
      } else {
        audioUrl = await Storage.get(audioFile);
      }

      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();

      // Detect the native sample rate to preserve it
      let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);

      if (!detectedSampleRate) {
        // Fallback: try to get sample rate by decoding
        detectedSampleRate = await this.getAudioSampleRate(audioUrl, arrayBuffer);
      }

      // Get or create matching audio context to preserve sample rate
      const audioContext = await this.getMatchingAudioContext(
        detectedSampleRate || 44100
      );

      // Decode audio with the matching context
      const audioBuffer = await this.decodeAudioData(
        audioContext,
        arrayBuffer.slice(0)
      );

      // Store audio duration on the item for UI controls
      if (item && !item.audioDuration) {
        item.audioDuration = audioBuffer.duration;

        // Update maxClipSeconds if we found a long file
        const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
        if (hasLongFile && this.maxClipSeconds <= 3) {
          this.maxClipSeconds = 12;
          console.log('Detected loaded file > 3s in download, setting maxClipSeconds to 12');
        }
      }

      let signal = audioBuffer.getChannelData(0);

      // Apply windowing for long files
      if (audioBuffer.duration > 3) {
        let startTime = 0;

        // Check if we have a numeric offset from extractOffsetFromWav (uses createdAt)
        if (
          item.currentWav &&
          typeof item.currentWav.offset === 'number'
        ) {
          startTime = item.currentWav.offset - this.clipSeconds / 2;
        } else {
          // Fallback: filename_unix − duration
          const filename = audioFile.split("/").pop();
          const match = filename.match(/_(\d+)\.flac$/);

          if (match && item.dt) {
            const fileEndTimestamp = parseInt(match[1]);
            const fileStartTimestamp = fileEndTimestamp - audioBuffer.duration;
            const detectionUnixTime = Math.floor(Date.parse(item.dt) / 1000);
            const offset = detectionUnixTime - fileStartTimestamp;

            if (offset >= 0 && offset <= audioBuffer.duration) {
              startTime = offset - Math.floor(this.clipSeconds / 2);
            }
          }
        }

        // Ensure startTime is within bounds
        if (startTime < 0) startTime = 0;
        if (startTime + this.clipSeconds > audioBuffer.duration) {
          startTime = audioBuffer.duration - this.clipSeconds;
        }
        if (startTime < 0) startTime = 0;

        // Extract the window
        const startSample = Math.floor(startTime * audioBuffer.sampleRate);
        const endSample = Math.floor(
          (startTime + this.clipSeconds) * audioBuffer.sampleRate
        );

        if (endSample <= audioBuffer.length) {
          signal = signal.slice(startSample, endSample);
        }
      }

      // Remove DC offset before scaling
      const dcOffset = signal.reduce((sum, val) => sum + val, 0) / signal.length;
      const dcRemoved = signal.map((value) => value - dcOffset);
      const peak = dcRemoved.reduce((acc, val) => Math.max(acc, Math.abs(val)), 0);
      const normalizedSignal = peak > 0 ? dcRemoved.map((value) => 0.8 * value / peak) : dcRemoved;

      // Apply cos² ramp to prevent clicks at start/end
      this.applyCos2Ramp(normalizedSignal, audioBuffer.sampleRate, 5);

      function saveArrayToWavFile(array, sampleRate, filename) {
        const numChannels = 1;
        const bitsPerSample = 16;
        const byteRate = (sampleRate * numChannels * bitsPerSample) / 8;
        const blockAlign = (numChannels * bitsPerSample) / 8;
        const dataSize = (array.length * bitsPerSample) / 8;
        const fileLength = 44 + dataSize;

        // Create a buffer for the WAV file
        const buffer = new ArrayBuffer(fileLength);
        const view = new DataView(buffer);

        // Write the WAV file header
        writeString(view, 0, "RIFF");
        view.setUint32(4, fileLength - 8, true);
        writeString(view, 8, "WAVE");
        writeString(view, 12, "fmt ");
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, byteRate, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitsPerSample, true);
        writeString(view, 36, "data");
        view.setUint32(40, dataSize, true);

        // Write the sample data
        for (let i = 0; i < array.length; i++) {
          view.setInt16(44 + i * 2, array[i] * 32767, true);
        }

        // Convert the buffer to a Blob
        const blob = new Blob([buffer], { type: "audio/wav" });

        // Create a link element and trigger a download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }

      let filename =
        this.replaceSpaces(item.cn) +
        "_" +
        this.replaceSpaces(item.currentWav["listname"]) +
        ".wav";
      saveArrayToWavFile(normalizedSignal, audioBuffer.sampleRate, filename);
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      const itemWithColon = itemWithApostrophe.replace(/:/g, "");
      const itemWithComma = itemWithColon.replace(/,/g, "");
      // console.log("link", itemWithColon);
      return itemWithComma;
    },
    showBirdCastButton() {
      // Check dates
      const currentDate = new Date();
      const year = currentDate.getFullYear();

      // Define the start and end dates for the first range
      const startRange1 = new Date(year, 2, 1); // March 1st (month is 0-indexed)
      const endRange1 = new Date(year, 5, 15); // June 15th (month is 0-indexed)

      // Define the start and end dates for the second range
      const startRange2 = new Date(year, 7, 1); // August 1st (month is 0-indexed)
      const endRange2 = new Date(year, 10, 9); // November 9th (month is 0-indexed)

      // Check if current date is between start and end dates of either range
      let showButton =
        (currentDate >= startRange1 && currentDate <= endRange1) ||
        (currentDate >= startRange2 && currentDate <= endRange2);
      if (this.lon > -30) showButton = false;
      return showButton;
    },
    async getBirdcastUrl() {
      if (this.showBirdCastButton() == false) return;
      // get county location with fips lookup
      var fipsCode = "https://dashboard.birdcast.info";
      const url =
        "https://geo.fcc.gov/api/census/area?lat=" +
        this.lat +
        "&lon=" +
        this.lon +
        "&censusYear=2020&format=json";
      // console.log("getBirdcastUrl", url);
      var countyFips, countyCode, stateCode;

      await fetch(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          try {
            countyFips = res.results[0].county_fips;
            stateCode = res.results[0].state_code;
            countyCode = countyFips.slice(2);
          } catch (err) {
            // console.log(res);
          }
        });
      // console.log('fipsCode', fipsCode);
      if ((countyFips != null) & (countyFips != "")) {
        fipsCode =
          "https://dashboard.birdcast.info/region/US-" +
          stateCode +
          "-" +
          countyCode;
      }
      this.birdCastUrl = fipsCode;
    },
    // async loadAndPlay(stationID, commonName) {
    //   // get wav file
    //   // query MyQuery($cnDt: ModelhitHitsBySpeciesByDateCompositeKeyConditionInput = {gt: {cn: "Northern Cardinal", dt:"2021-03-20T20:27:03.968487Z"}}) {
    //   //     hitsBySpeciesByDate(serial: "Haikubox_100000009aec770c", cnDt: $cnDt) {
    //   //       items {
    //   //         wav
    //   //         score
    //   //       }
    //   //     }
    //   //   }

    //   let lastMonthDate = moment.utc().subtract(60, "days").format();

    //   // could not figure out how to limit return to wav and score
    //   const wavFilterArg = {
    //     serial: stationID,
    //     cnDt: { gt: { cn: commonName, dt: lastMonthDate } },
    //     limit: 20,
    //     filter: { score: { gt: this.confidenceThreshold } },
    //   };
    //   const wavFilenames = await API.graphql({
    //     query: hitsBySpeciesByDate,
    //     variables: wavFilterArg,
    //   });
    //   var retWavs = wavFilenames.data.hitsBySpeciesByDate.items;
    //   console.log(retWavs);
    // },
    initAudioContext() {
      if (!globalAudioContext) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);

        if (isIOS && !this.isVisibilityListenerAdded) {
          document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
              if (globalAudioContext.state !== "suspended") {
                globalAudioContext.suspend();
                console.log("AudioContext suspended");
              }
            } else {
              if (globalAudioContext.state === "suspended") {
                globalAudioContext
                  .resume()
                  .then(() => {
                    // console.log("AudioContext resumed");

                    globalAudioContext
                      .close()
                      .then(() => {
                        // console.log("AudioContext closed");
                        globalAudioContext = new AudioContext();
                        globalGainNode = globalAudioContext.createGain();
                        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
                        globalGainNode.connect(globalAudioContext.destination);
                        unmute(globalAudioContext, false, false);
                      })
                      .catch((error) => {
                        console.error("Error closing AudioContext:", error);
                      });
                  })
                  .catch((error) => {
                    console.error("Error resuming AudioContext:", error);
                  });
              }
            }
          });
          // Set the flag to true after adding the listener
          this.isVisibilityListenerAdded = true;
        }
      }
    },
    // Add these methods for sample rate detection and audio context management
    async detectFlacSampleRate(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);

        // Verify it's a FLAC file
        const magic = String.fromCharCode(
          view.getUint8(0),
          view.getUint8(1),
          view.getUint8(2),
          view.getUint8(3)
        );

        if (magic !== "fLaC") {
          console.warn("Not a FLAC file");
          return null;
        }

        // STREAMINFO block starts at byte 8
        // Sample rate is 20 bits starting at bit 80 (byte 18)
        const byte18 = view.getUint8(18);
        const byte19 = view.getUint8(19);
        const byte20 = view.getUint8(20);

        // Sample rate is 20 bits: all of byte18, all of byte19, top 4 bits of byte20
        const sampleRate = (byte18 << 12) | (byte19 << 4) | (byte20 >> 4);

        // console.log(`Detected FLAC native sample rate: ${sampleRate}Hz`);
        return sampleRate;
      } catch (error) {
        console.error("Error detecting FLAC sample rate:", error);
        return null;
      }
    },

    async getAudioSampleRate(audioUrl, arrayBuffer) {
      // Create a temporary context just to decode and get the sample rate
      const tempContext = new AudioContext();
      try {
        const audioBuffer = await decodeAudioData(
          tempContext,
          arrayBuffer.slice(0)
        );
        const sampleRate = audioBuffer.sampleRate;
        tempContext.close();
        return sampleRate;
      } catch (error) {
        tempContext.close();
        throw error;
      }
    },

    async getMatchingAudioContext(sampleRate) {
      // Check if we already have a context for this sample rate
      if (this.audioContexts.has(sampleRate)) {
        const context = this.audioContexts.get(sampleRate);
        if (context.state !== "closed") {
          // console.log(`Reusing cached AudioContext for ${sampleRate}Hz (actual: ${context.sampleRate}Hz)`);
          return context;
        }
        // Remove stale closed context from cache
        this.audioContexts.delete(sampleRate);
      }

      // Create new context with matching sample rate
      try {
        const audioContext = new AudioContext({ sampleRate: sampleRate });
        // console.log(`Created AudioContext: requested ${sampleRate}Hz, got ${audioContext.sampleRate}Hz`);
        this.audioContexts.set(sampleRate, audioContext);
        return audioContext;
      } catch (error) {
        console.warn(`Cannot create context at ${sampleRate}Hz, using default`);
        const audioContext = new AudioContext();
        // console.log(`Using default AudioContext at ${audioContext.sampleRate}Hz`);
        this.audioContexts.set("default", audioContext);
        return audioContext;
      }
    },

    clearAudioCache() {
      this.audioCache.clear();
    },

    async getAudioUrl(audioPath) {
      try {
        const audioUrlResponse = await API.graphql({
          query: getAudioUrl,
          variables: {
            audioPath: audioPath,
          },
        });

        return audioUrlResponse.data.getAudioUrl;
      } catch (error) {
        console.error("Error getting audio URL:", error);
        throw error;
      }
    },

    isLongClipFile(item) {
      // Check if this item's file supports clips longer than 3s
      const wav = item.wav || '';
      // P files (position 5), p files (starts with p), or marine files (contains M)
      if (wav[5] === "P" || wav[0] === "p" || wav.includes("M")) {
        return true;
      }
      // Backblaze files (starts with bb/) support long clips, except bat files
      if (wav.startsWith("bb/") && item.cn !== 'Bat') {
        return true;
      }
      return false;
    },
    updateClipSeconds(delta) {
      const newValue = this.clipSeconds + delta;
      if (newValue >= 3 && newValue <= this.maxClipSeconds) {
        this.clipSeconds = newValue;
        localStorage.setItem("haikuboxClipSeconds", this.clipSeconds.toString());
      }

      // Force regenerate any visible spectrograms
      this.hits.forEach((hit, index) => {
        if (hit.window === "spectrogram") {
          // Don't clear the spectrogram - keep it visible while loading
          hit.loadingSpectrogram = true;

          // Force update
          this.$set(this.hits, index, hit);

          // Regenerate spectrogram with new clip length
          this.$nextTick(() => {
            this.spectrogram(index, hit.currentWav.filename, "Recent");
          });
        }
      });
    },

    stopPlayback() {
      if (this.currentPlayingItem) {
        this.currentPlayingItem.isPlaying = false;
        this.currentPlayingItem.isPlayingEnhance = false;
        this.currentPlayingItem.playbackProgress = 0;
      }
      if (this.currentAudioSource) {
        this.currentAudioSource.stop();
        this.currentAudioSource = null;
      }
      if (this.playbackInterval) {
        clearInterval(this.playbackInterval);
        this.playbackInterval = null;
      }
      this.currentPlayingItem = null;
      this.$forceUpdate();
    },
    async playFile(audioFile, spCode, cn, item, index, resetLabel) {
      // Stop any currently playing audio
      if (this.currentPlayingItem) {
        this.currentPlayingItem.isPlaying = false;
        this.currentPlayingItem.playbackProgress = 0;
      }

      if (this.currentAudioSource) {
        this.currentAudioSource.stop();
        this.currentAudioSource = null;
      }

      if (this.playbackInterval) {
        clearInterval(this.playbackInterval);
        this.playbackInterval = null;
      }

      // Reset label logic
      if (resetLabel === true) {
        item.classLabel = null;
        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: audioFile,
          },
        });

        if (favoriteHit.data.getFavoriteHit != null) {
          item.favoriteHit = true;
        } else {
          item.favoriteHit = false;
        }
        item.wav = audioFile;
      }

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if ((audioFile[5] == "P") | (audioFile[0] == "p")) {
        globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }

      // Get audio URL based on file prefix
      var audioUrl;
      if (audioFile[0] == "b") {
        audioUrl = await this.getAudioUrl(audioFile);
      } else {
        audioUrl = await Storage.get(audioFile);
      }

      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();

      // Try to parse Vorbis TIMESTAMP before decodeAudioData consumes the buffer
      const vorbisTimestamp = this.parseVorbisTimestamp(arrayBuffer);

      const decodedBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      // Store audio duration on the item for UI controls
      if (item && !item.audioDuration) {
        item.audioDuration = decodedBuffer.duration;

        // Update maxClipSeconds if we found a long file
        const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
        if (hasLongFile && this.maxClipSeconds <= 3) {
          this.maxClipSeconds = 12;
          console.log('Detected loaded file > 3s in playFile, setting maxClipSeconds to 12');
        }
      }

      let startTime = 0;
      let playbackDuration = this.clipSeconds; // Always use clipSeconds for duration

      // For files longer than 3 seconds, calculate the start offset
      if (decodedBuffer.duration > 3) {
        let offset = null;

        // Priority 1: stored offset from extractOffsetFromWav (uses createdAt)
        if (
          item.currentWav &&
          item.currentWav.offset !== null &&
          item.currentWav.offset !== undefined &&
          typeof item.currentWav.offset === 'number'
        ) {
          offset = item.currentWav.offset;
        }

        // Priority 2: Vorbis TIMESTAMP parsed from FLAC bytes
        if (offset === null && vorbisTimestamp && item.dt) {
          const detectionUnix = Math.floor(Date.parse(item.dt) / 1000);
          const vorbisOffset = detectionUnix - vorbisTimestamp;
          if (vorbisOffset >= 0 && vorbisOffset <= decodedBuffer.duration) {
            offset = vorbisOffset;
          }
        }

        // Priority 3: filename_unix − duration (proxy, ~1s off)
        if (offset === null && item.dt) {
          const filename = audioFile.split("/").pop();
          const match = filename.match(/_(\d+)\.flac$/);
          if (match) {
            const fileEndTimestamp = parseInt(match[1]);
            const fileStartTimestamp = fileEndTimestamp - decodedBuffer.duration;
            const detectionUnix = Math.floor(Date.parse(item.dt) / 1000);
            const filenameOffset = detectionUnix - fileStartTimestamp;
            if (filenameOffset >= 0 && filenameOffset <= decodedBuffer.duration) {
              offset = filenameOffset;
            }
          }
        }

        if (offset !== null) {
          startTime = offset - this.clipSeconds / 2;
        }

        // Ensure startTime is within bounds
        if (startTime < 0) startTime = 0;
        if (startTime + this.clipSeconds > decodedBuffer.duration) {
          startTime = decodedBuffer.duration - this.clipSeconds;
        }
        if (startTime < 0) startTime = 0; // If file is shorter than clipSeconds
      } else {
        // For short files, play the entire file
        playbackDuration = decodedBuffer.duration;
      }

      // Extract the audio segment and apply cos² ramp
      let channelData = decodedBuffer.getChannelData(0);
      let startSample = Math.floor(startTime * decodedBuffer.sampleRate);
      let endSample = Math.floor((startTime + playbackDuration) * decodedBuffer.sampleRate);

      // Ensure we don't go beyond buffer length
      endSample = Math.min(endSample, channelData.length);

      // Extract segment
      let segment = channelData.slice(startSample, endSample);

      // Apply cos² ramp to prevent clicks
      this.applyCos2Ramp(segment, decodedBuffer.sampleRate, 5);

      // Create new buffer with ramped audio
      const audioBuffer = globalAudioContext.createBuffer(
        1,
        segment.length,
        decodedBuffer.sampleRate
      );
      audioBuffer.getChannelData(0).set(segment);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = audioBuffer;
      sampleSource.connect(globalGainNode);

      // Set up playback tracking
      item.isPlaying = true;
      item.playbackProgress = 0;
      this.currentPlayingItem = item;
      this.currentAudioSource = sampleSource;

      const playbackStartTime = globalAudioContext.currentTime;

      // Update progress during playback
      this.playbackInterval = setInterval(() => {
        const elapsed =
          globalAudioContext.currentTime - playbackStartTime + 0.04;
        const progress = (elapsed / playbackDuration) * 100;

        if (progress >= 100 || !item.isPlaying) {
          item.isPlaying = false;
          item.playbackProgress = 0;
          if (this.playbackInterval) {
            clearInterval(this.playbackInterval);
            this.playbackInterval = null;
          }
          this.currentPlayingItem = null;
          this.currentAudioSource = null;
        } else {
          item.playbackProgress = progress;
        }
        this.$forceUpdate();
      }, 50);

      // Handle playback end
      sampleSource.onended = () => {
        item.isPlaying = false;
        item.playbackProgress = 0;
        if (this.playbackInterval) {
          clearInterval(this.playbackInterval);
          this.playbackInterval = null;
        }
        this.currentPlayingItem = null;
        this.currentAudioSource = null;
        this.$forceUpdate();
      };

      // Start playback (segment already extracted with ramp applied)
      // console.log(`Starting playback: duration=${playbackDuration}s`);
      sampleSource.start(0);

      // Update spectrogram if needed
      if (this.currentView == "Recent") {
        if (item.window == "spectrogram") {
          this.spectrogram(index, item.currentWav["filename"], "Recent");
          item.classLabel = null;
        }
      }
    },

    stopCurrentAudio() {
      if (this.currentPlayingItem) {
        this.currentPlayingItem.isPlaying = false;
        this.currentPlayingItem.playbackProgress = 0;
      }

      if (this.currentAudioSource) {
        try {
          this.currentAudioSource.stop();
        } catch (e) {
          // Already stopped
        }
        this.currentAudioSource = null;
      }

      if (this.playbackInterval) {
        clearInterval(this.playbackInterval);
        this.playbackInterval = null;
      }

      this.currentPlayingItem = null;
      this.$forceUpdate();
    },

    async playAudioFromCache(audioUrl, speciesGroup) {
      // Stop any currently playing audio
      this.stopCurrentAudio();

      try {
        let audioBuffer;
        let audioContext;

        // For files starting with 'b', we need to check if it's the URL or filename
        let cacheKey = audioUrl;
        if (audioUrl.startsWith("http")) {
          // It's already a URL, find the original filename in cache
          for (const [key, value] of this.audioCache.entries()) {
            if (value.audioUrl === audioUrl) {
              cacheKey = key;
              break;
            }
          }
        }

        // Check if we have cached data for this URL/file
        const cachedData = this.audioCache.get(cacheKey);

        if (cachedData && cachedData.audioBuffer) {
          audioBuffer = cachedData.audioBuffer;
          audioContext = cachedData.audioContext;
        } else {
          // If not cached, we need to determine if it's a URL or filename
          let finalUrl = audioUrl;
          if (!audioUrl.startsWith("http")) {
            // It's a filename, get the URL
            if (audioUrl[0] == "b") {
              finalUrl = await this.getAudioUrl(audioUrl);
            } else {
              finalUrl = await Storage.get(audioUrl);
            }
          }

          // Fetch and cache
          const response = await fetch(finalUrl);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const arrayBuffer = await response.arrayBuffer();
          const nativeSampleRate = await this.getAudioSampleRate(
            finalUrl,
            arrayBuffer
          );
          audioContext = await this.getMatchingAudioContext(nativeSampleRate);
          audioBuffer = await this.decodeAudioData(
            audioContext,
            arrayBuffer.slice(0)
          );

          // Cache for future use
          this.audioCache.set(cacheKey, {
            audioUrl: finalUrl,
            arrayBuffer: arrayBuffer,
            audioBuffer: audioBuffer,
            audioContext: audioContext,
            sampleRate: nativeSampleRate,
          });
        }

        // Create and play the audio source
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;

        // Create filters
        const highPassFilter = audioContext.createBiquadFilter();
        highPassFilter.type = "highpass";
        highPassFilter.frequency.value = 300; // Remove rumble below 300Hz
        highPassFilter.Q.value = 1;

        const lowPassFilter = audioContext.createBiquadFilter();
        lowPassFilter.type = "lowpass";
        lowPassFilter.frequency.value = 8000; // Remove hiss above 8kHz
        lowPassFilter.Q.value = 1;

        // Create gain node for volume control
        const gainNode = audioContext.createGain();

        // Analyze and normalize audio
        let maxSample = 0;
        for (
          let channel = 0;
          channel < audioBuffer.numberOfChannels;
          channel++
        ) {
          const channelData = audioBuffer.getChannelData(channel);
          for (let i = 0; i < channelData.length; i++) {
            maxSample = Math.max(maxSample, Math.abs(channelData[i]));
          }
        }

        if (maxSample > 0.001) {
          const targetLevel = 0.8;
          const requiredGain = targetLevel / maxSample;
          const appliedGain = Math.min(requiredGain, 4); // Max 12dB boost
          gainNode.gain.value = appliedGain;
          // console.log(`Audio normalized: gain ${appliedGain.toFixed(1)}x`);
        }

        // Connect the audio chain
        // source -> highpass -> lowpass -> gain -> speakers
        source.connect(highPassFilter);
        highPassFilter.connect(lowPassFilter);
        lowPassFilter.connect(gainNode);
        gainNode.connect(audioContext.destination);

        // Calculate playback parameters
        const startOffset = speciesGroup ? speciesGroup.windowOffset : 0;
        const duration = speciesGroup
          ? speciesGroup.windowDuration
          : audioBuffer.duration;

        // Start playback
        source.start(0, startOffset, duration);
        this.currentAudioSource = source;
        this.currentAudioContext = audioContext;
        this.playbackStartTime = audioContext.currentTime;
        this.playbackDuration = duration;

        // Track playback progress
        if (speciesGroup) {
          speciesGroup.isPlaying = true;
          speciesGroup.playbackProgress = 0;

          this.playbackInterval = setInterval(() => {
            const elapsed =
              audioContext.currentTime - this.playbackStartTime + 0.04;
            const progress = (elapsed / duration) * 100;

            if (progress >= 100) {
              this.stopCurrentAudio();
              speciesGroup.isPlaying = false;
              speciesGroup.playbackProgress = 0;
            } else {
              speciesGroup.playbackProgress = progress;
            }
            this.$forceUpdate();
          }, 50); // Update every 50ms
        }

        // Handle playback end
        source.onended = () => {
          if (speciesGroup) {
            speciesGroup.isPlaying = false;
            speciesGroup.playbackProgress = 0;
            this.$forceUpdate();
          }
          this.stopCurrentAudio();
        };
      } catch (error) {
        console.error("Error playing cached audio:", error);
        // Fallback to HTML Audio element
        const audio = new Audio(audioUrl);
        audio.crossOrigin = "anonymous";
        audio.play();
      }
    },

    zoomUpdate(zoom) {
      // console.log('zoomUpdate');
      this.currentZoom = Math.floor(zoom);
      this.updateCurrentHaikuboxRadius();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    getEventText(item) {
      let momentText = moment(item.dt).locale(this.selectedLanguage).fromNow();
      if (momentText == "in a few seconds") {
        momentText = "just now";
      }
      if (momentText == "a few seconds ago") {
        momentText = "just now";
      }
      return momentText;
    },
    // getScoreText(score) {
    //   //let scoreText = score;
    //   let scoreText = "high";
    //   if (score < 0.4) {
    //     scoreText = "low";
    //   } else {
    //     if (score < 0.9) scoreText = "medium";
    //   }
    //   return scoreText;
    // },
    clickRefresh(currentSerial) {
      this.logClick("clickRefresh", "", "");
      this.getHits(currentSerial);
      this.getState(currentSerial); // current state including timezone
      if (this.isOwner) this.getStatus(currentSerial); // wifi strength
      // this.getHourlyCount(currentSerial);
      // this.loadSummary(currentSerial);
    },
    async ownerSelectDevice() {
      // need to get lat lon
      // console.log('ownerSelectDevice', this.haikuboxSelect);
      this.currentSerial = this.haikuboxSelect.serial;
      this.subscriptionActive = this.haikuboxSelect.subscriptionActive;

      // get new bird alert setting
      const id = this.currentSerial.split("_");
      const devicesInfo = await API.graphql({
        query: getDevice,
        variables: { id: id[1] },
      });
      var temp = devicesInfo.data.getDevice;
      this.newBirdAlert = temp.newBirdAlert;

      this.clickDevice(
        { serial: this.currentSerial, name: this.haikuboxSelect.name },
        true,
        true,
        this.haikuboxSelect.lat,
        this.haikuboxSelect.lon
      );
      this.bookmarkSelect = {};
      this.getBirdcastUrl();
      // try {
      //   this.getBirdcastUrl();
      // } catch (error) {
      //   console.error(error);
      // }
    },
    bookmarkSelectDevice() {
      // need to get lat lon
      // console.log("bookmarkSelectDevice", this.bookmarkSelect);
      this.currentSerial = this.bookmarkSelect.id;
      this.clickDevice(
        { serial: this.currentSerial, name: this.bookmarkSelect.name },
        true,
        false,
        this.bookmarkSelect.shareLat,
        this.bookmarkSelect.shareLon
      );
      this.haikuboxSelect = {};
    },
    async clickDevice(item, logClick, isOwner, lat, lon) {
      // console.log("clickDevice", item);
      // double-checking in case click on their own device from map
      if (isOwner == false) {
        for (let i = 0; i < this.devicesByOwner.length; i++) {
          if (this.devicesByOwner[i].serial.includes(item.serial))
            isOwner = true;
          this.isOwner = true;
        }
      }
      this.lat = lat;
      this.lon = lon;
      this.hitCalendarDatePicked = true; // this hides calendar if it is open
      this.hitDatePicker = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10); // reset to now
      if (this.recentHours == 0) this.recentHours = 2; // in case clicked on a device after clicking on Home calendar
      this.currentSiteName = item.name;
      if (logClick) this.logClick("clickDevice", "", "");
      this.isOwner = isOwner;
      this.checkUserInteractionTableExists();
      this.currentSerial = item.serial;

      // Save selected device to localStorage
      try {
        localStorage.setItem('selectedDevice', JSON.stringify({
          serial: item.serial,
          name: item.name,
          lat: lat,
          lon: lon,
          isOwner: isOwner
        }));
      } catch (e) {
        console.error('Error saving selected device to localStorage:', e);
      }
      this.liveHits = [];
      this.moreActiveSpeciesList = [];
      this.hits = []; //clear previously clicked site
      await this.getState(item.serial);
      this.getYesterdayCounts(item.serial);
      this.getHits(item.serial);
      this.changeView(); // this will set subscription for Live and load All if on All view
      // this.getPrivacy(item.serial);

      if (this.isOwner) {
        this.getStatus(item.serial);
        // console.log('clickDevice is owner', item);
        // if (item.newBirdAlert === null) item.newBirdAlert = false;
        // this.newBirdAlert = item.newBirdAlert;
      }
      if (this.isOwner == false) {
        // check if site is bookmarked
        let bookmarkID = this.currentSerial + "_" + this.user;
        const bmrk = await API.graphql({
          query: getBookmarkHaikubox,
          variables: { id: bookmarkID },
        });
        let retBookmark = bmrk.data.getBookmarkHaikubox;
        // console.log("clickDevice bookmark", retBookmark);
        if (retBookmark != null) this.currentHaikuboxBookmark = true;
        else {
          this.currentHaikuboxBookmark = false;
          this.bookmarkSelect = {}; // clear bookmark select dropdown
        }
        this.haikuboxSelect = {}; // clear Haikubox select dropdown
        this.getBirdcastUrl();
      }
      // this.loadSummary(item.serial);
      this.loadUserInteractionData();
      // this.getHourlyCount(item.serial);

      this.showMap = false;
      this.updateBounds();
    },
    async getState(serialClicked) {
      // Try tz-lookup from lat/lon first for comparison
      let tzLookupTimezone = null;
      if (this.lat != null && this.lon != null) {
        try {
          tzLookupTimezone = tzlookup(this.lat, this.lon);
          // console.log("tz-lookup timezone:", tzLookupTimezone);
        } catch (e) {
          console.log("tz-lookup failed:", e);
        }
      }

      try {
        const deviceState = await API.graphql({
          query: getDeviceState,
          variables: { id: serialClicked },
        });
        var clickedDevice = deviceState.data.getDeviceState;
        // console.log("deviceState timezone:", clickedDevice.timezone);
        if (clickedDevice.timezone != null) {
          this.currentTimezone = clickedDevice.timezone;
        } else if (tzLookupTimezone) {
          // Fallback to tz-lookup if deviceState has no timezone
          // console.log("Using tz-lookup fallback");
          this.currentTimezone = tzLookupTimezone;
        }
      } catch (e) {
        console.log("getDeviceState failed:", e);
        // Fallback to tz-lookup if deviceState query fails
        if (tzLookupTimezone) {
          // console.log("Using tz-lookup fallback after deviceState failure");
          this.currentTimezone = tzLookupTimezone;
        }
      }
    },
    async updateBounds() {
      this.bounds = latLngBounds([
        [this.lat - 5.0, this.lon - 5.0],
        [this.lat + 5.0, this.lon + 5.0],
      ]);
    },
    async checkOneSignalConsent() {
      // console.log('checkOneSignalConsent');
      const oneSignalConsent = await API.graphql({
        query: getOneSignalConsent,
        variables: { id: this.user },
      });
      let consentData = oneSignalConsent.data.getOneSignalConsent;
      // console.log("checkOneSignalConsent", consentData);
      if (consentData.osConsentGranted == null) {
        this.osConsentGranted = false;
      } else {
        this.osConsentGranted = true;
      }
      //console.log('osConsentGranted', this.osConsentGranted);

      if (this.osConsentGranted) {
        this.grantOneSignalPrivacyConsent(); // this will connect oneSignal if new device and get OneSignal Info
      }
    },
    async grantOneSignalPrivacyConsent() {
      if (navigator.userAgent.indexOf("gonative") > -1) {
        await gonative.onesignal.userPrivacyConsent.grant();
        await gonative.onesignal.register();
        this.osConsentGranted = true;
        this.addConsentToOneSignalDb();
        this.getOneSignal();
      }
      this.notifyBirdInfo = false; // hide snackbar
    },
    async addConsentToOneSignalDb() {
      // update database
      const varArg = {
        id: this.user,
        osConsentGranted: true,
      };
      await API.graphql({
        query: createOneSignalConsent,
        variables: { input: varArg },
      });
    },
    async getOneSignal() {
      if (navigator.userAgent.indexOf("gonative") > -1) {
        this.gn_OneSignalInfo =
          "goNative active: " + this.devicesByOwner.length;
        let oneSignalInfo = await gonative.onesignal.onesignalInfo();
        this.gn_OneSignalUserId = oneSignalInfo.oneSignalUserId;
        this.gn_OneSignalPlatform = oneSignalInfo.platform;
        if (this.gn_OneSignalUserId) {
          for (let i = 0; i < this.devicesByOwner.length; i++) {
            const oneSignalData = {
              id: this.gn_OneSignalUserId + "_" + this.devicesByOwner[i].serial,
              playerID: this.gn_OneSignalUserId,
              platform: this.gn_OneSignalPlatform,
              serial: this.devicesByOwner[i].serial,
            };
            try {
              await API.graphql({
                query: createOneSignal,
                variables: { input: oneSignalData },
              });
            } catch (e) {
              // Ignore errors (e.g., record already exists) and continue with next device
            }
          }
        }
      } else this.gn_OneSignalInfo = "Go Native Not Recoginized";
    },
    async getDevicesByOwner() {
      this.haikuboxLoaded = 0;
      var userID = this.user;
      if (userID == "" || userID == undefined) {
        this.showMap = true;
        await this.loadBookmarkedHaikuboxes();
        return;
      }
      // console.log("getDevicesByOwner", this.user);
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: userID },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;

      // console.log("devicesByOwner", this.devicesByOwner);
      if (this.devicesByOwner.length > 0) {
        // Try to restore previously selected device from localStorage
        let savedDevice = null;
        try {
          const savedDeviceStr = localStorage.getItem('selectedDevice');
          if (savedDeviceStr) {
            savedDevice = JSON.parse(savedDeviceStr);
          }
        } catch (e) {
          console.error('Error reading selected device from localStorage:', e);
        }

        // Check if saved device still exists in devicesByOwner
        let deviceToSelect = this.devicesByOwner[0];
        if (savedDevice) {
          const matchingDevice = this.devicesByOwner.find(d => d.serial === savedDevice.serial);
          if (matchingDevice) {
            deviceToSelect = matchingDevice;
          }
        }

        this.haikuboxSelect = deviceToSelect;
        this.haikuboxSelect.lat = deviceToSelect.lat;
        this.haikuboxSelect.lon = deviceToSelect.lon;
        // check if subscription still valid
        this.getSubscriptionState().then((value) => {
          // console.log('sub ok');
          this.ownerSelectDevice(); // this calls clickDevice after getting newBirdAlert
        });

        this.getOneSignal();
        this.getNotices(); // see if there are any notices to show
        await this.loadBookmarkedHaikuboxes();
      } else {
        // If there are no haikuboxes owned but one or more bookmarked go to first in list
        // console.log(
        //   "getDevicesByOwner check bookmarks",
        //   this.bookmarkedDevices
        // );
        await this.loadBookmarkedHaikuboxes();
        if (this.bookmarkedDevices.length > 0) {
          // Try to restore previously selected bookmarked device
          let savedDevice = null;
          try {
            const savedDeviceStr = localStorage.getItem('selectedDevice');
            if (savedDeviceStr) {
              savedDevice = JSON.parse(savedDeviceStr);
            }
          } catch (e) {
            console.error('Error reading selected device from localStorage:', e);
          }

          let deviceToSelect = this.bookmarkedDevices[0];
          if (savedDevice) {
            const matchingDevice = this.bookmarkedDevices.find(d => d.serial === savedDevice.serial);
            if (matchingDevice) {
              deviceToSelect = matchingDevice;
            }
          }

          this.clickDevice(
            deviceToSelect,
            0,
            0,
            deviceToSelect.shareLat,
            deviceToSelect.shareLon
          );
        } else {
          // this.showMap = true;
          if (
            (this.user == "60c05843-732f-4d66-a49a-bd39658cdacb") |
            (this.user == "332232a5-51da-4f3e-a260-d83fdd959b12")
          ) {
            var demoHaikubox = {
              name: "Younger Lagoon 1",
              serial: "Haikubox_100000003071d681",
              lat: 36.956374713079256,
              lon: -122.06877083821281,
            };
            this.carouselItems[0].src =
              "https://haikubox-images.s3.amazonaws.com/carousel/YL_marinesteps.jpg";
          } else {
            var demoHaikubox = {
              name: "Haikubox Demo",
              serial: "Haikubox_3485188E66CC",
              lat: 41.601,
              lon: -70.608,
            };
          }

          this.clickDevice(
            demoHaikubox,
            0,
            false,
            demoHaikubox.lat,
            demoHaikubox.lon
          );
        }
      }
      this.haikuboxLoaded = 1;

      const userSettings = await API.graphql({
        query: getUserSettings,
        variables: { id: this.user },
      });
      // no entry yet leave at false
      if (userSettings.data.getUserSettings == null) {
        this.hidePics = false;
      } else {
        this.hidePics = userSettings.data.getUserSettings.hidePics;
      }
    },
    async getSubscriptionState() {
      // query subscription state
      this.showRenewAlert = false;
      for (let i = 0; i < this.devicesByOwner.length; i++) {
        const subState = await API.graphql({
          query: getSubscription,
          variables: { id: this.devicesByOwner[i].serial },
        });
        let currentUnixTime = Math.floor(Date.now() / 1000); // convert ms to s
        if (subState?.data?.getSubscription?.prepaidPeriodEndUnix != null) {
          this.devicesByOwner[i].prepaidPeriodEndUnix = moment
            .unix(Number(subState.data.getSubscription.prepaidPeriodEndUnix))
            .format("LL");
          this.devicesByOwner[i].subscriptionActive = true;
        }

        if (
          subState?.data?.getSubscription?.stripeCurrentPeriodEndUnix != null
        ) {
          this.devicesByOwner[i].stripeCurrentPeriodEndUnix = moment
            .unix(
              Number(subState.data.getSubscription.stripeCurrentPeriodEndUnix)
            )
            .format("LL");
          // check if stripeCurrentPeriodEndUnix is within 2 weeks (1209600 s) of expiring
          let stripeUnix = Number(
            subState.data.getSubscription.stripeCurrentPeriodEndUnix
          );
          // if((stripeUnix - currentUnixTime) < 1209600){
          //   this.showRenewAlert = true;
          // }
          if (stripeUnix - currentUnixTime < 0) {
            this.devicesByOwner[i].subscriptionActive = false;
          }
        } else {
          // Prepaid period
          if (subState?.data?.getSubscription?.prepaidPeriodEndUnix != null) {
            // check if prepaid period is within 2 weeks of expiring
            let stripeUnix = Number(
              subState.data.getSubscription.prepaidPeriodEndUnix
            );
            if (stripeUnix - currentUnixTime < 1209600) {
              this.showRenewAlert = true;
            }
            if (stripeUnix - currentUnixTime < 0) {
              this.devicesByOwner[i].subscriptionActive = false;
            }
          } else {
            // console.log(this.devicesByOwner[i].id, "missing prepaidPeriodEndUnix");
            this.devicesByOwner[i].subscriptionActive = false;
          }
        }
      }
      return true;
    },
    async loadBookmarkedHaikuboxes() {
      var nextToken = null;
      var allDevices = [];
      do {
        const bookmarks = await API.graphql({
          query: bookmarkHaikuboxByOwner,
          variables: { owner: this.user, nextToken: nextToken },
        });
        allDevices = allDevices.concat(
          bookmarks.data.bookmarkHaikuboxByOwner.items
        );
        nextToken = bookmarks.data.bookmarkHaikuboxByOwner.nextToken;
      } while (nextToken != null);
      // console.log("loadBookmarkedHaikuboxes", allDevices);

      // are these Haikuboxes in shareMap
      var bookmarkedHaikuboxes = [];
      if (allDevices.length > 0) {
        for (let i = 0; i < allDevices.length; i++) {
          let id = allDevices[i].serial;
          const hbox = await API.graphql({
            query: getShareMap,
            variables: { id: id },
          });
          let retShare = hbox.data.getShareMap;
          // console.log("load bookmark check shareMap", retShare);
          if (retShare != null) {
            retShare.serial = retShare.id;
            bookmarkedHaikuboxes.push(retShare);
          }
        }
      }
      this.bookmarkedDevices = bookmarkedHaikuboxes;
      // console.log("bookmarked Haikbuoxes", this.bookmarkedDevices);
    },
    async getDevices() {
      var nextToken = null;
      var allDevices = [];
      var connected = [];
      do {
        const deviceStates = await API.graphql({
          query: listShareMaps,
          variables: { nextToken: nextToken },
        });
        allDevices = allDevices.concat(deviceStates.data.listShareMaps.items);
        nextToken = deviceStates.data.listShareMaps.nextToken;
        deviceStates.data.listShareMaps.items.forEach(function (element) {
          // console.log("Element", element);
          element.serial = element.id;
          if ((element.shareLat != null) & element.connected) {
            connected.push(element);
          }
        });
        this.connectedDevices = connected;
      } while (nextToken != null);

      // console.log("Devices", this.devices);

      // var disconnected = [];

      // this.disconnectedDevices = disconnected;
      // console.log("connected", connected);
      // console.log("disconnected", disconnected);

      // this.isFetchingBoxes = false;
    },
    async checkConnection(serialClicked) {
      await this.getStatus(serialClicked);
      if (this.currentWiFi == 0) {
        this.checkConnectionFailed = true;
      } else {
        this.checkConnectionFailed = false;
      }
    },
    async getStatus(serialClicked) {
      let yesterdayDate = moment.utc().subtract(1, "hours").format();
      const filterArg = {
        serial: serialClicked,
        createdAt: { gt: yesterdayDate },
      };
      const boxStatus = await API.graphql({
        query: statusByDate,
        variables: filterArg,
        sortDirection: "ASC",
      });
      this.haikuboxStatus = boxStatus.data.statusByDate.items;
      // console.log('getStatus', this.haikuboxStatus);
      var currentWiFi = 0;
      this.lastStatusUpdate = "";
      if (this.haikuboxStatus.length > 0) {
        currentWiFi =
          this.haikuboxStatus[this.haikuboxStatus.length - 1].signal;
        this.lastStatusUpdate = moment(
          this.haikuboxStatus[this.haikuboxStatus.length - 1].updatedAt,
          "YYYY-MM-DDThh:mm:ssZ"
        ).calendar();
        this.wifiUpdatedAt = moment(
          this.haikuboxStatus[this.haikuboxStatus.length - 1].updatedAt
        )
          .local()
          .calendar();
      }

      this.currentWiFi = currentWiFi;

      // console.log('wifi last updated', this.haikuboxStatus[this.haikuboxStatus.length-1].updatedAt);
    },
    // fusioncharts format hourly data
    async getHourlySpecies(cn) {
      let hourlyTimeSeries = Array(24).fill(0);
      var nextToken = null;
      this.lastUpdated = moment
        .utc()
        .local()
        .locale(this.selectedLanguage)
        .calendar();
      let yesterdayDate, todayDate;
      var tempHits = [];

      todayDate = moment.utc().format();

      yesterdayDate = moment.utc().subtract(23, "hours").format();
      // console.log(cn, yesterdayDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: yesterdayDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);

      // console.log(tempHits);
      // loop through all detections and add to correct hour bin
      // localHour will correspond to bin index 23
      tempHits.forEach((hit) => {
        var currentMinutes = moment.utc().minutes();
        // convert to local time to get correct hour bin
        var diffMinutes = moment.utc(hit["dt"]).diff(todayDate, "minutes");
        var diffHours = moment.utc(hit["dt"]).diff(todayDate, "hours");
        if ((diffHours == 0) & (-diffMinutes > currentMinutes)) diffHours = -1; // round current hour
        // console.log('diff from now', currentMinutes, diffMinutes, diffHours);
        var i = 23 + diffHours;
        if (i < 0) i = 0;
        if (i > 23) i = 23;
        hourlyTimeSeries[i] = hourlyTimeSeries[i] + hit["detectionCount"];
      });
      // console.log("UTC", hourlyTimeSeries);

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate).utc();
        stopDate = moment(stopDate).utc();
        // console.log("start date", startDate);
        // console.log("stop date", stopDate);
        while (currentDate <= stopDate) {
          var a = moment.utc(currentDate);
          dateArray.push(a.format());
          currentDate = moment(currentDate).add(1, "hours");
        }
        return dateArray;
      }

      let minMomentDate = moment.utc().subtract(23, "hours");
      minMomentDate.minutes(0);
      minMomentDate.seconds(0);
      let minDate = minMomentDate.format();
      let maxDate = minMomentDate.add(23, "hours").format();
      let dateArr = getDates(minDate, maxDate);
      let localDateArr = [];
      for (let utcDate of dateArr) {
        localDateArr.push([
          moment.utc(utcDate).tz(this.currentTimezone).format("hh:mm a"),
        ]);
      }

      this.chartOptionsHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      this.chartOptionsSpeciesHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      // console.log(localDateArr);
      // console.log(this.chartOptionsHourly);
      // console.log(this.chartOptionsSpeciesHourly);

      var colorMap = [
        "#ffffd9",
        "#edf8b1",
        "#c7e9b4",
        "#7fcdbb",
        "#41b6c4",
        "#1d91c0",
        "#225ea8",
        "#0c2c84",
      ];

      // console.log("speciesID", speciesID);
      var totalDetections = 0;
      var plotData = [];

      var localHour;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 am")
        localHour = 0;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 am")
        localHour = 1;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 am")
        localHour = 2;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 am")
        localHour = 3;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 am")
        localHour = 4;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 am")
        localHour = 5;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 am")
        localHour = 6;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 am")
        localHour = 7;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 am")
        localHour = 8;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 am")
        localHour = 9;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 am")
        localHour = 10;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 am")
        localHour = 11;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 pm")
        localHour = 12;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 pm")
        localHour = 13;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 pm")
        localHour = 14;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 pm")
        localHour = 15;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 pm")
        localHour = 16;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 pm")
        localHour = 17;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 pm")
        localHour = 18;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 pm")
        localHour = 19;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 pm")
        localHour = 20;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 pm")
        localHour = 21;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 pm")
        localHour = 22;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 pm")
        localHour = 23;
      var startingAngle = 260 - localHour * (360 / 24);
      if (startingAngle < 0) startingAngle += 360;
      // console.log('localHour', localHour);
      // console.log("startingAngle", startingAngle);

      for (var i = 23; i > -1; i--) {
        var colorMapIndex = 0;
        if (hourlyTimeSeries[i] > 0) colorMapIndex = 1;
        if (hourlyTimeSeries[i] > 1) colorMapIndex = 2;
        if (hourlyTimeSeries[i] > 2) colorMapIndex = 3;
        if (hourlyTimeSeries[i] > 5) colorMapIndex = 4;
        if (hourlyTimeSeries[i] > 10) colorMapIndex = 5;
        if (hourlyTimeSeries[i] > 15) colorMapIndex = 6;
        if (hourlyTimeSeries[i] > 20) colorMapIndex = 7;
        totalDetections += hourlyTimeSeries[i];
        var dateText = this.chartOptionsSpeciesHourly.xaxis.categories[i];
        var showLabel = 0;
        var isSliced = 0;
        var dateTextDict = {
          "12:00 am": "midnight",
          "01:00 am": "1am",
          "02:00 am": "2am",
          "03:00 am": "3am",
          "04:00 am": "4am",
          "05:00 am": "5am",
          "06:00 am": "6am",
          "07:00 am": "7am",
          "08:00 am": "8am",
          "09:00 am": "9am",
          "10:00 am": "10am",
          "11:00 am": "11am",
          "12:00 pm": "noon",
          "01:00 pm": "1pm",
          "02:00 pm": "2pm",
          "03:00 pm": "3pm",
          "04:00 pm": "4pm",
          "05:00 pm": "5pm",
          "06:00 pm": "6pm",
          "07:00 pm": "7pm",
          "08:00 pm": "8pm",
          "09:00 pm": "9pm",
          "10:00 pm": "10pm",
          "11:00 pm": "11pm",
        };
        if (dateText == "12:00 am") showLabel = 1;
        if (dateText == "12:00 pm") showLabel = 1;
        if (dateText == "06:00 pm") showLabel = 1;
        if (dateText == "06:00 am") showLabel = 1;
        if (i == 23) isSliced = 1;
        plotData.push({
          label: dateTextDict[dateText],
          value: 100,
          color: colorMap[colorMapIndex],
          showLabel: showLabel,
          isSliced: isSliced,
          tooltext:
            dateTextDict[dateText] + ":" + hourlyTimeSeries[i].toString(),
        });
      }
      // console.log("hourly plotData", plotData);
      // console.log("totalDetections", totalDetections);

      var fusionDataset = {
        chart: {
          caption: "Past 24h",
          numberPrefix: "",
          bgColor: "#ffffff",
          startingAngle: startingAngle.toString(),
          showLegend: "0",
          enableSmartLabels: "1",
          showLabels: "0",
          showValues: "0",
          defaultCenterLabel: totalDetections.toString(),
          centerLabelFontSize: "18",
          centerLabelBold: "1",
          enableMultiSlicing: "0",
          animateClockwise: "1",
          showPercentInToolTip: "0",
        },
        data: plotData,
      };
      // console.log("fusionDataset", fusionDataset);
      return fusionDataset;
    },

    async getHeatmap(cn) {
      let nDays = 14;
      var nextToken = null;
      // this.lastUpdated = moment.utc().local().locale(this.selectedLanguage).calendar();
      let startDate, todayDate, refDate;
      var tempHits = [];

      refDate = moment.utc();
      todayDate = moment.utc().format();
      startDate = moment.utc().subtract(nDays, "days").format();
      // console.log(todayDate);
      if (this.recentHours == 0) {
        refDate = moment(this.hitDatePicker).utc();
        todayDate = moment(this.hitDatePicker).utc().format();
        startDate = moment(this.hitDatePicker)
          .utc()
          .subtract(nDays, "days")
          .format();
      }
      // console.log(startDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: startDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);
      // console.log(tempHits);

      // data are in rows; each row is a single hour for all days
      // create empty array with zeros
      var heatmapData = [];

      for (var i = 0; i < 24; i++) {
        const zerosArray = Array(nDays).fill(0); // this needs to be in the loop to clone the array (otherwise all rows end up with same value)
        heatmapData.push(zerosArray);
      }
      // loop through all detections and add to correct hour and day bin
      tempHits.forEach((hit) => {
        // To Do: convert to local time to get correct hour and date bin
        var hourBin = moment.utc(hit["dt"]).tz(this.currentTimezone).hour();
        var hitDate = moment
          .utc(hit["dt"])
          .tz(this.currentTimezone)
          .diff(refDate.tz(this.currentTimezone).endOf("day"), "days");
        let dayBin = nDays + hitDate - 1;

        // increment heatmap
        // console.log('hit["dt"], day hourBin dayBin heatmap cell',hit["dt"], hitDate, hourBin, dayBin);
        heatmapData[hourBin][dayBin] += hit["detectionCount"];
      });

      const formattedDates = [];
      // Loop through the dates and format them as "MMM D" (e.g., "Oct 1", "Oct 2", ...)
      for (let i = nDays - 1; i >= 0; i--) {
        // Assuming you want 31 days for October
        let formattedDate = moment
          .utc()
          .tz(this.currentTimezone)
          .subtract(i, "days")
          .format("MMM D");

        if (this.recentHours == 0) {
          formattedDate = moment(this.hitDatePicker)
            .utc()
            .tz(this.currentTimezone)
            .subtract(i, "days")
            .format("MMM D");
        }
        formattedDates.push(formattedDate);
      }
      const formattedHours = [];
      for (let i = 0; i < 24; i++) {
        formattedHours.push(i + ":" + "00");
      }

      var heatmap = [
        {
          x: formattedDates,
          y: formattedHours,
          z: heatmapData,
          type: "heatmap",
          showscale: true,
          hoverongaps: false,
        },
      ];

      return heatmap;
    },

    // for charts.js plots
    async getDailySpeciesChartsJS(commonName) {
      // query daily table to get time series for year
      // console.log("getDailyCountsBySpecies commonName", commonName);

      var nextToken = null;
      var dailyCounts = [];
      do {
        const dailyCountSummary = await API.graphql({
          query: dailyCountSummaryBySerialBySpecies,
          variables: {
            serial: this.currentSerial,
            cn: { eq: commonName },
            nextToken: nextToken,
          },
        });
        dailyCounts = dailyCounts.concat(
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.items
        );
        nextToken =
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("daily counts", dailyCounts);

      // Create date array in case dates with no results
      let maxDate = moment.utc().format();
      let minDate = moment.utc().subtract(90, "days").format();
      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);
      function getShortDates(startDate, stopDate) {
        var shortDateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          shortDateArray.push(moment(currentDate).format("MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return shortDateArray;
      }
      let shortDateArr = getShortDates(minDate, maxDate);
      // console.log('dateArr', dateArr);
      // console.log('shortDateArr', shortDateArr);

      //
      // dailyCounts is sparse; add missing dates
      //

      // dateList will hold array of all dates to plot
      var dateList = [];
      for (let item in dailyCounts) {
        dateList.push(dailyCounts[item]["countDate"]);
      }
      // console.log('dateList', dateList);

      // create array with zeros
      let countArray = [];
      for (let i = 0; i < countArray.length; i++) {
        countArray.push(0);
      }

      // loop through all dates with counts and subsitute actual count in countArray
      for (let i in dateList) {
        let countIndex = dateArr.indexOf(dateList[i]);
        countArray[countIndex] = dailyCounts[i].countsPerDay;
      }

      //console.log("countArray", countArray);

      var dailyCountPlotData = [];
      for (let item in dateArr) {
        dailyCountPlotData.push([shortDateArr[item], countArray[item]]);
      }
      // console.log("dailyCountPlotData", dailyCountPlotData);
      return dailyCountPlotData;
    },
    // Daily count for fusion charts plot
    async getDailyCountsBySpecies(commonName) {
      // query daily table to get time series for year
      // console.log("getDailyCountsBySpecies commonName", commonName);
      var nextToken = null;
      var dailyCounts = [];
      do {
        const dailyCountSummary = await API.graphql({
          query: dailyCountSummaryBySerialBySpecies,
          variables: {
            serial: this.currentSerial,
            cn: { eq: commonName },
            nextToken: nextToken,
          },
        });
        dailyCounts = dailyCounts.concat(
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.items
        );
        nextToken =
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("daily counts", dailyCounts);

      var dailyCountPlotData = [];

      for (let item in dailyCounts) {
        dailyCountPlotData.push([
          dailyCounts[item]["countDate"],
          dailyCounts[item]["countsPerDay"],
        ]);
      }
      const fusionDataStore = new FusionCharts.DataStore();
      const fusionTable = fusionDataStore.createDataTable(
        dailyCountPlotData,
        this.fusionSchemaDaily
      );
      return fusionTable;
    },
    async getYesterdayCounts(serial) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var nextToken = null;
      var yesterdayCountsAll = [];
      do {
        const returnCount = await API.graphql({
          query: dailyCountSummaryBySerialByDate,
          variables: {
            serial: serial,
            countDate: { eq: yesterdayDate },
            nextToken: nextToken,
          },
        });
        yesterdayCountsAll = yesterdayCountsAll.concat(
          returnCount.data.dailyCountSummaryBySerialByDate.items
        );
        nextToken = returnCount.data.dailyCountSummaryBySerialByDate.nextToken;
      } while (nextToken != null);

      var callsAndSongs = 0;
      var mostFrequent = "";
      var mostFrequentspCode = "";
      var maxCount = 0;
      var speciesCount = 0;
      // console.log("getYesterdayCounts", yesterdayDate, yesterdayCountsAll);
      var dailySummaryList = [];
      for (let i = 0; i < yesterdayCountsAll.length; i++) {
        if (!this.hiddenList.includes(yesterdayCountsAll[i].cn)) {
          dailySummaryList.push(yesterdayCountsAll[i]);
          callsAndSongs += yesterdayCountsAll[i].countsPerDay;
          speciesCount++;
          if (yesterdayCountsAll[i].countsPerDay > maxCount && yesterdayCountsAll[i].cn !== 'Bat') {
            maxCount = yesterdayCountsAll[i].countsPerDay;
            mostFrequent = yesterdayCountsAll[i].cn;
            mostFrequentspCode = yesterdayCountsAll[i].spCode;
          }
        }
      }
      //console.log('dailySummaryList', dailySummaryList);
      // sort list by abundance
      dailySummaryList.sort((a, b) =>
        a.countsPerDay < b.countsPerDay ? 1 : -1
      );
      this.dailySummaryList = dailySummaryList;
      this.dailySummaryDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("dddd, MMMM Do YYYY");

      this.yesterdayNumSpecies = speciesCount;
      this.yesterdayCallsAndSongs = callsAndSongs;
      this.yesterdayMostFrequent = mostFrequent;
      this.yesterdaySpCode = mostFrequentspCode;

      // get change in activity for birds detected yesterdayl
      let twoDaysAgo = moment
        .utc()
        .local()
        .subtract(48, "hours")
        .format("YYYY-MM-DD");

      var moreActiveSpeciesList = [];
      for (let i = 0; i < yesterdayCountsAll.length; i++) {
        // if had at least 10 detections yesterday, check to see if increasing pattern
        if (
          (yesterdayCountsAll[i].countsPerDay > 9) &
          !this.hiddenList.includes(yesterdayCountsAll[i].cn)
        ) {
          let summaryId =
            this.currentSerial +
            "_" +
            yesterdayCountsAll[i].spCode +
            "_" +
            twoDaysAgo;
          const dailyCountSummary = await API.graphql({
            query: getDailyCountSummary,
            variables: { id: summaryId },
          });
          const dailyCounts = dailyCountSummary.data.getDailyCountSummary;
          // console.log(yesterdayCountsAll[i].cn, dailyCounts);
          if (dailyCounts !== null) {
            if (dailyCounts["countsPerDay"] < 4) {
              // console.log("more active species", yesterdayCountsAll[i].cn);
              moreActiveSpeciesList.push(yesterdayCountsAll[i]);
            }
          } else {
            // console.log("more active species", yesterdayCountsAll[i].cn);
            moreActiveSpeciesList.push(yesterdayCountsAll[i]);
          }
        }
        this.moreActiveSpeciesList = moreActiveSpeciesList.slice(0, 3);
      }
    },
    hitSelectDate() {
      // console.log('hitsSelectRange');
      if (this.hitCalendarDatePicked == false) {
        this.hitCalendarDatePicked = true; // hide calendar
      } else {
        this.hitCalendarDatePicked = false; // show calendar
        this.recentHours = 0;
      }
    },
    hitDateClick() {
      // console.log('hitDateClick', this.hitDatePicker);
      this.logClick("calendar", "", "");
      this.hitCalendarDatePicked = true; // hide calendar
      this.changeRecentHours(0);
    },
    setViewSettings(viewSetting) {
      // console.log("setViewSettings", viewSetting);
      this.viewSettings = viewSetting;
      this.logClick("setViewSettings_" + viewSetting, "", "");
      if (viewSetting == "Low") {
        this.confidenceThreshold = 0.0;
        this.specSumThreshold = -1;
      }
      if (viewSetting == "Medium") {
        this.confidenceThreshold = 0.4;
        this.specSumThreshold = 2;
      }
      if (viewSetting == "High") {
        this.confidenceThreshold = 0.9;
        this.specSumThreshold = 6;
      }
      localStorage.setItem("haikuboxConfidence", viewSetting);
      this.clickRefresh(this.currentSerial);
    },
    setViewConfidence(viewSetting) {
      // console.log("setViewConfidence", viewSetting);
      if (viewSetting == "Low") {
        this.confidenceThreshold = 0.0;
        this.specSumThreshold = -1;
      }
      if (viewSetting == "Medium") {
        this.confidenceThreshold = 0.4;
        this.specSumThreshold = 2;
      }
      if (viewSetting == "High") {
        this.confidenceThreshold = 0.9;
        this.specSumThreshold = 6;
      }
    },
    async getHits(serialClicked) {
      //console.log("getHits", serialClicked);
      var nextToken = null;
      this.lastUpdated = moment
        .utc()
        .local()
        .locale(this.selectedLanguage)
        .calendar();
      let yesterdayDate;
      var tempHits = [];
      var tempHits2 = [];

      if (this.recentHours > 0) {
        yesterdayDate = moment
          .utc()
          .subtract(this.recentHours, "hours")
          .format();
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { gt: yesterdayDate },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      if (this.recentHours == 0) {
        let startDate = moment(this.hitDatePicker)
          .tz(this.currentTimezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(startDate)
          .add(24, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
        // console.log('query hits ', startDate, endDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { between: [startDate, endDate] },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }

      // Fetch labels from labeledData table to show previously labeled detections
      // Key is wav + spCode to handle 30s clips with multiple species
      // Store both label and createdAt to keep only the most recent label
      const labelMap = {};
      const labelTimestamps = {};
      try {
        let labelNextToken = null;
        do {
          const labelQuery = await API.graphql({
            query: labelBySerialByCn,
            variables: {
              serial: serialClicked,
              limit: 1000,
              nextToken: labelNextToken,
            },
          });
          const labelItems = labelQuery.data.labelBySerialByCn.items;
          for (const item of labelItems) {
            if (item.wav && item.label && item.spCode) {
              const key = item.wav + "_" + item.spCode;
              const itemTime = item.createdAt || "";
              // Only update if this is the first label or more recent than existing
              if (!labelTimestamps[key] || itemTime > labelTimestamps[key]) {
                labelMap[key] = item.label;
                labelTimestamps[key] = itemTime;
              }
            }
          }
          labelNextToken = labelQuery.data.labelBySerialByCn.nextToken;
        } while (labelNextToken != null);
      } catch (err) {
        console.log("Error fetching labels:", err);
      }

      // filter allHits
      // console.log('tempHits', tempHits);

      for (var i = 0; i < tempHits.length; i++) {
        if (
          !this.hiddenList.includes(tempHits[i].cn) &
          (tempHits[i].wav != "")
        ) {
          if (
            tempHits[i].score > this.confidenceThreshold &&
            tempHits[i].specSum > this.specSumThreshold
          )
            tempHits2.push(tempHits[i]);
        }
      }

      // console.log('tempHits2', tempHits2);
      this.allHits = tempHits2;

      // keep track of species in list and put wav files in list
      var speciesHits = [];
      var uniqueHits = [];
      var speciesDict = {};
      var counter = 0;

      for (i = 0; i < tempHits2.length; i++) {
        // var splitWav = tempHits2[i]["wav"].split("_");
        //var wavTimeStamp = splitWav[3].slice(0, -5);
        var wavTimeStamp = tempHits2[i].dt;
        // console.log(wavTimeStamp, this.currentTimezone)
        // let wavTimeMoment = moment(wavTimeStamp).fromNow();
        var wavTimeMoment = moment
          .utc(wavTimeStamp)
          .tz(this.currentTimezone)
          .locale(this.selectedLanguage)
          .format("ll LTS");

        // console.log(splitWav, wavTimeStamp);
        // console.log(wavTimeMoment);

        // use for quick check of low scores
        // var listname = "L " + tempHits2[i].score) + ' ' + wavTimeMoment;
        var listname = "L " + wavTimeMoment;
        if ((tempHits2[i].score > 0.4) & (tempHits2[i].specSum > 2)) {
          listname = "M " + wavTimeMoment;
        }
        if (tempHits2[i].score > 0.9 && tempHits2[i].specSum > 6) {
          listname = "H " + wavTimeMoment;
        }

        if (
          tempHits2[i].score < 0.4 &&
          (tempHits2[i].version.slice(-1) == "D") |
            (tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "L. " + wavTimeMoment;
        }

        if (
          tempHits2[i].score > 0.4 &&
          tempHits2[i].specSum > 3 &&
          (tempHits2[i].version.slice(-1) == "D") |
            (tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "M. " + wavTimeMoment;
        }
        if (
          tempHits2[i].score > 0.9 &&
          tempHits2[i].specSum > 5 &&
          (tempHits2[i].version.slice(-1) == "D") |
            (tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "H. " + wavTimeMoment;
        }

        // Append label if previously labeled (from labeledData table)
        // Use wav + spCode as key to handle 30s clips with multiple species
        const labelKey = tempHits2[i].wav + "_" + tempHits2[i].spCode;
        if (labelMap[labelKey]) {
          listname = listname + " - " + labelMap[labelKey];
        }

        if (!speciesHits.includes(tempHits2[i].cn)) {
          speciesHits.push(tempHits2[i].cn);
          speciesDict[tempHits2[i].cn] = counter;
          uniqueHits.push(tempHits2[i]);
          uniqueHits[counter].wavList = [
            {
              filename: tempHits2[i]["wav"],
              listname: listname,
              dt: tempHits2[i]["dt"],
              score: tempHits2[i]["score"],
              specSum: tempHits2[i]["specSum"],
              offset: this.extractOffsetFromWav(
                tempHits2[i]["wav"],
                tempHits2[i]["dt"],
                tempHits2[i]
              ), // Pass the hit item
              createdAt: tempHits2[i]["createdAt"], // Also store createdAt for later use
            },
          ];
          uniqueHits[counter].currentWav = {
            filename: tempHits2[i]["wav"],
            listname: listname,
            dt: tempHits2[i]["dt"],
            score: tempHits2[i]["score"],
            specSum: tempHits2[i]["specSum"],
            offset: this.extractOffsetFromWav(
              tempHits2[i]["wav"],
              tempHits2[i]["dt"],
              tempHits2[i]
            ), // Pass the hit item
            createdAt: tempHits2[i]["createdAt"], // Also store createdAt for later use
          };
          uniqueHits[counter].playbackIndex = 0;
          uniqueHits[counter].window = "image";
          uniqueHits[counter].showBird = true;
          uniqueHits[counter].notifyBird = false;
          uniqueHits[counter].loadingSpectrogram = false;
          uniqueHits[counter].spectrogram = null;
          counter = counter + 1;
        } else {
          uniqueHits[speciesDict[tempHits2[i].cn]]["wavList"].push({
            filename: tempHits2[i]["wav"],
            listname: listname,
            dt: tempHits2[i]["dt"],
            score: tempHits2[i]["score"],
            specSum: tempHits2[i]["specSum"],
            offset: this.extractOffsetFromWav(
              tempHits2[i]["wav"],
              tempHits2[i]["dt"],
              tempHits2[i]
            ), // Pass the hit item
            createdAt: tempHits2[i]["createdAt"], // Also store createdAt for later use
          });
        }
      }
      // console.log('speciesHits', speciesHits);
      // console.log('speciesDict', speciesDict);
      // console.log("uniqueHits", uniqueHits);

      // If only 1 wav file for a species and confidence is set to MED or HIGH remove from list
      if (this.confidenceThreshold >= 0.4) {
        for (i = uniqueHits.length - 1; i >= 0; i--) {
          if (uniqueHits[i].wavList.length == 1) {
            // console.log("delete single detection", uniqueHits[i].cn);
            uniqueHits.splice(i, 1); // remove and shift object
          }
        }
      } else {
        // If only 1 wav file for a species and confidence is set to LOW, change confidence to LOW
        for (i = uniqueHits.length - 1; i >= 0; i--) {
          if (uniqueHits[i].wavList.length == 1) {
            var listname = uniqueHits[i].wavList[0].listname;
            var listnameL = "L" + listname.slice(1);
            uniqueHits[i].wavList[0].listname = listnameL;
          }
        }
      }

      // Check if clips > 3s (only for active subscriptions)
      if (uniqueHits.length > 0) {
        this.maxClipSeconds = 3;

        // Only allow longer clips for active subscriptions
        if (this.subscriptionActive) {
          // Check for ANY files that support longer clips (not just the first one)
          const hasLongFiles = uniqueHits.some(hit => {
            const wav = hit.wav || '';
            // P files, p files (12 second files), or marine files
            if (wav[5] == "P" || wav[0] == "p" || wav.includes("M")) {
              return true;
            }
            // Backblaze files (starts with bb/) support long clips, except bat files
            if (wav.startsWith("bb/") && hit.cn !== 'Bat') {
              return true;
            }
            return false;
          });

          if (hasLongFiles) {
            this.maxClipSeconds = 12;
            // console.log('Detected long files, setting maxClipSeconds to 12');
          }
        }

        // Cap clipSeconds to maxClipSeconds
        if (this.clipSeconds > this.maxClipSeconds) {
          this.clipSeconds = this.maxClipSeconds;
        }
      }

      // query hidden list for this Haikubox
      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: this.currentSerial,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }

      // query notify birds
      var nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: this.currentSerial,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }

      // update hits with notifyBird
      for (i in uniqueHits) {
        if (customNotifyList.includes(uniqueHits[i].cn)) {
          uniqueHits[i].notifyBird = true;
          // console.log("notify index and species", i, uniqueHits[i]);
        }
      }

      // update hits with showBird and
      for (i = uniqueHits.length - 1; i >= 0; i--) {
        // console.log("unique hits", i, uniqueHits[i].cn)
        if (customHiddenList.includes(uniqueHits[i].cn)) {
          // console.log("hide bird", uniqueHits[i].cn)
          uniqueHits.splice(i, 1);
        }
      }

      // query favorites
      for (i = uniqueHits.length - 1; i >= 0; i--) {
        uniqueHits[i].favoriteHit = false;
        // console.log(uniqueHits[i].currentWav.filename);
        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: uniqueHits[i].wav,
          },
        });
        if (favoriteHit.data.getFavoriteHit != null) {
          uniqueHits[i].favoriteHit = true;
          // console.log('getHits favorite', favoriteHit);
        }
      }

      this.hits = uniqueHits; // this.hits is what is looped through to show cards
      // console.log("hits", this.hits);
      this.hitsLoading = 0; // hide hits loading counter
    },
    async getAll(serial) {
      this.seriesDaily = [];
      var startYear = "2022";
      // console.log("getAll", currentYear);

      var nextToken = null;
      var yearlyCountsAll = [];

      do {
        const returnCount = await API.graphql({
          query: yearlyCountSummaryBySerialByYear,
          variables: {
            serial: serial,
            countYear: { ge: startYear },
            nextToken: nextToken,
          },
        });
        yearlyCountsAll = yearlyCountsAll.concat(
          returnCount.data.yearlyCountSummaryBySerialByYear.items
        );
        nextToken = returnCount.data.yearlyCountSummaryBySerialByYear.nextToken;
      } while (nextToken != null);

      // console.log("yearly counts All", yearlyCountsAll);
      // sum and remove duplicates to get total
      var k = 0;
      while (k < yearlyCountsAll.length) {
        for (let i = yearlyCountsAll.length - 1; i > k; i--) {
          // if found a match add count and remove match
          if (yearlyCountsAll[k].cn == yearlyCountsAll[i].cn) {
            yearlyCountsAll[k].countsTotal += yearlyCountsAll[i].countsTotal;
            yearlyCountsAll.splice(i, 1);
          }
        }
        k++;
        // console.log(k);
      }

      // sort by totalCount
      yearlyCountsAll.sort(function (a, b) {
        var keyA = a.countsTotal,
          keyB = b.countsTotal;
        // Compare the 2 counts
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });
      // console.log("yearly counts All sorted", yearlyCountsAll);

      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: this.currentSerial,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }
      // console.log('customHiddenList', customHiddenList);

      // query notify birds
      var nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: this.currentSerial,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }
      // remove hidden birds and set showBird and notifyBird
      for (let i = yearlyCountsAll.length - 1; i >= 0; i--) {
        if (this.hiddenList.includes(yearlyCountsAll[i].cn)) {
          yearlyCountsAll.splice(i, 1);
        } else {
          yearlyCountsAll[i].showBird = true;
          if (customHiddenList.includes(yearlyCountsAll[i].cn))
            yearlyCountsAll[i].showBird = false;
          yearlyCountsAll[i].notifyBird = false;
          if (customNotifyList.includes(yearlyCountsAll[i].cn)) {
            yearlyCountsAll[i].notifyBird = true;
          }
        }
      }
      var dailyDataSource = {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Count",
          },
        ],
      };
      this.allSpeciesList = [];
      this.speciesSelected = "";
      this.scrolledToBottom = false;
      for (let i in yearlyCountsAll) {
        yearlyCountsAll[i].dataSource = { ...dailyDataSource }; //spread operator to make deep copy
        this.allSpeciesList.push(
          this.t(yearlyCountsAll[i].spCode, yearlyCountsAll[i].cn)
        );
      }
      this.seriesDaily = yearlyCountsAll;
      // console.log('yearlyCountsAll', yearlyCountsAll);
      // console.log("seriesDaily", this.seriesDaily);
    },
    async getMapCountsPerSpecies(commonName) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var tempHits = [];
      var nextToken = null;
      do {
        const queryHits = await API.graphql({
          query: dailyCountSummaryByDateBySpecies,
          variables: {
            cn: { eq: commonName },
            countDate: yesterdayDate,
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(
          queryHits.data.dailyCountSummaryByDateBySpecies.items
        );
        nextToken = queryHits.data.dailyCountSummaryByDateBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("getMapCountsPerSpecies tempHits", tempHits);
      var mapHits = [];
      for (let i = 0; i < tempHits.length; i++) {
        let mapCount = {
          lat: tempHits[i].lat,
          lon: tempHits[i].lon,
          radius: tempHits[i].countsPerDay * 100,
        };
        mapHits.push(mapCount);
      }
      return mapHits;
    },
    float2int(value) {
      return value | 0;
    },
    extractOffsetFromWav(wavFile, detectionTime, hitItem) {
      // Compute offset = seconds into the file where the detection occurred.
      // createdAt = recording start time (written by lambda as Vorbis TIMESTAMP)
      // dt = detection time
      // offset = dt - createdAt
      const filename = wavFile.split("/").pop();
      const match = filename.match(/_(\d+)\.flac$/);

      // Path 1: Use createdAt (recording start) from hit row
      if (match && hitItem && hitItem.createdAt && hitItem.dt) {
        const fileStartUnix = Math.floor(
          new Date(hitItem.createdAt).getTime() / 1000
        );
        const detectionUnix = Math.floor(new Date(hitItem.dt).getTime() / 1000);
        const offset = detectionUnix - fileStartUnix;

        if (offset >= 0) {
          return offset;
        }
        return null;
      }

      // Path 2: createdAt missing — return null, playFile will use filename fallback
      return null;
    },

    // Parse Vorbis TIMESTAMP from FLAC metadata bytes (fallback for missing createdAt)
    parseVorbisTimestamp(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);
        if (view.byteLength < 42) return null;
        const magic = String.fromCharCode(
          view.getUint8(0), view.getUint8(1), view.getUint8(2), view.getUint8(3)
        );
        if (magic !== 'fLaC') return null;

        // Walk metadata blocks starting at byte 4
        let pos = 4;
        while (pos < view.byteLength && pos < 65536) {
          const header = view.getUint8(pos);
          const isLast = (header & 0x80) !== 0;
          const blockType = header & 0x7F;
          const blockLen = (view.getUint8(pos + 1) << 16) |
                           (view.getUint8(pos + 2) << 8) |
                           view.getUint8(pos + 3);
          pos += 4;

          if (blockType === 4) {
            // VORBIS_COMMENT block — little-endian strings
            let offset = pos;
            const vendorLen = view.getUint32(offset, true);
            offset += 4 + vendorLen;
            const commentCount = view.getUint32(offset, true);
            offset += 4;

            for (let i = 0; i < commentCount; i++) {
              if (offset + 4 > view.byteLength) break;
              const commentLen = view.getUint32(offset, true);
              offset += 4;
              if (offset + commentLen > view.byteLength) break;

              let comment = '';
              for (let j = 0; j < commentLen; j++) {
                comment += String.fromCharCode(view.getUint8(offset + j));
              }
              offset += commentLen;

              if (comment.toUpperCase().startsWith('TIMESTAMP=')) {
                const ts = parseInt(comment.split('=')[1]);
                if (!isNaN(ts)) {
                  return ts;
                }
              }
            }
          }

          pos += blockLen;
          if (isLast) break;
        }
      } catch (err) {
      }
      return null;
    },
    async setWindowRecent(index, value, spCode, commonName) {
      this.logClick("setWindowRecent_" + value, spCode, commonName);

      if (value == "daily") {
        this.hits[index].hourlyCountPlotData = await this.getHourlySpecies(
          commonName
        );
      }
      if (value == "monthly") {
        this.hits[index].dailyCountPlotData =
          await this.getDailySpeciesChartsJS(commonName);
      }
      if (value == "heatmap") {
        this.hits[index].heatmap = await this.getHeatmap(commonName);
      }
      if (value == "map") {
        this.hits[index].map = await this.getMapCountsPerSpecies(commonName);
      }
      this.hits[index].window = value;
      this.$forceUpdate();
      // this.hits[index].id += 1; // increment ID so that component updates
      // console.log('setWindowRecent', this.hits[index]);
      // console.log("setWindowRecent", commonName, this.hits[index]);
    },
    async setWindowAll(index, value, spCode, commonName) {
      this.logClick("setWindowAll_" + value, spCode, commonName);
      // console.log("setWindowAll", index, value, commonName);
      if (this.seriesDaily[index].window == value)
        this.seriesDaily[index].window = "none";
      // toggle view
      else {
        if (value == "monthly") {
          this.seriesDaily[index].dataSource.data =
            await this.getDailyCountsBySpecies(commonName);
        }
        this.seriesDaily[index].window = value;
      }
      this.seriesDaily[index].id += 1; // increment ID so that component updates
      // console.log("setWindowAll", this.seriesDaily[index]);
    },
    setWindowNew(index, value) {
      this.newSpeciesList[index].window = value;
      this.newSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    setWindowMissing(index, value) {
      this.missingSpeciesList[index].window = value;
      this.missingSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    async getNotices() {
      const userNotices = await API.graphql({
        query: userNoticeByOwnerByViewed,
        variables: {
          owner: this.user,
          noticeViewed: { eq: "False" },
        },
      });
      // console.log(userNotices.data.userNoticeByOwnerByViewed.items);
      var tempNotices = userNotices.data.userNoticeByOwnerByViewed.items;
      var tempNoticeDescriptions = [];
      for (var i = 0; i < tempNotices.length; i++) {
        const nD = await API.graphql({
          query: getNoticeDescription,
          variables: {
            id: tempNotices[i].noticeID,
          },
        });
        // console.log(nD.data.getNoticeDescription);
        tempNoticeDescriptions.push(nD.data.getNoticeDescription);
      }
      this.userNotices = tempNoticeDescriptions;
    },
    async acknowledgeNotice(noticeID) {
      // set notice to True (read)
      var id = noticeID + "-" + this.user;
      var owner = this.user;
      var noticeViewed = "True";
      const noticeData = {
        id,
        owner,
        noticeViewed,
      };

      await API.graphql({
        query: updateUserNotice,
        variables: { input: noticeData },
      });

      this.getNotices(); // this will clear the notice
    },
    async getWavFileName(index, spCode, cn, pageType, pipeTo, audioFile) {
      //console.log(audioFile)
      // hitsBySpecies
      if (pageType === "Increasing") {
        // To Do:
        // move increasing into yesterday summary)
      }

      if ((audioFile != "") & (pipeTo === "spectrogram"))
        this.spectrogram(index, audioFile, pageType);
      if ((audioFile != "") & (pipeTo === "play"))
        this.playFile(audioFile, spCode, cn);
    },

    // Add these helper methods before the spectrogram() method
    generateHannWindow(length) {
      const window = new Float32Array(length);
      for (let i = 0; i < length; i++) {
        window[i] = 0.5 * (1 - Math.cos((2 * Math.PI * i) / (length - 1)));
      }
      return window;
    },

    // Apply cosine-squared ramp to signal to prevent clicks at start/end
    applyCos2Ramp(signal, sampleRate, rampDurationMs = 5) {
      // Calculate ramp length in samples (default 5ms)
      const rampLength = Math.floor((rampDurationMs / 1000) * sampleRate);
      const effectiveRampLength = Math.min(rampLength, Math.floor(signal.length / 2));

      // Apply fade-in (cos² ramp at the beginning)
      for (let i = 0; i < effectiveRampLength; i++) {
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle); // sin²(x) = cos²(π/2 - x)
        signal[i] *= ramp;
      }

      // Apply fade-out (cos² ramp at the end)
      for (let i = 0; i < effectiveRampLength; i++) {
        const idx = signal.length - 1 - i;
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle);
        signal[idx] *= ramp;
      }

      return signal;
    },

    getOptimalFFTLength(sampleRate) {
      const fftLengthMap = {
        8000: 256, // 32ms window, 31.25 Hz/bin
        16000: 512, // 32ms window, 31.25 Hz/bin
        22050: 512, // 23.2ms window, 43.07 Hz/bin
        24000: 512, // 21.3ms window, 46.88 Hz/bin
        32000: 1024, // 32ms window, 31.25 Hz/bin
        44100: 1024, // 23.2ms window, 43.07 Hz/bin
        48000: 1024, // 21.3ms window, 46.88 Hz/bin
      };

      // Find closest sample rate in map
      const rates = Object.keys(fftLengthMap)
        .map(Number)
        .sort((a, b) => a - b);
      let closestRate = rates[0];

      for (const rate of rates) {
        if (Math.abs(sampleRate - rate) < Math.abs(sampleRate - closestRate)) {
          closestRate = rate;
        }
      }

      return fftLengthMap[closestRate] || 512; // Default to 512
    },

    // Helper method to decode audio data with promise wrapper
    decodeAudioData(audioContext, arrayBuffer) {
      return new Promise((resolve, reject) => {
        audioContext.decodeAudioData(
          arrayBuffer,
          (buffer) => resolve(buffer),
          (error) => reject(error)
        );
      });
    },

    async playFileEnhance(audioFile, spCode, cn, _id, item) {
      this.logClick("playFileEnhance", spCode, cn);

      // Stop any currently playing audio
      if (this.currentPlayingItem) {
        this.currentPlayingItem.isPlaying = false;
        this.currentPlayingItem.playbackProgress = 0;
      }

      if (this.currentAudioSource) {
        this.currentAudioSource.stop();
        this.currentAudioSource = null;
      }

      if (this.playbackInterval) {
        clearInterval(this.playbackInterval);
        this.playbackInterval = null;
      }

      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      // Playing last file again - use cached context to preserve pitch shifting
      // Use audioFile as cache key (not id) since id stays same when selecting different recordings
      if (this.lastEnhancedFile == audioFile && this.lastEnhancedContext) {
        const cachedContext = this.lastEnhancedContext;
        const sourceNode = cachedContext.createBufferSource();
        sourceNode.buffer = this.lastEnhancedAudio;
        sourceNode.connect(cachedContext.destination);

        // Set up playback tracking for cached audio
        item.isPlaying = true;
        item.isPlayingEnhance = true;
        item.playbackProgress = 0;
        this.currentPlayingItem = item;
        this.currentAudioSource = sourceNode;

        const playbackStartTime = cachedContext.currentTime;
        // Use actual buffer duration (already trimmed and pitch-shifted)
        const playbackDuration = this.lastEnhancedAudio.duration;

        // Update progress during playback
        this.playbackInterval = setInterval(() => {
          const elapsed = cachedContext.currentTime - playbackStartTime;
          const adjustedElapsed = elapsed + 0.04; // Compensate for lag
          const progress = Math.min(
            (adjustedElapsed / playbackDuration) * 100,
            100
          );

          if (progress >= 100 || !item.isPlaying) {
            item.isPlaying = false;
            item.isPlayingEnhance = false;
            item.playbackProgress = 0;
            if (this.playbackInterval) {
              clearInterval(this.playbackInterval);
              this.playbackInterval = null;
            }
            this.currentPlayingItem = null;
            this.currentAudioSource = null;
          } else {
            item.playbackProgress = progress;
          }
          this.$forceUpdate();
        }, 25);

        // Handle playback end
        sourceNode.onended = () => {
          item.isPlaying = false;
          item.isPlayingEnhance = false;
          item.playbackProgress = 0;
          if (this.playbackInterval) {
            clearInterval(this.playbackInterval);
            this.playbackInterval = null;
          }
          this.currentPlayingItem = null;
          this.currentAudioSource = null;
          this.$forceUpdate();
        };

        // Play the full cached buffer (don't limit by clipSeconds - buffer is already trimmed and pitch-shifted)
        sourceNode.start(0);
        return;
      }

      try {
        // Get audio URL based on file prefix
        var audioUrl;
        if (audioFile[0] == "b") {
          audioUrl = await this.getAudioUrl(audioFile);
        } else {
          audioUrl = await Storage.get(audioFile);
        }

        // Fetch and decode with proper sample rate handling
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();

        // Detect the native sample rate
        let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);
        if (!detectedSampleRate) {
          detectedSampleRate = await this.getAudioSampleRate(
            audioUrl,
            arrayBuffer
          );
        }

        // Get or create matching audio context
        const audioContext = await this.getMatchingAudioContext(
          detectedSampleRate || 44100
        );
        const sample = await this.decodeAudioData(
          audioContext,
          arrayBuffer.slice(0)
        );

        // Store audio duration on the item for UI controls
        if (item && !item.audioDuration) {
          item.audioDuration = sample.duration;

          // Update maxClipSeconds if we found a long file
          const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
          if (hasLongFile && this.maxClipSeconds <= 3) {
            this.maxClipSeconds = 12;
            console.log('Detected loaded file > 3s in playFileEnhance, setting maxClipSeconds to 12');
          }
        }

        let origSignal = sample.getChannelData(0);
        var signal;
        let startTime = 0;

        // Fast path for bat files: skip STFT enhancement, just pitch shift
        const isBatFile = detectedSampleRate >= 176400;
        if (isBatFile) {
          signal = origSignal;
          const outputSampleRate = Math.round(sample.sampleRate / 10);

          // Normalize
          const peak = signal.reduce((acc, val) => Math.max(acc, Math.abs(val)), 0);
          const gain = peak > 0 ? 0.8 / peak : 1;

          // Create buffer at lower sample rate for pitch shift
          const audioBuffer = audioContext.createBuffer(1, signal.length, outputSampleRate);
          const channelData = audioBuffer.getChannelData(0);
          for (let i = 0; i < signal.length; i++) {
            channelData[i] = signal[i] * gain;
          }

          // Apply cos² ramp
          this.applyCos2Ramp(channelData, outputSampleRate, 5);

          const sourceNode = audioContext.createBufferSource();
          sourceNode.buffer = audioBuffer;
          sourceNode.connect(audioContext.destination);

          item.isPlaying = true;
          item.isPlayingEnhance = true;
          item.playbackProgress = 0;
          this.currentPlayingItem = item;
          this.currentAudioSource = sourceNode;

          const playbackStartTime = audioContext.currentTime;
          const playbackDuration = audioBuffer.duration;

          this.playbackInterval = setInterval(() => {
            const elapsed = audioContext.currentTime - playbackStartTime;
            const progress = Math.min(((elapsed + 0.04) / playbackDuration) * 100, 100);
            if (progress >= 100 || !item.isPlaying) {
              item.isPlaying = false;
              item.isPlayingEnhance = false;
              item.playbackProgress = 0;
              if (this.playbackInterval) { clearInterval(this.playbackInterval); this.playbackInterval = null; }
              this.currentPlayingItem = null;
              this.currentAudioSource = null;
            } else {
              item.playbackProgress = progress;
            }
            this.$forceUpdate();
          }, 25);

          sourceNode.onended = () => {
            item.isPlaying = false;
            item.isPlayingEnhance = false;
            item.playbackProgress = 0;
            if (this.playbackInterval) { clearInterval(this.playbackInterval); this.playbackInterval = null; }
            this.currentPlayingItem = null;
            this.currentAudioSource = null;
            this.$forceUpdate();
          };

          sourceNode.start(0);
          this.lastEnhancedFile = audioFile;
          this.lastEnhancedAudio = audioBuffer;
          this.lastEnhancedContext = audioContext;
          return;
        }

        // Define the start and end times (in seconds) - same logic as playFile
        if (
          (audioFile[5] == "P") | (audioFile[0] == "p") ||
          sample.duration > 3
        ) {
          // Check if we have a numeric offset from extractOffsetFromWav (uses createdAt)
          if (
            item.currentWav &&
            typeof item.currentWav.offset === 'number'
          ) {
            startTime = item.currentWav.offset - this.clipSeconds / 2;
          } else {
            // Fallback: filename_unix − duration
            const filename = audioFile.split("/").pop();
            const match = filename.match(/_(\d+)\.flac$/);

            if (match && item.dt) {
              const fileEndTimestamp = parseInt(match[1]);
              const fileStartTimestamp = fileEndTimestamp - sample.duration;
              const detectionUnixTime = Math.floor(Date.parse(item.dt) / 1000);
              const offset = detectionUnixTime - fileStartTimestamp;

              if (offset >= 0 && offset <= sample.duration) {
                startTime = offset - this.clipSeconds / 2;
              }
            }
          }

          // Ensure startTime is within bounds
          if (startTime < 0) startTime = 0;
          if (startTime + this.clipSeconds > sample.duration) {
            startTime = sample.duration - this.clipSeconds;
          }
          if (startTime < 0) startTime = 0;

          // Convert time to sample indices
          var startSample = Math.floor(startTime * sample.sampleRate);
          var endSample = Math.floor(
            (startTime + this.clipSeconds) * sample.sampleRate
          );

          // Check if playback beyond end of clip
          if (endSample > sample.length) {
            endSample = sample.length - 1;
            startSample = endSample - this.clipSeconds * sample.sampleRate;
            if (startSample < 0) startSample = 0;
          }

          signal = origSignal.slice(startSample, endSample);
        } else {
          signal = origSignal;
        }

        // Define STFT parameters (enhancement code remains the same)
        const fftSize = 512;
        const overlap = 256;
        const hopSize = fftSize - overlap;

        // Compute the STFT
        const stft = [];
        var meanMag = new Array(fftSize).fill(0);
        var stdMag = new Array(fftSize).fill(0);
        var numStrides = 0;

        // Generate Hann window
        const hann = this.generateHannWindow(fftSize);

        for (let i = 0; i < signal.length - fftSize; i += hopSize) {
          const frame = signal.slice(i, i + fftSize);
          // Hanning Window
          for (var k = 0; k < fftSize; k++) {
            frame[k] = frame[k] * hann[k];
          }
          var phasors = fft(frame);
          // store running sum of magnitude to calculate mean
          for (var j = 0; j < phasors.length; j++) {
            meanMag[j] += Math.sqrt(
              phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
            );
          }
          numStrides++;
          stft.push([...phasors]);
        }
        for (let j = 0; j < fftSize; j++) {
          meanMag[j] = meanMag[j] / numStrides;
        }

        // calculate SD
        for (let i = 0; i < stft.length; i++) {
          for (let j = 0; j < fftSize; j++) {
            let magnitude =
              Math.sqrt(
                stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
              ) - meanMag[j];
            stdMag[j] += magnitude * magnitude;
          }
        }
        for (j = 0; j < fftSize; j++) {
          stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
        }

        // gate values based on mean + 2*SD with temporal smoothing
        // Track smoothed gain per frequency bin to prevent rapid on/off switching
        const smoothedGain = new Array(fftSize).fill(1.0);
        const smoothingFactor = 0.7; // Higher = smoother (less responsive), Lower = more responsive

        for (let i = 0; i < stft.length - 4; i++) {
          for (let j = 0; j < fftSize; j++) {
            let magnitude =
              (Math.sqrt(
                stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
              ) +
                Math.sqrt(
                  stft[i + 1][j][0] * stft[i + 1][j][0] +
                    stft[i + 1][j][1] * stft[i + 1][j][1]
                ) +
                Math.sqrt(
                  stft[i + 2][j][0] * stft[i + 2][j][0] +
                    stft[i + 2][j][1] * stft[i + 2][j][1]
                ) +
                Math.sqrt(
                  stft[i + 3][j][0] * stft[i + 3][j][0] +
                    stft[i + 3][j][1] * stft[i + 3][j][1]
                ) +
                Math.sqrt(
                  stft[i + 4][j][0] * stft[i + 4][j][0] +
                    stft[i + 4][j][1] * stft[i + 4][j][1]
                )) /
              5;

            // Determine target gain based on threshold
            let targetGain = 1.0;
            if (magnitude < meanMag[j] + 1.5 * stdMag[j]) {
              targetGain = 0.25;
            }
            if (j < 4) {
              targetGain = 0.25;
            }

            // Smooth the gain over time to prevent warble
            smoothedGain[j] = smoothingFactor * smoothedGain[j] + (1 - smoothingFactor) * targetGain;

            // Apply smoothed gain
            stft[i][j][0] *= smoothedGain[j];
            stft[i][j][1] *= smoothedGain[j];
            stft[i][fftSize - 1 - j][0] *= smoothedGain[j];
            stft[i][fftSize - 1 - j][1] *= smoothedGain[j];
          }
        }

        // Compute the ISTFT with proper synthesis window and normalization
        let recoveredSignal = new Array(signal.length).fill(0);
        let windowSum = new Array(signal.length).fill(0); // Track window overlap for normalization
        let recoveredSignalComplex = new Array(fftSize);

        for (let i = 0; i < stft.length - 4; i++) {
          recoveredSignalComplex = ifft(stft[i]);
          for (let j = 0; j < fftSize; j++) {
            const outIdx = i * hopSize + j;
            if (outIdx < signal.length) {
              // Apply synthesis window and accumulate
              recoveredSignal[outIdx] += recoveredSignalComplex[j][0] * hann[j];
              windowSum[outIdx] += hann[j] * hann[j]; // Track squared window sum
            }
          }
        }

        // Normalize by the overlap-add window sum
        for (let i = 0; i < recoveredSignal.length; i++) {
          if (windowSum[i] > 0.001) {
            recoveredSignal[i] /= windowSum[i];
          }
        }

        var maxSignal = 0;
        for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
          var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
          if (tempMax > maxSignal) {
            maxSignal = tempMax;
          }
        }
        var maxSignal = 0.9 / maxSignal;

        // Normalize the signal
        for (let i = 0; i < recoveredSignal.length; i++) {
          recoveredSignal[i] = recoveredSignal[i] * maxSignal;
        }

        // Apply cos² ramp to prevent clicks at start/end
        this.applyCos2Ramp(recoveredSignal, sample.sampleRate, 5);

        // Check if this is a 192 kHz file that needs pitch shifting
        const is192k = detectedSampleRate >= 176400; // 176.4 kHz or 192 kHz
        let outputSampleRate = sample.sampleRate;

        if (is192k) {
          // For 192 kHz files, pitch shift down by factor of 10
          // This makes 96 kHz content sound like 8 kHz (96000 / 10 = 9600)
          outputSampleRate = Math.round(sample.sampleRate / 10);
          // console.log(`Pitch shifting: ${sample.sampleRate}Hz -> ${outputSampleRate}Hz (12x down)`);
        }

        // Create an AudioBuffer from the audio data
        const audioBuffer = audioContext.createBuffer(
          1,
          recoveredSignal.length,
          outputSampleRate
        );
        const channelData = audioBuffer.getChannelData(0);
        for (let i = 0; i < recoveredSignal.length; i++) {
          channelData[i] = recoveredSignal[i];
        }

        // Create an AudioBufferSourceNode
        const sourceNode = audioContext.createBufferSource();
        sourceNode.buffer = audioBuffer;
        sourceNode.connect(audioContext.destination);

        // Set up playback tracking
        item.isPlaying = true;
        item.isPlayingEnhance = true;
        item.playbackProgress = 0;
        this.currentPlayingItem = item;
        this.currentAudioSource = sourceNode;

        const playbackStartTime = audioContext.currentTime;
        const playbackDuration = audioBuffer.duration;

        // Update progress during playback
        this.playbackInterval = setInterval(() => {
          const elapsed = audioContext.currentTime - playbackStartTime;
          const adjustedElapsed = elapsed + 0.04; // Compensate for lag
          const progress = Math.min(
            (adjustedElapsed / playbackDuration) * 100,
            100
          );

          if (progress >= 100 || !item.isPlaying) {
            item.isPlaying = false;
            item.isPlayingEnhance = false;
            item.playbackProgress = 0;
            if (this.playbackInterval) {
              clearInterval(this.playbackInterval);
              this.playbackInterval = null;
            }
            this.currentPlayingItem = null;
            this.currentAudioSource = null;
          } else {
            item.playbackProgress = progress;
          }
          this.$forceUpdate();
        }, 25);

        // Handle playback end
        sourceNode.onended = () => {
          item.isPlaying = false;
          item.isPlayingEnhance = false;
          item.playbackProgress = 0;
          if (this.playbackInterval) {
            clearInterval(this.playbackInterval);
            this.playbackInterval = null;
          }
          this.currentPlayingItem = null;
          this.currentAudioSource = null;
          this.$forceUpdate();
        };

        // Start playback
        sourceNode.start(0);

        this.lastEnhancedFile = audioFile;
        this.lastEnhancedAudio = audioBuffer;
        this.lastEnhancedContext = audioContext;
      } catch (error) {
        console.error("Error in playFileEnhance:", error);

        // Clean up on error
        item.isPlaying = false;
        item.playbackProgress = 0;
        this.currentPlayingItem = null;
        this.currentAudioSource = null;
        if (this.playbackInterval) {
          clearInterval(this.playbackInterval);
          this.playbackInterval = null;
        }
      }
    },

    moveWindow(item, index, direction) {
      const moveAmount = Math.floor(this.clipSeconds * 0.75); // 75% overlap
      const newOffset = (item.windowOffset || 0) + direction * moveAmount;

      if (
        newOffset >= 0 &&
        newOffset + this.clipSeconds <= item.audioDuration
      ) {
        item.windowOffset = newOffset;
        item.windowStart = newOffset;
        item.windowEnd = newOffset + this.clipSeconds;

        // Regenerate spectrogram for new window
        this.spectrogram(index, item.currentWav.filename, "Recent");
      }
    },

    jumpToDetection(item, index) {
      if (item.offset) {
        item.windowOffset = Math.max(
          0,
          item.offset - Math.floor(this.clipSeconds / 2)
        );
        item.windowStart = item.windowOffset;
        item.windowEnd = Math.min(
          item.audioDuration,
          item.windowOffset + this.clipSeconds
        );

        // Regenerate spectrogram for detection window
        this.spectrogram(index, item.currentWav.filename, "Recent");
      }
    },

    spectrogram(index, audioFile, pageType) {
      // console.log("Spectrogram", index, audioFile, pageType);

      this.initAudioContext();

      // First get the URL (either from Storage or API)
      let audioUrlPromise;
      if (audioFile[0] == "b") {
        // console.log(`Using getAudioUrl API for file: ${audioFile}`);
        audioUrlPromise = this.getAudioUrl(audioFile);
      } else {
        // console.log(`Using S3 Storage.get for file: ${audioFile}`);
        audioUrlPromise = Storage.get(audioFile);
      }

      audioUrlPromise
        .then(async (audioUrl) => {
          try {
            let audioBuffer;
            let audioContext;
            let detectedSampleRate;

            // Check cache first
            const cacheKey = audioFile;
            const cachedData = this.audioCache.get(cacheKey);

            if (cachedData && cachedData.audioBuffer) {
              audioBuffer = cachedData.audioBuffer;
              audioContext = cachedData.audioContext;
              detectedSampleRate = cachedData.sampleRate;
              // console.log("Using cached audio data");
            } else {
              // Fetch the audio file
              const response = await fetch(audioUrl);
              const arrayBuffer = await response.arrayBuffer();

              // console.log(`Fetched audio file: ${arrayBuffer.byteLength} bytes (${(arrayBuffer.byteLength / 1024 / 1024).toFixed(2)} MB)`);

              // Detect the native sample rate
              detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);

              if (!detectedSampleRate) {
                // Fallback: try to get sample rate by decoding
                detectedSampleRate = await this.getAudioSampleRate(
                  audioUrl,
                  arrayBuffer
                );
              }

              // Get or create matching audio context
              audioContext = await this.getMatchingAudioContext(
                detectedSampleRate || 44100
              );

              // Decode audio with the matching context
              audioBuffer = await this.decodeAudioData(
                audioContext,
                arrayBuffer.slice(0)
              );

              // console.log('After decoding:');
              // console.log('  Detected sample rate:', detectedSampleRate, 'Hz');
              // console.log('  AudioContext sample rate:', audioContext.sampleRate, 'Hz');
              // console.log('  AudioBuffer sample rate:', audioBuffer.sampleRate, 'Hz');
              // console.log('  AudioBuffer duration:', audioBuffer.duration, 's');
              // console.log('  AudioBuffer length (samples):', audioBuffer.length);
              // console.log('  Expected samples for', audioBuffer.duration, 's at', detectedSampleRate, 'Hz:', Math.floor(audioBuffer.duration * detectedSampleRate));
              // console.log('  Sample count mismatch:', audioBuffer.length !== Math.floor(audioBuffer.duration * detectedSampleRate));

              // Cache the decoded audio
              this.audioCache.set(cacheKey, {
                audioUrl: audioUrl,
                arrayBuffer: arrayBuffer,
                audioBuffer: audioBuffer,
                audioContext: audioContext,
                sampleRate: detectedSampleRate || audioBuffer.sampleRate,
              });
            }

            // Now process the audio buffer for spectrogram
            let origSignal = audioBuffer.getChannelData(0);
            let signal;
            const actualSampleRate = audioBuffer.sampleRate;

            // console.log(
            //   `Spectrogram audio buffer: detectedSampleRate=${detectedSampleRate}Hz, ` +
            //   `audioBuffer.sampleRate=${audioBuffer.sampleRate}Hz, ` +
            //   `audioBuffer.length=${audioBuffer.length} samples, ` +
            //   `audioBuffer.duration=${audioBuffer.duration.toFixed(2)}s`
            // );

            // Define the start and end times
            let startTime = 0;
            let endTime = Math.min(this.clipSeconds, audioBuffer.duration);

            if (audioBuffer.duration > 3) {
              let offset = null;
                    const hit = (pageType === "Recent" && this.hits[index]) ? this.hits[index] : null;

              // Priority 1: stored offset from extractOffsetFromWav (uses createdAt)
              if (
                hit && hit.currentWav &&
                hit.currentWav.offset !== null &&
                hit.currentWav.offset !== undefined &&
                typeof hit.currentWav.offset === 'number'
              ) {
                offset = hit.currentWav.offset;
                    }

              // Priority 2: Vorbis TIMESTAMP from cached raw bytes
              if (offset === null && hit && hit.dt) {
                const cached = this.audioCache.get(audioFile);
                if (cached && cached.arrayBuffer) {
                  const vorbisTs = this.parseVorbisTimestamp(cached.arrayBuffer);
                  if (vorbisTs) {
                    const detectionUnix = Math.floor(Date.parse(hit.dt) / 1000);
                    const vorbisOffset = detectionUnix - vorbisTs;
                    if (vorbisOffset >= 0 && vorbisOffset <= audioBuffer.duration) {
                      offset = vorbisOffset;
                              }
                  }
                }
              }

              // Priority 3: filename_unix − duration
              if (offset === null && hit && hit.dt) {
                const filename = audioFile.split("/").pop();
                const match = filename.match(/_(\d+)\.flac$/);
                if (match) {
                  const fileEndTimestamp = parseInt(match[1]);
                  const fileStartTimestamp = fileEndTimestamp - audioBuffer.duration;
                  const detectionUnix = Math.floor(Date.parse(hit.dt) / 1000);
                  const filenameOffset = detectionUnix - fileStartTimestamp;
                  if (filenameOffset >= 0 && filenameOffset <= audioBuffer.duration) {
                    offset = filenameOffset;
                        }
                }
              }


              if (offset !== null) {
                startTime = offset - this.clipSeconds / 2;
              }

              // Ensure startTime is within bounds
              if (startTime < 0) startTime = 0;
              if (startTime > audioBuffer.duration - this.clipSeconds) {
                startTime = audioBuffer.duration - this.clipSeconds;
              }
              if (startTime < 0) startTime = 0; // Double check if duration < clipSeconds

              endTime = startTime + this.clipSeconds;
            }

            // Convert time to sample indices
            var startSample = Math.floor(startTime * actualSampleRate);
            var endSample = Math.floor(endTime * actualSampleRate);

            // console.log(
            //   `Before bounds check: startSample=${startSample}, endSample=${endSample}, ` +
            //   `audioBuffer.length=${audioBuffer.length}`
            // );

            // Ensure we don't go beyond the audio buffer
            if (endSample > audioBuffer.length) {
              // console.log(
              //   `WARNING: endSample (${endSample}) > audioBuffer.length (${audioBuffer.length}). ` +
              //   `Clipping to buffer length! This means the audio was decoded at wrong sample rate.`
              // );
              endSample = audioBuffer.length;
              startSample = Math.max(
                0,
                endSample - Math.floor(this.clipSeconds * actualSampleRate)
              );
            }

            // Extract the signal window
            signal = origSignal.slice(startSample, endSample);

            // console.log(
            //   `Spectrogram signal: startTime=${startTime.toFixed(2)}s, endTime=${endTime.toFixed(2)}s, ` +
            //   `duration=${(endTime - startTime).toFixed(2)}s, signal.length=${signal.length} samples, ` +
            //   `expected=${Math.floor(this.clipSeconds * actualSampleRate)} samples`
            // );

            // Dynamic FFT length based on sample rate
            const fftLength = this.getOptimalFFTLength(actualSampleRate);
            const halfLength = fftLength / 2;
            // console.log('fft', fftLength, halfLength);

            // Control frequency cutoff - 41.67% to show 10kHz for 24kHz files, 80kHz for 192kHz
            const frequencyRatio = 0.4166666666667;
            const targetMaxFreq = Math.min(96000, actualSampleRate * frequencyRatio);
            const nyquistFreq = actualSampleRate / 2;
            const binFrequency = nyquistFreq / halfLength; // Hz per bin
            const targetBins = Math.min(
              Math.floor(targetMaxFreq / binFrequency),
              halfLength
            );
            let showLength = targetBins;

            // Adjust for specific audio files if needed
            let zmidVal = -60;
            if (audioBuffer.duration <= 3) {
              zmidVal = -66;
            }

            const overlap = 0.5;
            const hopSize = Math.floor(fftLength * (1.0 - overlap));
            const numTimeSteps =
              Math.floor((signal.length - fftLength) / hopSize) + 1;
            const fft = new FFT(fftLength, actualSampleRate);

            // Generate Hann window
            const hannWindow = this.generateHannWindow(fftLength);

            // Build mic correction table for bat files (192kHz+)
            // Stores dB values to subtract per frequency bin
            const isBatSpectrogram = actualSampleRate >= 176400;

            // Generate spectrogram - store as 2D array
            const spectrogramData = [];

            // Initialize the 2D array
            for (let i = 0; i < showLength; i++) {
              spectrogramData[i] = [];
            }

            // Process each time window
            for (let timeStep = 0; timeStep < numTimeSteps; timeStep++) {
              const startIdx = timeStep * hopSize;
              const chunk = signal.slice(startIdx, startIdx + fftLength);

              // Pad with zeros if needed
              while (chunk.length < fftLength) {
                chunk.push(0);
              }

              // Apply Hann window
              for (let i = 0; i < fftLength; i++) {
                chunk[i] = chunk[i] * hannWindow[i];
              }

              // Perform FFT
              fft.forward(chunk);

              const scaleFactor = fftLength / 2;

              // Convert to dB and store
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                const value = fft.spectrum[freqBin] * scaleFactor;
                const db = 20 * Math.log10(Math.max(value, 1e-10));
                spectrogramData[freqBin][timeStep] = db;
              }
            }

            // Collect pre-subtraction values for color scaling
            const preSubValues = [];
            for (let freqBin = 0; freqBin < showLength; freqBin++) {
              for (let t = 0; t < numTimeSteps; t++) {
                preSubValues.push(spectrogramData[freqBin][t]);
              }
            }

            // Empirical spectral subtraction for bat files:
            // 1. Compute energy per time step
            // 2. Use only quiet frames (below median energy) to estimate noise/mic profile
            // 3. Subtract 0.9 of that profile from all frames
            if (isBatSpectrogram && this.micCorrectionEnabled) {
              // Compute total energy per time step
              const energyPerStep = new Float32Array(numTimeSteps);
              for (let t = 0; t < numTimeSteps; t++) {
                let sum = 0;
                for (let freqBin = 0; freqBin < showLength; freqBin++) {
                  sum += spectrogramData[freqBin][t];
                }
                energyPerStep[t] = sum;
              }

              // Find median energy to threshold quiet vs loud frames
              const sortedEnergy = Array.from(energyPerStep).sort((a, b) => a - b);
              const medianEnergy = sortedEnergy[Math.floor(sortedEnergy.length / 2)];

              // Average only quiet frames per frequency bin
              const noiseProfile = new Float32Array(showLength);
              let quietCount = 0;
              for (let t = 0; t < numTimeSteps; t++) {
                if (energyPerStep[t] <= medianEnergy) {
                  quietCount++;
                  for (let freqBin = 0; freqBin < showLength; freqBin++) {
                    noiseProfile[freqBin] += spectrogramData[freqBin][t];
                  }
                }
              }
              if (quietCount > 0) {
                for (let freqBin = 0; freqBin < showLength; freqBin++) {
                  noiseProfile[freqBin] /= quietCount;
                }
              }

              // Compute mean before subtraction
              let totalSum = 0;
              const totalCount = showLength * numTimeSteps;
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                for (let t = 0; t < numTimeSteps; t++) {
                  totalSum += spectrogramData[freqBin][t];
                }
              }
              const meanBefore = totalSum / totalCount;

              // Subtract 0.9 of noise profile from all frames, floor at 0
              let afterSum = 0;
              for (let t = 0; t < numTimeSteps; t++) {
                for (let freqBin = 0; freqBin < showLength; freqBin++) {
                  spectrogramData[freqBin][t] = Math.max(0, spectrogramData[freqBin][t] - 0.9 * noiseProfile[freqBin]);
                  afterSum += spectrogramData[freqBin][t];
                }
              }
              const meanAfter = afterSum / totalCount;

              // Shift to preserve original mean
              const meanShift = meanBefore - meanAfter;
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                for (let t = 0; t < numTimeSteps; t++) {
                  spectrogramData[freqBin][t] += meanShift;
                }
              }
            }

            // Use pre-subtraction values for color scaling to preserve dynamic range
            const colorSource = (isBatSpectrogram && this.micCorrectionEnabled && preSubValues.length > 0)
              ? preSubValues : [];
            if (colorSource.length === 0) {
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                for (let t = 0; t < numTimeSteps; t++) {
                  colorSource.push(spectrogramData[freqBin][t]);
                }
              }
            }

            // Calculate percentiles for color scaling
            colorSource.sort((a, b) => a - b);
            const percentile = (p) => {
              const index = Math.floor((colorSource.length * p) / 100);
              return colorSource[Math.min(index, colorSource.length - 1)];
            };

            const minVal = percentile(30);
            const maxVal = percentile(99);
            const dynamicRange = maxVal - minVal;

            // Clamp values
            for (let i = 0; i < showLength; i++) {
              for (let j = 0; j < numTimeSteps; j++) {
                spectrogramData[i][j] = Math.max(
                  minVal,
                  Math.min(maxVal, spectrogramData[i][j])
                );
              }
            }

            // Gaussian smoothing
            for (let i = 1; i < showLength - 1; i++) {
              for (let j = 1; j < numTimeSteps - 1; j++) {
                const smoothed =
                  spectrogramData[i][j] * 0.4 +
                  (spectrogramData[i - 1][j] +
                    spectrogramData[i + 1][j] +
                    spectrogramData[i][j - 1] +
                    spectrogramData[i][j + 1]) *
                    0.15;
                spectrogramData[i][j] = smoothed;
              }
            }

            // Improved colorscale
            const colorscale = [
              [0, "#440154"], // Dark purple
              [0.3, "#3b528b"], // Dark blue
              [0.7, "#21908c"], // Teal
              [0.8, "#5dc863"], // Green
              [0.9, "#fde725"], // Yellow
              [1, "#ffffff"], // White for peaks
            ];

            // After building spectrogramData, calculate frequency values
            const freqValues = [];
            for (let i = 0; i < showLength; i++) {
              freqValues.push(i * binFrequency);
            }

            // Calculate time values for x-axis
            const timeValues = [];
            const timePerStep = (hopSize / actualSampleRate);
            for (let i = 0; i < numTimeSteps; i++) {
              timeValues.push(startTime + (i * timePerStep));
            }

            // Calculate max frequency for display (rounded to nearest integer kHz)
            const maxFreqKHz = Math.round(freqValues[freqValues.length - 1] / 1000);

            // Store window information for display (needs to be after maxFreqKHz is calculated)
            if (pageType === "Recent" && this.hits[index]) {
              this.hits[index].windowStart = startTime;
              this.hits[index].windowEnd = endTime;
              this.hits[index].windowOffset = startTime;
              this.hits[index].audioDuration = audioBuffer.duration;
              this.hits[index].maxFreqKHz = maxFreqKHz;

              // Update maxClipSeconds based on actual file durations
              // Check if any loaded file has duration > 3s
              const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
              if (hasLongFile && this.maxClipSeconds <= 3) {
                this.maxClipSeconds = 12;
                // console.log('Detected loaded file > 3s, setting maxClipSeconds to 12');
              }

              // Log for debugging
              // console.log(`Spectrogram window: ${startTime.toFixed(1)}s - ${endTime.toFixed(1)}s (${this.clipSeconds}s window) from ${audioBuffer.duration.toFixed(1)}s file`);
            }

            const spectrogramPlotData = [
              {
                z: spectrogramData,
                x: timeValues,
                type: "heatmap",
                colorscale: colorscale,
                showscale: false,
                zmin: minVal,
                zmax: maxVal,
                zmid: minVal + dynamicRange * 0.9,
                zsmooth: "best",
                connectgaps: false,
                y: freqValues,
                hovertemplate: `Time: %{x:.2f}s<br>Freq: %{y:.0f}Hz<br><extra></extra>`,
              },
            ];

            // Update the spectrogram data based on pageType
            if (pageType === "Recent") {
              this.hits[index].spectrogram = spectrogramPlotData;
              this.hits[index].loadingSpectrogram = false;
              this.setWindowRecent(
                index,
                "spectrogram",
                this.hits[index].spCode,
                this.hits[index].cn
              );
            }
            if (pageType === "All") {
              this.seriesDaily[index].spectrogram = spectrogramPlotData;
              this.setWindowAll(
                index,
                "spectrogram",
                this.seriesDaily[index].spCode,
                this.seriesDaily[index].cn
              );
            }
            if (pageType === "New") {
              this.newSpeciesList[index].spectrogram = spectrogramPlotData;
              this.setWindowNew(
                index,
                "spectrogram",
                this.newSpeciesList[index].spCode,
                this.newSpeciesList[index].cn
              );
            }
            if (pageType === "Missing") {
              this.missingSpeciesList[index].spectrogram = spectrogramPlotData;
              this.setWindowMissing(
                index,
                "spectrogram",
                this.missingSpeciesList[index].spCode,
                this.missingSpeciesList[index].cn
              );
            }
          } catch (err) {
            console.log(err);
            console.log("No audio", audioFile);
            this.snackbar = true;

            // Clear loading state on error
            if (pageType === "Recent" && this.hits[index]) {
              this.hits[index].loadingSpectrogram = false;
            }

            return false;
          }
        })
        .catch((err) => {
          console.log("Error getting audio URL:", err);

          // Clear loading state on error
          if (pageType === "Recent" && this.hits[index]) {
            this.hits[index].loadingSpectrogram = false;
          }
        });
    },

    wiFiText() {
      if (this.currentWiFi <= -75) return "WiFi Weak";
      if (this.currentWiFi <= -60) return "WiFi Good";
      if (this.currentWiFi == 0) return "No data";
      return "WiFi Strong";
    },
    getImageUrl(spCode) {
      var imageUrl =
        "https://haikubox-images.s3.amazonaws.com/" + spCode + ".jpeg?v=5";
      // console.log(imageUrl);
      return imageUrl;
    },
    updateCurrentHaikuboxRadius() {
      // console.log('current zoom', this.currentZoom);
      this.currentHaikuboxRadius = 20000 / this.currentZoom;
      // var radiusIncrement = 40000;
      // var markerThreshold = 400000;
      if (this.currentZoom <= 4) {
        this.currentHaikuboxRadius = 40000;
      }
      if (this.currentZoom == 5) {
        this.currentHaikuboxRadius = 20000;
      }
      // if (this.currentZoom == 6) {
      //   markerThreshold = 80000;
      //   radiusIncrement = 8000;
      // }
      // if (this.currentZoom == 7) {
      //   markerThreshold = 40000;
      //   radiusIncrement = 4000;
      // }
      // if (this.currentZoom == 8) {
      //   markerThreshold = 30000;
      //   radiusIncrement = 3000;
      // }
      // if (this.currentZoom == 9) {
      //   markerThreshold = 20000;
      //   radiusIncrement = 2000;
      // }
      // if (this.currentZoom == 10) {
      //   markerThreshold = 10000;
      //   radiusIncrement = 1000;
      // }
      // if (this.currentZoom == 11) {
      //   markerThreshold = 3000;
      //   radiusIncrement = 300;
      // }
      // if (this.currentZoom == 12) {
      //   markerThreshold = 1000;
      //   radiusIncrement = 100;
      // }
      // if (this.currentZoom >= 13) {
      //   markerThreshold = 500;
      //   radiusIncrement = 50;
      // }
      // this.currentHaikuboxRadius += radiusIncrement;
      // if (this.currentHaikuboxRadius > markerThreshold)
      //   this.currentHaikuboxRadius = 0;
      // // console.log("updateCurrentHaikuboxRadius", this.currentZoom);
      // this.haikuboxMarkerID += 1; // force redraw
      // console.log(this.currentZoom);
      // if (this.showMap) setTimeout(this.updateCurrentHaikuboxRadius, 200);
    },
    // async loadSummary(serial) {
    //   var tempSummary = [];
    //   // var colorMap = ['#ffffcc','#c7e9b4','#7fcdbb','#41b6c4','#2c7fb8','#253494'];

    //   // load past day first so fast to load, then load beyond that
    //   var startDate = moment.utc().subtract(24, "hours").format();
    //   const queryHitSummary = await API.graphql({
    //     query: hitSummaryBySerialByDate,
    //     variables: {
    //       serial: serial,
    //       dt: { ge: startDate },
    //     },
    //   });
    //   tempSummary = tempSummary.concat(
    //     queryHitSummary.data.hitSummaryBySerialByDate.items
    //   );
    //   // console.log("1 day tempSummary", tempSummary);

    //   // parse by species and total
    //   // goal is list of objects
    //   // [ { Bluejay: [0,0,12,12,43,54,]},
    //   //   {American Goldfinch: [ 0, 0, 123,34,324,]}]

    //   var species15MinuteCounts = {};
    //   // empty list
    //   let n = 24 * 4; // every 15 minutes for 24 hours
    //   let a = new Array(n);
    //   for (let i = 0; i < n; ++i) a[i] = 0;
    //   species15MinuteCounts["dt"] = a;

    //   async function createEmptyLists() {
    //     // set up keys with empty lists
    //     for (let item in tempSummary) {
    //       let speciesCount = JSON.parse(tempSummary[item].name);
    //       // console.log('speciesCount', speciesCount);
    //       for (var key in speciesCount) {
    //         species15MinuteCounts[key] = a.slice();
    //       }
    //     }
    //   }

    //   async function fillList() {
    //     var tempArray;
    //     for (let item in tempSummary) {
    //       tempArray = species15MinuteCounts["dt"].slice();
    //       tempArray[item] = tempSummary[item].dt;
    //       species15MinuteCounts["dt"] = tempArray.slice();
    //       let speciesCount = JSON.parse(tempSummary[item].name);
    //       for (var key in speciesCount) {
    //         // console.log("item key count", item, key, speciesCount[key]);
    //         tempArray = species15MinuteCounts[key].slice();
    //         tempArray[item] = speciesCount[key];
    //         species15MinuteCounts[key] = tempArray.slice();
    //       }
    //     }
    //   }
    //   await createEmptyLists();
    //   await fillList();

    //   // console.log("species15MinuteCounts", species15MinuteCounts);

    //   var species1HourCounts = {};

    //   for (var key in species15MinuteCounts) {
    //     // console.log(key, species15MinuteCounts[key]);
    //     var tempArray4 = [];
    //     var tempArray = species15MinuteCounts[key].slice();
    //     for (let i = 0; i < n; i += 4) {
    //       if (key == "dt") {
    //         tempArray4.push(tempArray[i]);
    //       } else {
    //         tempArray4.push(
    //           tempArray[i] +
    //             tempArray[i + 1] +
    //             tempArray[i + 2] +
    //             tempArray[i + 3]
    //         );
    //       }
    //     }
    //     species1HourCounts[key] = tempArray4.slice();
    //   }
    //   // console.log("species1HourCounts", species1HourCounts);
    //   this.species1HourCounts = species1HourCounts;

    //   var nextToken = null;
    //   startDate = moment.utc().subtract(60, "days").format();
    //   tempSummary = [];
    //   do {
    //     const queryHitSummary = await API.graphql({
    //       query: hitSummaryBySerialByDate,
    //       variables: {
    //         serial: serial,
    //         dt: { gt: startDate },
    //         nextToken: nextToken,
    //       },
    //     });
    //     tempSummary = tempSummary.concat(
    //       queryHitSummary.data.hitSummaryBySerialByDate.items
    //     );
    //     nextToken = queryHitSummary.data.hitSummaryBySerialByDate.nextToken;
    //   } while (nextToken != null);

    //   // console.log("tempSummary", tempSummary);
    //   var fifteenMinuteCountPlot = [];
    //   for (let item in tempSummary) {
    //     let dateText = moment(tempSummary[item].createdAt)
    //       .local()
    //       .format("YYYY-MM-DD HH:mm");
    //     fifteenMinuteCountPlot.push([dateText, tempSummary[item].count]);
    //   }
    //   // console.log("fifteenMinuteCount", fifteenMinuteCountPlot);
    //   this.fifteenMinuteCountPlot = fifteenMinuteCountPlot;

    //   const fusionDataStore = new FusionCharts.DataStore();
    //   // After that we are creating a DataTable by passing our data and schema as arguments
    //   const fusionTable = fusionDataStore.createDataTable(
    //     fifteenMinuteCountPlot,
    //     this.fusionSchema
    //   );
    //   // After that we simply mutated our timeseries datasource by attaching the above
    //   // DataTable into its data property.
    //   this.dataSource.data = fusionTable;
    // },
    filterHourlySummary(showHour) {
      // if (this.animationRunning==false) this.sliderSummaryHourIndex();
      const filteredSummary = this.hourlySummary.filter(function (el) {
        // if (el.hour == showHour) console.log('el', el);
        return el.hour == showHour;
      });
      // console.log('filterHourlySummary', showHour, filteredSummary);
      this.summaryHourLabel = filteredSummary[0].datetime;
      return filteredSummary;
    },
    incrementHour() {
      var tempSummaryHour = this.summaryHour + 1;
      if (tempSummaryHour == 24) tempSummaryHour = 0;
      this.summaryHour = tempSummaryHour;
    },
    toggleBasemap() {
      if (
        this.urlSummary ==
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}"
      )
        this.urlSummary =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}";
      else
        this.urlSummary =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}";
    },
    toggleColormap() {
      let tempIndex = this.summaryColorMapIndex + 1;
      if (this.summaryColorMapIndex == 5) tempIndex = 0;
      this.summaryColorMapIndex = tempIndex;
    },
    startAnimation() {
      if (this.animationRunning) return;
      this.animationInterval = setInterval(this.incrementHour, 500);
      this.animationRunning = true;
    },
    stopAnimation() {
      if (this.animationRunning) {
        clearInterval(this.animationInterval);
        this.animationRunning = false;
      }
    },
    sliderSummaryHourIndex() {
      // map slider values from 0 to 23, so that 23 is latest time and 0 is earliest
      var currentHour = moment.utc().hours() - 1;
      if (currentHour < 0) currentHour = 23;
      var maxSliderCorrection = 23 - currentHour;
      var tempSummaryHour = this.summaryHourIndex - maxSliderCorrection;
      if (tempSummaryHour < 0) tempSummaryHour = tempSummaryHour + 24;
      this.summaryHour = tempSummaryHour;
    },
    labelText(spCode, commonName) {
      let cn = this.t(spCode, commonName);
      // console.log(spCode, cn);
      return this.t("Is") + " " + cn + " " + this.t("Correct") + "?";
    },
    subscribe(serialClicked) {
      if (subscription) {
        // console.log("unsubscribing");
        subscription.unsubscribe();
      }
      // console.log("subscribe");
      subscription = API.graphql({
        query: onCreateHit,
        variables: { serial: serialClicked },
      }).subscribe({
        next: (eventData) => {
          // console.log(eventData);
          let liveHit = eventData.value.data.onCreateHit;
          if (liveHit.specSum <= this.specSumThreshold) return;
          if (liveHit.score <= this.confidenceThreshold) return;
          if (this.hiddenList.includes(liveHit.cn)) return;
          if (liveHit.cn === "soundscape") return;
          if (this.liveHits.some((item) => item.id === liveHit.id)) return; // remove duplications
          this.liveHits = [liveHit, ...this.liveHits];
          this.liveHits = this.liveHits.slice(0, 20); // limit to 20 hits
          this.lastUpdated = moment
            .utc()
            .local()
            .locale(this.selectedLanguage)
            .calendar();
        },
      });
    },
    async logClick(clickTarget, spCode, cn) {
      const userID = this.user;
      const serial = this.currentSerial;
      const pageClickedFrom = this.currentView;

      // createdAt
      const clickData = {
        userID,
        serial,
        spCode,
        cn,
        clickTarget,
        pageClickedFrom,
      };

      await API.graphql({
        query: createClickTable,
        variables: { input: clickData },
      });
    },

    async shareLink(spCode, commonName, audioFile) {
      this.logClick("shareLink", "", commonName);

      // Handle Backblaze files - need to copy to S3 first
      if (audioFile.startsWith("bb/")) {
        console.log("Processing Backblaze file for sharing...");

        // Copy the file from Backblaze to S3 public bucket
        const audioUrl = await this.getAudioUrl(audioFile);
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: "audio/flac" });

        // Extract filename and add spCode prefix
        const pathParts = audioFile.split("/");
        const filename = pathParts.pop(); // Get just the filename
        const newFilename = spCode + "_" + filename; // Add spCode prefix

        // Rebuild path with new filename
        pathParts.push(newFilename);
        const s3AudioFile = pathParts.slice(1).join("/"); // Remove 'bb/' and rebuild

        await Storage.put(s3AudioFile, blob, {
          level: "public",
          contentType: "audio/flac",
        });

        console.log(
          "Backblaze file copied to S3 with spCode prefix:",
          s3AudioFile
        );

        // Update audioFile to use S3 path with new filename
        audioFile = s3AudioFile;
      }

      var audioFileParts = audioFile.split("/").pop();
      // console.log('shareLink', audioFileParts);
      this.audioLink =
        "https://haikubox.social/" + audioFileParts.slice(0, -4) + "html";

      // this is link for downloading file that is created in haikubox.social
      this.downloadLink =
        "https://haikubox.social/public/tweet/" +
        this.audioLink.slice(24, -4) +
        "flac";

      // Only create the TXT file in tweet/ folder - Lambda will handle the rest
      var dest = "tweet/" + audioFile.slice(0, -5) + ".txt";
      // html web page gets generated when new audio file saved in s3 haikubox.social
      this.shareCommonName = commonName;
      this.shareAudioFile = audioFile;
      await Storage.put(dest, commonName);
    },

    async copyLink() {
      this.logClick("copyLink");
      this.copyLinkSnackbar = true;
      await navigator.clipboard.writeText(this.audioLink);
    },
    async toggleShowBird(cn, spCode, showBird) {
      let id = this.currentSerial + "_" + spCode;
      this.logClick("hideBird" + "_" + showBird, spCode, cn);
      let serial = this.currentSerial;
      const hideBirdData = {
        id,
        spCode,
        cn,
        serial,
      };
      // console.log('toggleShowBird', hideBirdData);
      if (showBird == true) {
        await API.graphql({
          query: deleteHideBird,
          variables: { input: { id: id } },
        });
      }
      if (showBird == false) {
        await API.graphql({
          query: createHideBird,
          variables: { input: hideBirdData },
        });
      }
    },
    async toggleNewBirdAlert(newBirdAlert) {
      // update device table
      var id = this.currentSerial.split("_");
      this.logClick("toggleNewBirdAlert" + "_" + newBirdAlert, null, null);
      // console.log('toggleNewBirdAlert', this.currentSerial);
      await API.graphql({
        query: updateDevice,
        variables: { input: { id: id[1], newBirdAlert: newBirdAlert } },
      });
      if (newBirdAlert == true) {
        // console.log("notify check notifications on", deviceInfo);
        if (this.osConsentGranted === false) {
          this.notifyBirdInfo = true;
          // notifyBirdInfoSnackShown will show for each notify clicked if on Pause
          // this.notifyBirdInfoSnackShown = true;
        }
      }
    },
    async toggleNotifyBird(cn, spCode, notifyBird) {
      let id = this.currentSerial + "_" + spCode;
      this.logClick("notifyBird" + "_" + notifyBird, spCode, cn);
      let serial = this.currentSerial;
      const notifyBirdData = {
        id,
        spCode,
        cn,
        serial,
      };
      // console.log("toggleNotifyBird", notifyBirdData);
      if (notifyBird == false) {
        await API.graphql({
          query: deleteNotifyBird,
          variables: { input: { id: id } },
        });
      }
      if (notifyBird == true) {
        await API.graphql({
          query: createNotifyBird,
          variables: { input: notifyBirdData },
        });

        if (this.osConsentGranted === false) {
          this.notifyBirdInfo = true;
          // notifyBirdInfoSnackShown will show for each notify clicked if on Pause
          // this.notifyBirdInfoSnackShown = true;
        }
      }
      // console.log('notifySnackShown', this.notifyBirdInfoSnackShown);
    },
    async toggleHaikuboxBookmark() {
      if (this.currentSerial === "") return;
      this.currentHaikuboxBookmark = !this.currentHaikuboxBookmark;
      // create or delete bookmark from bookmarkHaikubox
      let id = this.currentSerial + "_" + this.user;
      this.logClick(
        "toggleHaikuboxBookmark" + "_" + this.currentSerial,
        null,
        null
      );
      let serial = this.currentSerial;
      let owner = this.user;
      const bookmarkHaikuboxData = {
        id,
        serial,
        owner,
      };
      // console.log("toggleHaikuboxBookmark", bookmarkHaikuboxData);
      // console.log('toggleNotifyBird', id);
      if (this.currentHaikuboxBookmark == false) {
        await API.graphql({
          query: deleteBookmarkHaikubox,
          variables: { input: { id: id } },
        });
      }

      if (this.currentHaikuboxBookmark == true) {
        await API.graphql({
          query: createBookmarkHaikubox,
          variables: { input: bookmarkHaikuboxData },
        });
      }
      // update list
      this.loadBookmarkedHaikuboxes();
      // this.bookmarkHaikuboxKey += 1;
    },
    async downloadCSV() {
      if (this.downloadRaw) {
        this.logClick("downloadRaw", "", "");
        // if only pick one day add one to start for end
        if (this.csvDates.length == 1) {
          // Single day picked — end day is included in full below
          this.csvDates[1] = this.csvDates[0];
        }

        // Range picker stores dates in click order — sort so start <= end
        this.csvDates.sort();

        // Cap the range at the same window the date picker allows
        var b = moment(this.csvDates[0]);
        var a = moment(this.csvDates[1]);
        let diffDays = a.diff(b, "days");
        let maxDays = moment().diff(moment(this.csvMinDate), "days");
        if (diffDays > maxDays) return;
      }

      this.csvDialog = false;

      if (this.downloadSummary) {
        this.logClick("downloadSummary", "", "");
        // Empty array for storing the values
        let csvRows = "Species,Count\n";
        // const values = Object.values(this.seriesDaily).join(',');
        // csvRows.push(values);
        for (let i in this.seriesDaily) {
          // Fall back to cn: bat records may not have a spCode
          csvRows +=
            this.t(this.seriesDaily[i].spCode, this.seriesDaily[i].cn) +
            "," +
            this.seriesDaily[i].countsTotal +
            "\n";
        }

        // Creating a Blob for having a csv file format
        // and passing the data with type
        const blob = new Blob([csvRows], { type: "text/csv" });

        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);

        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute("download", this.currentSiteName + ".csv");

        // Performing a download with click
        a.click();
      }

      if (this.downloadRaw) {
        // Empty array for storing the values
        let csvRows =
          "Species,Scientific Name,UTC Date,Local Date,Local Time,Score,Count,Group\n";

        // Convert picked dates (device-local days) to a UTC range that covers
        // the end day in full. A bare-date upper bound cut off everything on
        // the last day: after ~8pm local, detections land on the next UTC day,
        // which silently dropped nocturnal (bat) detections in particular.
        const csvStartUtc = moment
          .tz(this.csvDates[0], this.currentTimezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        const csvEndUtc = moment
          .tz(this.csvDates[1], this.currentTimezone)
          .add(1, "d")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");

        // Big Query of Hit Table
        var nextToken = null;
        // console.log("Yesterday", yesterdayDate)
        var tempHits = [];
        // console.log("csv range", this.csvDates);
        var queryCounter = 0;
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: this.currentSerial,
              dt: { between: [csvStartUtc, csvEndUtc] },
              sortDirection: "DESC",
              // Birds keep the specSum noise gate; everything else (bats etc.)
              // is included unconditionally — non-bird hits may not populate
              // specSum, and their group value varies, so match by exclusion
              filter: {
                or: [
                  { and: [{ group: { eq: "bird" } }, { specSum: { gt: 1 } }] },
                  { group: { ne: "bird" } },
                ],
              },
              nextToken: nextToken,
            },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.csvLoading = queryCounter;
          queryCounter++;
          if (queryCounter > 1000) break;
        } while (nextToken != null);
        this.csvLoading = 0;

        // console.log('csv export tempHits', tempHits);
        for (let i in tempHits) {
          let localTimeStr = moment
            .utc(tempHits[i].dt)
            .tz(this.currentTimezone)
            .format("HH:mm:ss");
          let localDateStr = moment
            .utc(tempHits[i].dt)
            .tz(this.currentTimezone)
            .format("DD-MMM-YYYY");
          csvRows +=
            // Fall back to cn: bat hits may not have a spCode
            this.t(tempHits[i].spCode, tempHits[i].cn) +
            "," +
            tempHits[i].sn +
            "," +
            tempHits[i].dt +
            "," +
            localDateStr +
            "," +
            localTimeStr +
            "," +
            tempHits[i].score +
            "," +
            tempHits[i].detectionCount +
            "," +
            tempHits[i].group +
            "\n";
        }

        // Creating a Blob for having a csv file format
        // and passing the data with type
        const blob = new Blob([csvRows], { type: "text/csv" });

        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);

        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute("download", this.currentSiteName + "_raw.csv");

        // Performing a download with click
        a.click();
      }

      if (this.downloadDailyCounts) {
        this.logClick("downloadDailyCounts", "", "");
        let csvRows = "Date,Species,Species Code,Count\n";

        var nextToken = null;
        var dailyCounts = [];
        var queryCounter = 0;
        do {
          const result = await API.graphql({
            query: dailyCountSummaryBySerialByDate,
            variables: {
              serial: this.currentSerial,
              countDate: { ge: "2022-01-01" },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
          });
          dailyCounts = dailyCounts.concat(
            result.data.dailyCountSummaryBySerialByDate.items
          );
          nextToken = result.data.dailyCountSummaryBySerialByDate.nextToken;
          this.csvLoading = queryCounter;
          queryCounter++;
          if (queryCounter > 1000) break;
        } while (nextToken != null);
        this.csvLoading = 0;

        for (let i in dailyCounts) {
          csvRows +=
            dailyCounts[i].countDate +
            "," +
            this.t(dailyCounts[i].spCode, dailyCounts[i].cn) +
            "," +
            dailyCounts[i].spCode +
            "," +
            dailyCounts[i].countsPerDay +
            "\n";
        }

        const blob = new Blob([csvRows], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", this.currentSiteName + "_daily_counts.csv");
        a.click();
      }
    },
    selectSpecies(species) {
      // console.log('selectSpecies', species);
      // janky way to make sure scrolling goes to right location
      if (this.scrolledToBottom == false) {
        window.scrollTo(0, document.documentElement.scrollHeight, "instant"); // scroll to bottom first
        this.scrolledToBottom = true;
      }
      var targetElement = document.getElementById(species);
      var targetScrollPosition = targetElement.offsetTop + 80;
      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth", // You can use 'auto' for instant scrolling
      });
    },
    async favoriteHit(item) {
      // console.log("favoriteHit", item);
      item.favoriteHit = !item.favoriteHit;
      item.id = item.id + 1;

      try {
        const favoriteReturn = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: item.currentWav["filename"],
          },
        });

        const id = item.currentWav["filename"];
        if (favoriteReturn.data.getFavoriteHit != null) {
          // Delete existing favorite
          await API.graphql({
            query: deleteFavoriteHit,
            variables: { input: { id: id } },
          });
        } else {
          // Create new favorite with windowed audio
          const audioFile = item.wav;

          // Get audio URL
          let audioUrl;
          if (audioFile[0] === "b") {
            audioUrl = await this.getAudioUrl(audioFile);
          } else {
            audioUrl = await Storage.get(audioFile);
          }

          // Download and decode the audio
          const response = await fetch(audioUrl);
          const arrayBuffer = await response.arrayBuffer();

          const detectedSampleRate = await this.detectFlacSampleRate(
            arrayBuffer
          );
          // console.log('Original file sample rate:', detectedSampleRate);

          // Get or create matching audio context to preserve sample rate
          const audioContext = await this.getMatchingAudioContext(
            detectedSampleRate || 44100
          );

          // Decode with the matching context instead of globalAudioContext
          const audioBuffer = await this.decodeAudioData(
            audioContext,
            arrayBuffer.slice(0)
          );
          // console.log('Decoded at sample rate:', audioBuffer.sampleRate);

          let signal = audioBuffer.getChannelData(0);

          // Apply windowing for long files
          if (audioBuffer.duration > 3) {
            let startTime = 0;

            // Check if we have an offset from currentWav
            if (
              item.currentWav &&
              item.currentWav.offset !== null &&
              item.currentWav.offset !== undefined
            ) {
              startTime =
                item.currentWav.offset - this.clipSeconds / 2;
            } else {
              // Try to calculate offset from filename and dt
              const filename = audioFile.split("/").pop();
              const match = filename.match(/_(\d+)\.flac$/);

              if (match && item.dt) {
                const fileEndTimestamp = parseInt(match[1]);
                const fileStartTimestamp =
                  fileEndTimestamp - audioBuffer.duration;
                const detectionUnixTime = Math.floor(
                  Date.parse(item.dt) / 1000
                );
                const offset = detectionUnixTime - fileStartTimestamp;

                if (offset >= 0 && offset <= audioBuffer.duration) {
                  startTime = offset - this.clipSeconds / 2;
                }
              }
            }

            // Ensure startTime is within bounds
            if (startTime < 0) startTime = 0;
            if (startTime + this.clipSeconds > audioBuffer.duration) {
              startTime = audioBuffer.duration - this.clipSeconds;
            }
            if (startTime < 0) startTime = 0;

            // Extract the window
            const startSample = Math.floor(startTime * audioBuffer.sampleRate);
            const endSample = Math.floor(
              (startTime + this.clipSeconds) * audioBuffer.sampleRate
            );

            if (endSample <= audioBuffer.length) {
              signal = signal.slice(startSample, endSample);
            }
          }

          // Convert to WAV format
          const numChannels = 1;
          const bitsPerSample = 16;
          const byteRate =
            (audioBuffer.sampleRate * numChannels * bitsPerSample) / 8;
          const blockAlign = (numChannels * bitsPerSample) / 8;
          const dataSize = (signal.length * bitsPerSample) / 8;
          const fileLength = 44 + dataSize;

          // Create WAV buffer
          const buffer = new ArrayBuffer(fileLength);
          const view = new DataView(buffer);

          // Helper function to write string
          function writeString(view, offset, string) {
            for (let i = 0; i < string.length; i++) {
              view.setUint8(offset + i, string.charCodeAt(i));
            }
          }

          // Write WAV header
          writeString(view, 0, "RIFF");
          view.setUint32(4, fileLength - 8, true);
          writeString(view, 8, "WAVE");
          writeString(view, 12, "fmt ");
          view.setUint32(16, 16, true);
          view.setUint16(20, 1, true);
          view.setUint16(22, numChannels, true);
          view.setUint32(24, audioBuffer.sampleRate, true);
          view.setUint32(28, byteRate, true);
          view.setUint16(32, blockAlign, true);
          view.setUint16(34, bitsPerSample, true);
          writeString(view, 36, "data");
          view.setUint32(40, dataSize, true);

          for (let i = 0; i < signal.length; i++) {
            // Just clamp to valid range to be safe, but don't normalize
            const clampedSample = Math.max(-1, Math.min(1, signal[i]));
            view.setInt16(44 + i * 2, clampedSample * 32767, true);
          }

          // Convert to Blob
          const blob = new Blob([buffer], { type: "audio/wav" });

          // Change extension from .flac to .wav for the saved file
          const wavFilename = audioFile.replace(".flac", ".wav");

          // Upload windowed WAV to S3 private storage
          await Storage.put(wavFilename, blob, {
            level: "private",
            contentType: "audio/wav",
          });

          // console.log(`Saved ${this.clipSeconds}s clip as favorite`);

          // Create favorite record in database with WAV filename
          const favoriteData = {
            id: wavFilename, // Use WAV filename as ID
            serial: item.serial,
            owner: this.user,
            dt: item.currentWav["dt"],
            animalGroup: item.group,
            cn: item.cn,
            sn: item.sn,
            spCode: item.spCode,
            wav: wavFilename, // Store WAV filename
            score: item.currentWav["score"],
            specSum: item.currentWav["specSum"],
          };

          await API.graphql({
            query: createFavoriteHit,
            variables: { input: favoriteData },
          });
        }
      } catch (err) {
        console.error("favoriteHit failed", err);
        // Revert the UI state if the operation failed
        item.favoriteHit = !item.favoriteHit;
        item.id = item.id + 1;
      }
    },

    async openPhotoUploadDialog(species) {
      this.uploadingSpecies = species;
      this.photoUploadDialog = true;
      this.selectedPhotoFile = null;
      this.photoPreviewUrl = null;
      this.photoUploadError = null;
      this.photoUploadSuccess = false;
    },

    closePhotoUploadDialog() {
      this.photoUploadDialog = false;
      this.selectedPhotoFile = null;
      this.photoPreviewUrl = null;
      this.photoUploadError = null;
      this.photoUploadSuccess = false;
      this.processingPhoto = false;
      this.uploadingPhoto = false;

      if (this.photoUploadSuccess) {
        this.$forceUpdate();
      }
    },

    async handlePhotoSelect(file) {
      if (!file || !file.type.startsWith("image/")) {
        this.photoUploadError = "Please select a valid image file";
        return;
      }

      this.processingPhoto = true;
      this.photoUploadError = null;

      try {
        const resizedImage = await this.resizeImage(file, 320, 240);
        this.photoPreviewUrl = resizedImage;
        this.processingPhoto = false;
      } catch (error) {
        this.photoUploadError = "Failed to process image";
        this.processingPhoto = false;
      }
    },

    resizeImage(file, targetWidth, targetHeight) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();

          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = targetWidth;
            canvas.height = targetHeight;

            const aspectRatio = img.width / img.height;
            const targetRatio = targetWidth / targetHeight;

            let sourceX = 0;
            let sourceY = 0;
            let sourceWidth = img.width;
            let sourceHeight = img.height;

            if (aspectRatio > targetRatio) {
              sourceWidth = img.height * targetRatio;
              sourceX = (img.width - sourceWidth) / 2;
            } else if (aspectRatio < targetRatio) {
              sourceHeight = img.width / targetRatio;
              sourceY = (img.height - sourceHeight) / 2;
            }

            ctx.drawImage(
              img,
              sourceX,
              sourceY,
              sourceWidth,
              sourceHeight,
              0,
              0,
              targetWidth,
              targetHeight
            );

            canvas.toBlob(
              (blob) => {
                if (blob) {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                } else {
                  reject(new Error("Canvas toBlob failed"));
                }
              },
              "image/jpeg",
              0.9
            );
          };

          img.onerror = () => reject(new Error("Failed to load image"));
          img.src = e.target.result;
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async uploadPhoto() {
      if (!this.photoPreviewUrl) return;

      this.uploadingPhoto = true;
      this.photoUploadError = null;
      this.photoUploadSuccess = false;

      try {
        const base64Data = this.photoPreviewUrl.split(",")[1];

        const result = await API.graphql({
          query: uploadBirdPhoto,
          variables: {
            serial: this.currentSerial,
            spCode: this.uploadingSpecies.spCode,
            imageBase64: base64Data,
          },
        });

        const response = JSON.parse(result.data.uploadBirdPhoto);

        if (!response.success) {
          throw new Error(response.error);
        }

        this.photoUploadSuccess = true;
        this.imageVersion = Date.now(); // update when images change

        setTimeout(() => {
          this.photoPreviewUrl = null;
          this.selectedPhotoFile = null;
        }, 1500);
      } catch (error) {
        console.error("Upload error:", error);

        const errorMessage =
          error?.message || error?.errors?.[0]?.message || "Upload failed";

        if (errorMessage && errorMessage.includes("inappropriate content")) {
          this.photoUploadError =
            "This image cannot be uploaded due to content policy violations.";
        } else {
          this.photoUploadError = `Upload failed: ${errorMessage}`;
        }
      } finally {
        this.uploadingPhoto = false;
      }
    },

    async deleteCustomPhoto() {
      this.deletingPhoto = true;
      this.photoUploadError = null;

      try {
        const result = await API.graphql({
          query: deleteBirdPhoto,
          variables: {
            serial: this.currentSerial,
            spCode: this.uploadingSpecies.spCode,
          },
        });

        const response = JSON.parse(result.data.deleteBirdPhoto);

        if (!response.success) {
          throw new Error(response.error);
        }

        this.photoUploadSuccess = true;
        this.imageVersion = Date.now();
      } catch (error) {
        this.photoUploadError = `Delete failed: ${error.message}`;
      } finally {
        this.deletingPhoto = false;
      }
    },

    moveUp() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import url("https://fonts.googleapis.com/css?family=Quicksand");
#haikubox {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
header {
  font-family: Quicksand;
}
main {
  min-height: 100%;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}
.v-menu__content {
  max-height: 600px !important;
}

/* Spectrogram progress bar */
.spectrogram-container {
  position: relative;
  width: 100%;
}

.spectrogram-progress-bar {
  height: 4px;
  background-color: #ffeb3b;
  box-shadow: 0 2px 8px rgba(255, 235, 59, 0.8);
  transition: width 0.05s linear;
  margin: 4px 0;
}

/* Loading overlay for spectrogram updates */
.spectrogram-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

/* Playing indicator animation */
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.playing-indicator {
  animation: pulse 1.5s infinite;
}
</style>
